/* eslint-disable vue/no-side-effects-in-computed-properties */
<template>
    <div class="app has-header">
        <div class="header main">
            
            <div class="align-left">
                <dateselectionheader v-if="!hourMode"
                        :label="dateSelectionStart.format('MMMM') + ' ' + dateSelectionStart.format('YYYY')"
                        @PrevDate="setDateSelection(dateSelectionStart.add(-1, 'month'), true)"
                        @NextDate="setDateSelection(dateSelectionStart.add(1, 'month'), true)"
                        @CalendarOpen="OpenDateSelection"
                        @SetToday="setDateSelection($helpers.getCurrentMonthMomentTZ(), true)"/>
                
                <div class="header date month" v-if="hourMode">
                    <div class="fas fa-angle-left" v-on:click="hourMode = false, currentHourStatistics = []"></div>
                    <div class="label bold">{{hourDate.format('dd').toUpperCase() + ', '}}</div>
                    <div class="label">{{hourDate.format('DD') + '.' + hourDate.format('MM') + '.'}}</div>
                    <div class="label">{{hourDate.format('YYYY')}}</div>
                    <!--<div class="fas fa-calendar" v-on:click="OpenDateSelection($event)"></div>-->
                </div>
                
            </div>
            <div class="align-middle">
               <headerbuttonstack :state="headerButtons"/>
            </div>
            <div class="align-right">
                <headerbuttonstack :state="sideButtons"/> 
            </div>
        </div>
        <div class ="tablecontainer scrollbar-container">
            
             <div v-if="mainType">
                 
                 <datatable :state="dataTableState"/>
             </div>
             
             <h3 v-else style="color: red;">{{ $t('roster.error.defaultKeyFigureMissing') }}</h3>
        </div>  
      
      
        <div v-if="loading" class="loading-md bg">
            <i class="fas fa-spinner"></i>
            <div v-if="!$helpers.isEmpty(loadingText)" class="loading-text">
                {{ loadingText }}
            </div>
        </div>


    </div>

</template>

<script>
import datatable from '../uicomponents/datatable.vue';
import Papa from 'papaparse';
import { mapState, mapGetters } from 'vuex';
export default {
  name: 'statisticsoverview',
    components: {
        datatable,
    },
    data () {
        return {
            filterDropdownOptions: [],
            dayStatistics: [],
            hourStatistics: [],
            hourMode: false,
            hourDate: null,
            dateSelectionStart: this.$helpers.getCurrentMonthMomentTZ(),
            mainTypeId:null,
            error: false,
            loading: true,
            loadingText: null,
            showPlanned: false,
            crewLaborDetail: false,
            unproductiveDetail: false,
            planCrewLaborDetail: false,
            
            defaultCrewLaborConfig: {
                holidayWorkValue: true,
                workValue: false,
                openWorkValue: true,
                nightWorkShiftFlatValue: true,
                nightWorkValue: true,
                overtimeShiftFlatValue: true,
                overtimeValue: true,
                vacationWorkValue: true,
                sickWorkValue: true,
                holidayAdjustWorkValue: false,
                miscWorkValue: true,
                nursingVacationWorkValue: true,
                eduWorkValue: true,
                wageContinuationWorkValue: true,
            },

            minuteOffset: 0,

            daysShort: {
                'Mo': this.$t('store.openingHours.weekDay1Short'),
                'Di': this.$t('store.openingHours.weekDay2Short'),
                'Mi': this.$t('store.openingHours.weekDay3Short'),
                'Do': this.$t('store.openingHours.weekDay4Short'),
                'Fr': this.$t('store.openingHours.weekDay5Short'),
                'Sa': this.$t('store.openingHours.weekDay6Short'),
                'So': this.$t('store.openingHours.weekDay7Short'),
            },
        }
    },
    mounted() {
        if(this.rosterFromTo != null){
            this.dateSelectionStart = this.$helpers.getMomentFromValuesTZ(this.rosterFromTo.year,this.rosterFromTo.month, 1);
        }
    },
    created: function () {
        if(this.$store.state.jwt != undefined && this.$store.state.storeId != undefined){
            this.refresh();
        }
    },
    computed: {
        ...mapGetters(['storeId', 'anonMode', 'crewLaborConfig', 'planningIndicatorTypeMap', 'planningEmployeeThresholdMap', 'spotMap', 'storeSettings', 'employeeMap']),
        currentMonthFrom(){
          let rFrom = new Date(this.rosterFromTo.from);
          let rTo = new Date(this.rosterFromTo.to);
          let diffTime = Math.abs(rTo - rFrom);
          let diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
          let diffDaysHalf = Math.abs(diffDays / 2);
          rFrom.setDate(rFrom.getDate() + diffDaysHalf);
          let from = this.$helpers.getMomentFromValuesUTC(rFrom.getFullYear(), rFrom.getMonth(), 1);
          return from;
        },
        headerButtons(){

            let view = this;

            let state= {
                buttons: []
            };
            //BUTTON 1
            state.buttons.push({
                type: "block",
                icon: "fa-sync-alt",
                click: () => {
                    view.refreshStatistics(); 
                },
                tooltip: this.$t('global.general.refreshData')
            });
            state.buttons.push({
                type: view.showPlanned ? "block green" : "block orange",
                icon: "fa-clone",
                click: () => {
                    view.showPlanned = !view.showPlanned
                },
                tooltip: view.showPlanned ? this.$t('indicator.main.showsTargetData')  : this.$t('indicator.main.showsActualData'),
                helperText: this.$t('indicator.eval.showPlannedHelp'),
                externalUrl: "https://meindienstplan.atlassian.net/servicedesk/customer/portal/1/topic/4f6eac84-477d-4789-9e9c-7ff50794cb2f/article/2301853697"
            }); 
            
            state.buttons.push({
                type: "block cyan",
                icon: "fa-edit",
                click: () => {
                    view.OpenEditCrewLaborConfigMenu();
                },
                tooltip: this.$t('indicator.eval.setClCalculation') ,
                helperText: this.$t('indicator.eval.setClCalculationHelp'),
                externalUrl: "https://meindienstplan.atlassian.net/servicedesk/customer/portal/1/topic/4f6eac84-477d-4789-9e9c-7ff50794cb2f/article/2301853697"
            
            });
            state.buttons.push({type: "block border-r", icon: "far fa-chart-area",click: ($event) => {view.OpenChartPopup($event)},tooltip: this.$t('indicator.eval.graphicView')});

            state.helperLinks = [
                    {
                        title:  this.$t('store.structure.getSupport'),
                        helperText:  this.$t('store.structure.getSupportHelp'),
                        externalUrl: "https://meindienstplan.atlassian.net/servicedesk/customer/portal/1/group/2/create/13",
                        externalLabel:  this.$t('store.structure.getSupportLabel'),
                        cancelLabel: this.$t('global.ui.close')
                    }
                ];
            return state;
        },
        sideButtons() {
            let view = this;

            let state= {
                buttons: [
                    {
                        type: "block border-r",
                        icon: "fa-filter",
                        click: ($event) => {
                        view.OpenFilterDropdown($event);
                        },
                        tooltip: this.$t('global.ui.viewFilter')
                    },
                    {
                        type: "block border-r",
                        icon: "fa-eye",
                        tooltip: this.$t('global.ui.viewOptions'),
                        click: ($event) => {view.OpenMenuDetails($event, this.displayMenuState);},

                    },
                    {
                        type: "block border-r",
                        icon: "fa-print",
                        tooltip: this.$t('global.ui.reportsExports'),
                        click: ($event) => { view.OpenMenuDetails($event, this.reportMenuState); }
                    }
                    
                ]
            };
           
                
            return state; 
        },
        displayMenuState(){
            let view = this;
            let state = {
                componentref: 'burgermenustate',
                groups: [],
                items: []
            };

            let group0 = {
                label: this.$t('global.ui.viewOptions'),
                items: [
                    {
                        closeOnClick: true,
                        icon: "fa-clock",
                        text: this.$t('indicator.main.setHourOffset'),
                        disabled: false,
                        show: true,
                        click: () => { view.OpenMinuteOffsetPopup()}
                    },
                     
                    
                ]
            };

            state.groups.push(group0);
            //state.groups.push(spotGroup);

            return state;
        },
        reportMenuState(){
          let view = this;
          let state = {
            componentref: 'burgermenustate',
            groups: [],
            items: []
          };

          let exportGroup = {
            label: this.$t('global.ui.csvExport'),
            items: [
              {
                closeOnClick: true,
                classes: "export-csv",
                type: "block cyan",
                disabled: false,
                icon: "fa-file-csv",
                click: () => { view.exportCSV(); },
                show:  true,
                tooltip: this.$t('global.ui.exportCsv'),
                text: this.$t('global.ui.exportCsv'),
                helperText: this.$t('indicator.eval.exportCsv')
              }
            ]
          }

          state.groups.push(exportGroup);

          let reportGroup = {
            label: this.$t('roster.view.report'),
            items: [
                
              {
                closeOnClick: true,
                classes: "export-save",
                type: "block green",
                disabled: false,
                icon: "fa-file-pdf",
                click: () => { view.OpenCrewLaborReportPopup(); },
                show:  true,
                text: this.$t('indicator.eval.crewLaborReport'),
                helperText: this.$t('indicator.eval.crewLaborReportHelp')
              },
              {
                closeOnClick: true,
                classes: "export-save",
                type: "block green",
                disabled: false,
                icon: "fa-file-pdf",
                click: () => { view.PdfDailyReportPopup(); },
                show:  true,
                text: this.$t('indicator.eval.dayEval'),
                helperText: this.$t('indicator.eval.dayEvalHelp')
              },
              {
                closeOnClick: true,
                classes: "export-save",
                type: "block green",
                disabled: false,
                icon: "fa-file-pdf",
                click: () => { view.PdfHourlyReportPopup(); },
                show:  true,
                text: this.$t('indicator.eval.hourEval'),
                helperText: this.$t('indicator.eval.hourEvalHelp')
              },
              {
                closeOnClick: true,
                classes: "export-save",
                type: "block green",
                disabled: false,
                icon: "fa-file-pdf",
                click: () => { view.PdfWeekReportPopup(); },
                show:  true,
                text: this.$t('indicator.eval.weekEval'),
                helperText: this.$t('indicator.eval.weekEvalHelp')
              },
              {
                closeOnClick: true,
                classes: "export-save",
                type: "block green",
                disabled: false,
                icon: "fa-file-pdf",
                click: () => { view.PdfYearReportPopup(); },
                show:  true,
                text: this.$t('indicator.eval.yearEval'),
                helperText: this.$t('indicator.eval.yearEvalHelp')
              },
              {
                closeOnClick: true,
                classes: "export-save",
                type: "block green",
                disabled: false,
                icon: "fa-file-pdf",
                click: () => { view.PdfDailyReportPerEmployeePopup(); },
                show:  true,
                text: this.$t('indicator.eval.dayEvalEmployee'),
                helperText: this.$t('indicator.eval.dayEvalEmployeeHelp')
              },
              {
                closeOnClick: true,
                classes: "export-save",
                type: "block green",
                disabled: false,
                icon: "fa-file-pdf",
                click: () => { view.PdfHourlyReportPerEmployeePopup(); },
                show:  true,
                text: this.$t('indicator.eval.hourEvalEmployee'),
                helperText: this.$t('indicator.eval.hourEvalEmployeeHelp')
              },
              {
                closeOnClick: true,
                classes: "export-save",
                type: "block green",
                disabled: false,
                icon: "fa-file-pdf",
                click: () => { view.PdfWeekReportPerEmployeePopup(); },
                show:  true,
                text: this.$t('indicator.eval.weekEvalEmployee'),
                helperText: this.$t('indicator.eval.weekEvalEmployeeHelp')
              },
              {
                closeOnClick: true,
                classes: "export-save",
                type: "block green",
                disabled: false,
                icon: "fa-file-pdf",
                click: () => { view.PdfYearReportPerEmployeePopup(); },
                show:  true,
                text: this.$t('indicator.eval.yearEvalEmployee'),
                helperText: this.$t('indicator.eval.yearEvalEmployeeHelp')
              },

            ]
          }

          state.groups.push(reportGroup);

          return state;
        },
        monthDisplay: function() {
            if(this.dateSelectionStart != null){
                return this.dateSelectionStart.format('MMM YYYY');
            } else {
                return '-';
            }
                    
        },
        rosterFromTo() {
            if(this.$store.state.loggedIn){
                return this.$store.state.rosterFromTo;
            } else {
                return null;
            }    
        },
        mainType(){
            const config = this.crewLaborConfig;
            
            
            if(config == null || config.incomeIndicatorId == null){
                let def = Object.values(this.planningIndicatorTypeMap).filter(i => i.isDefault == true);
                if(def.length > 0){
                    return def[0]
                } else {
                    return null;
                }
            } else {
                return this.planningIndicatorTypeMap[config.incomeIndicatorId];
            }
            
        },
        statisticsDayMap(){
            let map = {};
            let view = this;
            Object.values(this.dayStatistics).forEach(i => {
                let from = view.$helpers.getMomentFromStringTZ(i.from);
                let key = from.year()+"-"+from.month()+"-"+from.date();
                if(!map[key]){
                    let entry = {};
                    for(let x in i){
                        entry[x] = i[x];
                    }
                    entry.hourData = [];
                    entry.hourData.push(i);
                    map[key] = entry;

                } else {
                    let entry = map[key];
                    let eFrom = view.$helpers.getMomentFromStringTZ(entry.from);
                    if(from < eFrom){
                        entry.from = i.from;
                    }
                    for(let x in i){
                        if(x != 'from'){
                            entry[x] = entry[x]+i[x];
                        } 
                    }
                    entry.hourData.push(i);
                }
            })
            
            return map;
        },
        statisticsHourMap(){
            let map = {};
            let view = this;
            Object.values(this.hourStatistics).forEach(i => {
                let from = view.$helpers.getMomentFromStringTZ(i.from);
                let key = from.format();
                if(!map[key]){
                    let entry = {};
                    for(let x in i){
                        entry[x] = i[x];
                    }
                    entry.hourData = [];
                    entry.hourData.push(i);
                    map[key] = entry;

                } else {
                    let entry = map[key];
                    let eFrom = view.$helpers.getMomentFromStringTZ(entry.from);
                    if(from < eFrom){
                        entry.from = i.from;
                    }
                    for(let x in i){
                        if(x != 'from'){
                            entry[x] = entry[x]+i[x];
                        } 
                    }
                    entry.hourData.push(i);
                }
            })
           
            return map;
        },
        
        dataTableState(){
            let view = this;
            
            let state = {
                headerMap: {},
                data: []
            };
            
            const mainType = this.mainType;
            const config = this.crewLaborConfig ? this.crewLaborConfig : this.defaultCrewLaborConfig;

            state.data = this.hourMode ? Object.values(this.statisticsHourMap) : Object.values(this.statisticsDayMap);
            
            state.headerMap['from'] = {};
            state.headerMap['from'].sort = false;
            state.headerMap['from'].key = 'from';
            state.headerMap['from'].label = this.$t('store.settings.date');
            state.headerMap['from'].align = 'sides';
            state.headerMap['from'].DisplayLabel = (i) => {
                let fromTz = view.$helpers.getMomentFromStringTZ(i.from);
                return this.hourMode ? view.$helpers.getMomentFromStringTZ(i.from).format("HH:mm") : fromTz.format("DD.MM. ") + this.translateDayShort(fromTz.format("dd")) };
                
            if(!this.crewLaborDetail && !this.unproductiveDetail && !this.planCrewLaborDetail){
                if(this.showPlanned){
                    state.headerMap['plannedIndicatorValue'] = {};
                    state.headerMap['plannedIndicatorValue'].sort = false
                    state.headerMap['plannedIndicatorValue'].key = 'plannedIndicatorValue';
                    state.headerMap['plannedIndicatorValue'].label = mainType ? mainType.name : this.$t('roster.view.keyFigure');
                    state.headerMap['plannedIndicatorValue'].DisplayLabel = (i) => { return view.anonMode ? '-' : i.plannedIndicatorValue.toFixed(2)};

                    state.headerMap['plannedWorkTimeSum'] = {};
                    state.headerMap['plannedWorkTimeSum'].sort = false;
                    state.headerMap['plannedWorkTimeSum'].label = this.$t('indicator.eval.productiveWorkTimeShort');
                    state.headerMap['plannedWorkTimeSum'].key = 'plannedWorkTimeSum';
                    state.headerMap['plannedWorkTimeSum'].tooltip = this.$t('workBalance.payroll.productiveWorkTime') + this.$t('indicator.vlh.targetBubbleCaps');
                    state.headerMap['plannedWorkTimeSum'].DisplayLabel = (i) => { return (view.$helpers.calculateCLWorkTimeSum(i, config, view.showPlanned)/3600).toFixed(2)};
                    state.headerMap['plannedWorkTimeSum'].labelicon = this.crewLaborDetail ? 'fas fa-eye-slash' : 'fas fa-eye';
                    state.headerMap['plannedWorkTimeSum'].action = ()=> {
                                                        this.crewLaborDetail = !this.crewLaborDetail;
                                                        this.unproductiveDetail = false;
                                                        this.planCrewLaborDetail = false;
                                                    }
                    state.headerMap['plannedWorkValueSum'] = {};
                    state.headerMap['plannedWorkValueSum'].sort = false;
                    state.headerMap['plannedWorkValueSum'].key = 'plannedWorkValueSum';
                    state.headerMap['plannedWorkValueSum'].label = this.$t('indicator.eval.productiveWorkTimeCostsShort');
                    state.headerMap['plannedWorkValueSum'].tooltip = this.$t('workBalance.payroll.productiveWorkTime') + this.$t('indicator.eval.costSumBubble');
                    state.headerMap['plannedWorkValueSum'].bgcolor = "#FFFF99";
                    state.headerMap['plannedWorkValueSum'].DisplayLabel = (i) => { return (view.$helpers.calculateCLWorkValueSum(i, config, view.showPlanned)/100).toFixed(2)};  
                } else {
                    state.headerMap['actualIndicatorValue'] = {};
                    state.headerMap['actualIndicatorValue'].sort = false
                    state.headerMap['actualIndicatorValue'].key = 'actualIndicatorValue';
                    state.headerMap['actualIndicatorValue'].label = mainType ? mainType.name : this.$t('roster.view.keyFigure');
                    state.headerMap['actualIndicatorValue'].DisplayLabel = (i) => { return view.anonMode ? '-' : i.actualIndicatorValue.toFixed(2)};

                    state.headerMap['actualWorkTimeSum'] = {};
                    state.headerMap['actualWorkTimeSum'].sort = false;
                    state.headerMap['actualWorkTimeSum'].key = 'actualWorkTimeSum';
                    state.headerMap['actualWorkTimeSum'].label = this.$t('indicator.eval.productiveWorkTimeShort');
                    state.headerMap['actualWorkTimeSum'].tooltip = this.$t('workBalance.payroll.productiveWorkTime') + this.$t('roster.comp.actualBubble');
                    state.headerMap['actualWorkTimeSum'].DisplayLabel = (i) => { return (view.$helpers.calculateCLWorkTimeSum(i, config, view.showPlanned)/3600).toFixed(2)};
                    state.headerMap['actualWorkTimeSum'].labelicon = this.crewLaborDetail ? 'fas fa-eye-slash' : 'fas fa-eye';
                    state.headerMap['actualWorkTimeSum'].action = ()=> {
                                                        this.crewLaborDetail = !this.crewLaborDetail;
                                                        this.unproductiveDetail = false;
                                                        this.planCrewLaborDetail = false;
                                                    }
                    state.headerMap['actualWorkValueSum'] = {};
                    state.headerMap['actualWorkValueSum'].sort = false;
                    state.headerMap['actualWorkValueSum'].key = 'actualWorkValueSum';
                    state.headerMap['actualWorkValueSum'].label = this.$t('indicator.eval.productiveWorkTimeCostsShort');
                    state.headerMap['actualWorkValueSum'].tooltip = this.$t('workBalance.payroll.productiveWorkTime') + this.$t('indicator.eval.costSumBubble');
                    state.headerMap['actualWorkValueSum'].bgcolor = "#FFFF99";
                    state.headerMap['actualWorkValueSum'].DisplayLabel = (i) => {return (view.$helpers.calculateCLWorkValueSum(i, config, view.showPlanned)/100).toFixed(2)};
                }
                
                state.headerMap['unproductiveWorkTime'] = {};
                state.headerMap['unproductiveWorkTime'].sort = false;
                state.headerMap['unproductiveWorkTime'].key = 'unproductiveWorkTime';
                state.headerMap['unproductiveWorkTime'].label = this.$t('indicator.eval.unproductiveWorkTimeShort');
                state.headerMap['unproductiveWorkTime'].tooltip = this.$t('workBalance.payroll.unproductiveWorkTime') + " " + this.$t('global.ui.sum');
                state.headerMap['unproductiveWorkTime'].DisplayLabel = (i) => {  return (view.$helpers.calculateCLUnproductiveWorkTimeSum(i, config, view.showPlanned)/3600).toFixed(2) };
                state.headerMap['unproductiveWorkTime'].labelicon = this.unproductiveDetail ? 'fas fa-eye-slash' : 'fas fa-eye';
                state.headerMap['unproductiveWorkTime'].action = ()=> {
                                                        this.crewLaborDetail = false;
                                                        this.unproductiveDetail = !this.unproductiveDetail;
                                                        this.planCrewLaborDetail = false;
                                                    }
                    
                state.headerMap['unproductiveWorkValue'] = {};
                state.headerMap['unproductiveWorkValue'].sort = false;
                state.headerMap['unproductiveWorkValue'].key = 'unproductiveWorkValue';
                state.headerMap['unproductiveWorkValue'].label = this.$t('indicator.eval.unproductiveWorkTimeCostShort');
                state.headerMap['unproductiveWorkValue'].tooltip = this.$t('workBalance.payroll.unproductiveWorkTime') + this.$t('indicator.eval.costSumBubble');
                state.headerMap['unproductiveWorkValue'].bgcolor = "#FFFF99";
                state.headerMap['unproductiveWorkValue'].DisplayLabel = (i) => { return (view.$helpers.calculateCLUnproductiveWorkValueSum(i, config, view.showPlanned)/100).toFixed(2) };

                

                state.headerMap['contractWorkTime'] = {};
                state.headerMap['contractWorkTime'].sort = false;
                state.headerMap['contractWorkTime'].label = this.$t('indicator.eval.contractWorkTimeShort');
                state.headerMap['contractWorkTime'].key = 'contractWorkTime';
                state.headerMap['contractWorkTime'].tooltip = this.$t('indicator.eval.contractedWorkTime');
                state.headerMap['contractWorkTime'].DisplayLabel = (i) => { return (Math.round(i.contractWorkTime)/3600).toFixed(2)};
                state.headerMap['contractWorkTime'].labelicon = this.planCrewLaborDetail ? 'fas fa-eye-slash' : 'fas fa-eye';
                state.headerMap['contractWorkTime'].action = ()=> {
                                                        this.crewLaborDetail = false;
                                                        this.unproductiveDetail = false;
                                                        this.planCrewLaborDetail = !this.planCrewLaborDetail;
                                                    }

                    
                state.headerMap['contractWorkValue'] = {};
                state.headerMap['contractWorkValue'].sort = false;
                state.headerMap['contractWorkValue'].key = 'contractWorkValue';
                state.headerMap['contractWorkValue'].label = this.$t('indicator.eval.contractedCrewLaborShort');
                state.headerMap['contractWorkValue'].tooltip = this.$t('indicator.eval.contractedCrewLabor');
                state.headerMap['contractWorkValue'].DisplayLabel = (i) => { return  ((Math.round(i.contractWorkValue))/100).toFixed(2)};
                
                

                state.headerMap['totalWorkValueSum'] = {};
                state.headerMap['totalWorkValueSum'].sort = false;
                state.headerMap['totalWorkValueSum'].key = 'totalWorkValueSum';
                state.headerMap['totalWorkValueSum'].label = this.$t('indicator.eval.crewLaborShort');
                state.headerMap['totalWorkValueSum'].tooltip = this.$t('indicator.crew.crewLabor');
                state.headerMap['totalWorkValueSum'].bgcolor = "#FFFF99";
                state.headerMap['totalWorkValueSum'].DisplayLabel = (i) => { return (view.$helpers.calculateCLCrewLaborSum(i, config, view.showPlanned)/100).toFixed(2)};

                state.headerMap['contractWorkValuePercentage'] = {};
                state.headerMap['contractWorkValuePercentage'].sort = false;
                state.headerMap['contractWorkValuePercentage'].key = 'contractWorkValuePercentage';
                state.headerMap['contractWorkValuePercentage'].label = this.$t('indicator.eval.contractedCrewLaborShort') + "%";
                state.headerMap['contractWorkValuePercentage'].tooltip = this.$t('indicator.eval.contractedCrewLaborPercentage');
                state.headerMap['contractWorkValuePercentage'].DisplayLabel = (i) => { 
                    if(view.showPlanned){
                        if(i.plannedIndicatorValue > 0 && !view.anonMode){
                            return ((i.contractWorkValue/100/i.plannedIndicatorValue)*100).toFixed(2)+' %';
                        } else {
                            return "-"
                        }
                    } else {
                        if(i.actualIndicatorValue > 0 && !view.anonMode){
                            return ((i.contractWorkValue/100/i.actualIndicatorValue)*100).toFixed(2)+' %';
                        } else {
                            return "-"
                        }
                    }   
                    
                };

                if(this.showPlanned){
                    state.headerMap['plannedWorkValuePercentage'] = {};
                    state.headerMap['plannedWorkValuePercentage'].sort = false;
                    state.headerMap['plannedWorkValuePercentage'].key = 'plannedWorkValuePercentage';
                    state.headerMap['plannedWorkValuePercentage'].label = this.$t('indicator.eval.crewLaborShort') + "%";
                    state.headerMap['plannedWorkValuePercentage'].tooltip = this.$t('indicator.eval.crewLaborPercentage');
                    state.headerMap['plannedWorkValuePercentage'].DisplayLabel = (i) => { 
                        if(i.plannedIndicatorValue > 0 && !view.anonMode){
                            return ((view.$helpers.calculateCLCrewLaborSum(i, config, view.showPlanned)/100/i.plannedIndicatorValue)*100).toFixed(2)+' %';
                        } else {
                            return '-';
                        }
                        
                    };

                } else {
                    state.headerMap['actualWorkValuePercentage'] = {};
                    state.headerMap['actualWorkValuePercentage'].sort = false;
                    state.headerMap['actualWorkValuePercentage'].key = 'actualWorkValuePercentage';
                    state.headerMap['actualWorkValuePercentage'].label = this.$t('indicator.eval.crewLaborShort') + "%";
                    state.headerMap['actualWorkValuePercentage'].tooltip = this.$t('indicator.eval.crewLaborPercentage');
                    state.headerMap['actualWorkValuePercentage'].DisplayLabel = (i) => { 
                        if(i.actualIndicatorValue > 0 && !view.anonMode){
                            return ((view.$helpers.calculateCLCrewLaborSum(i, config, view.showPlanned)/100/i.actualIndicatorValue)*100).toFixed(2)+' %';
                        } else {
                            return '-';
                        }
                        
                    };

                    
                }

                state.headerMap['productivity'] = {};
                state.headerMap['productivity'].sort = false;
                state.headerMap['productivity'].key = 'productivity';
                state.headerMap['productivity'].label = view.showPlanned ? this.$t('roster.view.productivity') + this.$t('indicator.vlh.targetBubbleCaps') : this.$t('roster.view.productivity') + this.$t('roster.comp.actualBubble');
                state.headerMap['productivity'].DisplayLabel = (i) => { 
                    let p = view.$helpers.calculateCLWorkTimeSum(i, config, view.showPlanned)
                    if(view.showPlanned){
                        
                        if(p > 0){
                            return (i.plannedIndicatorValue/(p/3600)).toFixed(2);
                        } else {
                            return "-"
                        }
                    } else {
                        if(p > 0){
                            return (i.actualIndicatorValue/(p/3600)).toFixed(2);
                        } else {
                            return "-"
                        }
                    }   
                };
                
                
            }

            if(this.crewLaborDetail && !this.unproductiveDetail && !this.planCrewLaborDetail){
                if(this.showPlanned){
                    if(!config.openWorkValue) {
                        state.headerMap['productivePlannedWorkTime'] = {};
                        state.headerMap['productivePlannedWorkTime'].sort = false;
                        state.headerMap['productivePlannedWorkTime'].label = this.$t('indicator.eval.productiveWorkTimeShort');
                        state.headerMap['productivePlannedWorkTime'].key = 'productivePlannedWorkTime';
                        state.headerMap['productivePlannedWorkTime'].tooltip = this.$t('workBalance.payroll.productiveWorkTime') + this.$t('indicator.vlh.targetBubbleCaps');
                        state.headerMap['productivePlannedWorkTime'].DisplayLabel = (i) => { return (i.productivePlannedWorkTime/3600).toFixed(2)};
                        state.headerMap['productivePlannedWorkTime'].labelicon = this.crewLaborDetail ? 'fas fa-eye-slash' : 'fas fa-eye';
                        state.headerMap['productivePlannedWorkTime'].action = ()=> {
                                                            this.crewLaborDetail = !this.crewLaborDetail;
                                                            this.unproductiveDetail = false;
                                                            this.planCrewLaborDetail = false;
                                                        } 

                        state.headerMap['productivePlannedWorkValue'] = {};
                        state.headerMap['productivePlannedWorkValue'].sort = false;
                        state.headerMap['productivePlannedWorkValue'].key = 'productivePlannedWorkValue';
                        state.headerMap['productivePlannedWorkValue'].label = this.$t('indicator.eval.productiveWorkTimeCostsShort');
                        state.headerMap['productivePlannedWorkValue'].tooltip = this.$t('workBalance.payroll.productiveWorkTime') + " " + this.$t('workBalance.extraPay.costs');
                        state.headerMap['productivePlannedWorkValue'].bgcolor = config.workValue ? "#FFFF99" : null;
                        state.headerMap['productivePlannedWorkValue'].DisplayLabel = (i) => { return (i.productivePlannedWorkValue/100).toFixed(2)};
                    } else {
                        state.headerMap['productivePlannedOpenWorkTime'] = {};
                        state.headerMap['productivePlannedOpenWorkTime'].sort = false;
                        state.headerMap['productivePlannedOpenWorkTime'].label = this.$t('indicator.eval.openProductiveWorkTimeShort');
                        state.headerMap['productivePlannedOpenWorkTime'].key = 'productivePlannedOpenWorkTime';
                        state.headerMap['productivePlannedOpenWorkTime'].tooltip = this.$t('indicator.eval.openProductiveWorkTime') + this.$t('indicator.vlh.targetBubbleCaps');
                        state.headerMap['productivePlannedOpenWorkTime'].DisplayLabel = (i) => { return (i.productivePlannedOpenWorkTime/3600).toFixed(2)};
                        state.headerMap['productivePlannedOpenWorkTime'].labelicon = this.crewLaborDetail ? 'fas fa-eye-slash' : 'fas fa-eye'; 
                        state.headerMap['productivePlannedOpenWorkTime'].action = ()=> {
                                                            this.crewLaborDetail = !this.crewLaborDetail;
                                                            this.unproductiveDetail = false;
                                                            this.planCrewLaborDetail = false;
                                                        }

                        state.headerMap['productivePlannedOpenWorkValue'] = {};
                        state.headerMap['productivePlannedOpenWorkValue'].sort = false;
                        state.headerMap['productivePlannedOpenWorkValue'].key = 'productivePlannedOpenWorkValue';
                        state.headerMap['productivePlannedOpenWorkValue'].label = this.$t('indicator.eval.openProductiveWorkTimeCostShort');
                        state.headerMap['productivePlannedOpenWorkValue'].tooltip = this.$t('indicator.eval.openProductiveWorkTimeCost');
                        state.headerMap['productivePlannedOpenWorkValue'].bgcolor = config.openWorkValue ? "#FFFF99" : null;
                        state.headerMap['productivePlannedOpenWorkValue'].DisplayLabel = (i) => { return (i.productivePlannedOpenWorkValue/100).toFixed(2)};
                    }
                    
                    
                    state.headerMap['plannedNightWorkShiftCount'] = {};
                    state.headerMap['plannedNightWorkShiftCount'].sort = false;
                    state.headerMap['plannedNightWorkShiftCount'].label = this.$t('workBalance.payroll.nightWorkShiftsShort');
                    state.headerMap['plannedNightWorkShiftCount'].key = 'plannedNightWorkShiftCount';
                    state.headerMap['plannedNightWorkShiftCount'].tooltip = this.$t('indicator.eval.nightWorkShiftsAmount') + this.$t('indicator.vlh.targetBubbleCaps');
                    state.headerMap['plannedNightWorkShiftCount'].DisplayLabel = (i) => { return (i.plannedNightWorkShiftCount).toFixed(2)}; 

                    state.headerMap['plannedNightWorkShiftFlatValue'] = {};
                    state.headerMap['plannedNightWorkShiftFlatValue'].sort = false;
                    state.headerMap['plannedNightWorkShiftFlatValue'].key = 'plannedNightWorkShiftFlatValue';
                    state.headerMap['plannedNightWorkShiftFlatValue'].label = this.$t('indicator.eval.nightWorkFixedCostsShort');
                    state.headerMap['plannedNightWorkShiftFlatValue'].tooltip = this.$t('indicator.eval.nightWorkFixedCosts');
                    state.headerMap['plannedNightWorkShiftFlatValue'].bgcolor = config.nightWorkShiftFlatValue ? "#FFFF99" : null;
                    state.headerMap['plannedNightWorkShiftFlatValue'].DisplayLabel = (i) => { return (i.plannedNightWorkShiftFlatValue/100).toFixed(2)};

                    state.headerMap['plannedNightWorkTime'] = {};
                    state.headerMap['plannedNightWorkTime'].sort = false;
                    state.headerMap['plannedNightWorkTime'].label = this.$t('workBalance.payroll.nightWorkShort');
                    state.headerMap['plannedNightWorkTime'].key = 'plannedNightWorkTime';
                    state.headerMap['plannedNightWorkTime'].tooltip = this.$t('workBalance.payroll.nightWork') + this.$t('indicator.vlh.targetBubbleCaps');
                    state.headerMap['plannedNightWorkTime'].DisplayLabel = (i) => { return (i.plannedNightWorkTime/3600).toFixed(2)}; 

                    state.headerMap['plannedNightWorkValue'] = {};
                    state.headerMap['plannedNightWorkValue'].sort = false;
                    state.headerMap['plannedNightWorkValue'].key = 'plannedNightWorkValue';
                    state.headerMap['plannedNightWorkValue'].label = this.$t('indicator.eval.nightWorkCostsShort');
                    state.headerMap['plannedNightWorkValue'].tooltip = this.$t('indicator.eval.nightWorkCosts');
                    state.headerMap['plannedNightWorkValue'].bgcolor = config.nightWorkValue ? "#FFFF99" : null;
                    state.headerMap['plannedNightWorkValue'].DisplayLabel = (i) => { return (i.plannedNightWorkValue/100).toFixed(2)};

                    state.headerMap['plannedOvertimeShiftCount'] = {};
                    state.headerMap['plannedOvertimeShiftCount'].sort = false;
                    state.headerMap['plannedOvertimeShiftCount'].label = this.$t('workBalance.payroll.overTimeShiftsShort');
                    state.headerMap['plannedOvertimeShiftCount'].key = 'plannedOvertimeShiftCount';
                    state.headerMap['plannedOvertimeShiftCount'].tooltip = this.$t('workBalance.payroll.overTimeShifts') + this.$t('indicator.vlh.targetBubbleCaps');
                    state.headerMap['plannedOvertimeShiftCount'].DisplayLabel = (i) => { return (i.plannedOvertimeShiftCount).toFixed(2)}; 

                    state.headerMap['plannedOvertimeShiftFlatValue'] = {};
                    state.headerMap['plannedOvertimeShiftFlatValue'].sort = false;
                    state.headerMap['plannedOvertimeShiftFlatValue'].key = 'plannedOvertimeShiftFlatValue';
                    state.headerMap['plannedOvertimeShiftFlatValue'].label = this.$t('indicator.eval.overtimeFixedCosts');
                    state.headerMap['plannedOvertimeShiftFlatValue'].tooltip = this.$t('indicator.eval.overtimeFlatCosts');
                    state.headerMap['plannedOvertimeShiftFlatValue'].bgcolor = config.overtimeShiftFlatValue ? "#FFFF99" : null;
                    state.headerMap['plannedOvertimeShiftFlatValue'].DisplayLabel = (i) => { return (i.plannedOvertimeShiftFlatValue/100).toFixed(2)};

                    state.headerMap['plannedOvertime'] = {};
                    state.headerMap['plannedOvertime'].sort = false;
                    state.headerMap['plannedOvertime'].label = this.$t('workBalance.payroll.overTimeShort');
                    state.headerMap['plannedOvertime'].key = 'plannedOvertime';
                    state.headerMap['plannedOvertime'].tooltip = this.$t('workBalance.payroll.overTime') + this.$t('indicator.vlh.targetBubbleCaps');
                    state.headerMap['plannedOvertime'].DisplayLabel = (i) => { return (i.plannedOvertime/3600).toFixed(2)}; 

                    state.headerMap['plannedOvertimeValue'] = {};
                    state.headerMap['plannedOvertimeValue'].sort = false;
                    state.headerMap['plannedOvertimeValue'].key = 'plannedOvertimeValue';
                    state.headerMap['plannedOvertimeValue'].label = this.$t('indicator.eval.overtimeCostsShort');
                    state.headerMap['plannedOvertimeValue'].tooltip = this.$t('indicator.eval.overtimeCosts');
                    state.headerMap['plannedOvertimeValue'].bgcolor = config.overtimeValue ? "#FFFF99" : null;
                    state.headerMap['plannedOvertimeValue'].DisplayLabel = (i) => { return (i.plannedOvertimeValue/100).toFixed(2)};

                    state.headerMap['plannedHolidayWorkTime'] = {};
                    state.headerMap['plannedHolidayWorkTime'].sort = false;
                    state.headerMap['plannedHolidayWorkTime'].key = 'plannedHolidayWorkTime';
                    state.headerMap['plannedHolidayWorkTime'].label = this.$t('workBalance.payroll.holidayShort');
                    state.headerMap['plannedHolidayWorkTime'].tooltip = this.$t('workBalance.payroll.holidayWorkTime') + this.$t('indicator.vlh.targetBubbleCaps');
                    state.headerMap['plannedHolidayWorkTime'].DisplayLabel = (i) => { return (i.plannedHolidayWorkTime/3600).toFixed(2)}; 
                    
                    state.headerMap['plannedHolidayWorkValue'] = {};
                    state.headerMap['plannedHolidayWorkValue'].sort = false;
                    state.headerMap['plannedHolidayWorkValue'].key = 'plannedHolidayWorkValue';
                    state.headerMap['plannedHolidayWorkValue'].label = this.$t('indicator.eval.holidayCostsShort');
                    state.headerMap['plannedHolidayWorkValue'].tooltip = this.$t('indicator.eval.holidayCosts');
                    state.headerMap['plannedHolidayWorkValue'].bgcolor = config.holidayWorkValue ? "#FFFF99" : null;
                    state.headerMap['plannedHolidayWorkValue'].DisplayLabel = (i) => { return (i.plannedHolidayWorkValue/100).toFixed(2)};
                } else {
                    if(!config.openWorkValue) {
                        state.headerMap['productiveActualWorkTime'] = {};
                        state.headerMap['productiveActualWorkTime'].sort = false;
                        state.headerMap['productiveActualWorkTime'].key = 'productiveActualWorkTime';
                        state.headerMap['productiveActualWorkTime'].label = this.$t('indicator.eval.productiveWorkTimeShort');
                        state.headerMap['productiveActualWorkTime'].tooltip = this.$t('workBalance.payroll.productiveWorkTime') + this.$t('roster.comp.actualBubble');
                        state.headerMap['productiveActualWorkTime'].DisplayLabel = (i) => { return (i.productiveActualWorkTime/3600).toFixed(2)};
                        state.headerMap['productiveActualWorkTime'].labelicon = this.crewLaborDetail ? 'fas fa-eye-slash' : 'fas fa-eye'; 
                        state.headerMap['productiveActualWorkTime'].action = ()=> {
                                                            this.crewLaborDetail = !this.crewLaborDetail;
                                                            this.unproductiveDetail = false;
                                                            this.planCrewLaborDetail = false;
                                                        }
                        
                        state.headerMap['productiveActualWorkValue'] = {};
                        state.headerMap['productiveActualWorkValue'].sort = false;
                        state.headerMap['productiveActualWorkValue'].key = 'productiveActualWorkValue';
                        state.headerMap['productiveActualWorkValue'].label = this.$t('indicator.eval.productiveWorkTimeCostsShort');
                        state.headerMap['productiveActualWorkValue'].tooltip = this.$t('workBalance.payroll.productiveWorkTime') + " " + this.$t('workBalance.extraPay.costs');
                        state.headerMap['productiveActualWorkValue'].bgcolor = config.workValue ? "#FFFF99" : null;
                        state.headerMap['productiveActualWorkValue'].DisplayLabel = (i) => { return (i.productiveActualWorkValue/100).toFixed(2)};
                    } else {

                        state.headerMap['productiveActualOpenWorkTime'] = {};
                        state.headerMap['productiveActualOpenWorkTime'].sort = false;
                        state.headerMap['productiveActualOpenWorkTime'].label = this.$t('indicator.eval.openProductiveWorkTime');
                        state.headerMap['productiveActualOpenWorkTime'].key = 'productiveActualOpenWorkTime';
                        state.headerMap['productiveActualOpenWorkTime'].tooltip = this.$t('indicator.eval.openProductiveWorkTime') + this.$t('roster.comp.actualBubble');
                        state.headerMap['productiveActualOpenWorkTime'].DisplayLabel = (i) => { return (i.productiveActualOpenWorkTime/3600).toFixed(2)};
                        state.headerMap['productiveActualOpenWorkTime'].labelicon = this.crewLaborDetail ? 'fas fa-eye-slash' : 'fas fa-eye'; 
                        state.headerMap['productiveActualOpenWorkTime'].action = ()=> {
                                                            this.crewLaborDetail = !this.crewLaborDetail;
                                                            this.unproductiveDetail = false;
                                                            this.planCrewLaborDetail = false;
                                                        }

                        state.headerMap['productiveActualOpenWorkValue'] = {};
                        state.headerMap['productiveActualOpenWorkValue'].sort = false;
                        state.headerMap['productiveActualOpenWorkValue'].key = 'productiveActualOpenWorkValue';
                        state.headerMap['productiveActualOpenWorkValue'].label = this.$t('indicator.eval.openProductiveWorkTimeCostShort');
                        state.headerMap['productiveActualOpenWorkValue'].tooltip = this.$t('indicator.eval.openProductiveWorkTimeCost');
                        state.headerMap['productiveActualOpenWorkValue'].bgcolor = config.openWorkValue ? "#FFFF99" : null;
                        state.headerMap['productiveActualOpenWorkValue'].DisplayLabel = (i) => { return (i.productiveActualOpenWorkValue/100).toFixed(2)};
                    }

                    state.headerMap['actualNightWorkShiftCount'] = {};
                    state.headerMap['actualNightWorkShiftCount'].sort = false;
                    state.headerMap['actualNightWorkShiftCount'].label = this.$t('workBalance.payroll.nightWorkShiftsShort');
                    state.headerMap['actualNightWorkShiftCount'].key = 'actualNightWorkShiftCount';
                    state.headerMap['actualNightWorkShiftCount'].tooltip = this.$t('indicator.eval.nightWorkShiftsAmount') + this.$t('roster.comp.actualBubble');
                    state.headerMap['actualNightWorkShiftCount'].DisplayLabel = (i) => { return (i.actualNightWorkShiftCount).toFixed(2)}; 

                    state.headerMap['actualNightWorkShiftFlatValue'] = {};
                    state.headerMap['actualNightWorkShiftFlatValue'].sort = false;
                    state.headerMap['actualNightWorkShiftFlatValue'].key = 'actualNightWorkShiftFlatValue';
                    state.headerMap['actualNightWorkShiftFlatValue'].label = this.$t('indicator.eval.nightWorkFixedCostsShort');
                    state.headerMap['actualNightWorkShiftFlatValue'].tooltip = this.$t('indicator.eval.nightWorkFixedCosts');
                    state.headerMap['actualNightWorkShiftFlatValue'].bgcolor = config.nightWorkShiftFlatValue ? "#FFFF99" : null;
                    state.headerMap['actualNightWorkShiftFlatValue'].DisplayLabel = (i) => { return (i.actualNightWorkShiftFlatValue/100).toFixed(2)};

                    state.headerMap['actualNightWorkTime'] = {};
                    state.headerMap['actualNightWorkTime'].sort = false;
                    state.headerMap['actualNightWorkTime'].label = this.$t('workBalance.payroll.nightWorkShort');
                    state.headerMap['actualNightWorkTime'].key = 'actualNightWorkTime';
                    state.headerMap['actualNightWorkTime'].tooltip = this.$t('workBalance.payroll.nightWork') + this.$t('roster.comp.actualBubble');
                    state.headerMap['actualNightWorkTime'].DisplayLabel = (i) => { return (i.actualNightWorkTime/3600).toFixed(2)}; 

                    state.headerMap['actualNightWorkValue'] = {};
                    state.headerMap['actualNightWorkValue'].sort = false;
                    state.headerMap['actualNightWorkValue'].key = 'actualNightWorkValue';
                    state.headerMap['actualNightWorkValue'].label = this.$t('indicator.eval.nightWorkCostsShort');
                    state.headerMap['actualNightWorkValue'].tooltip = this.$t('indicator.eval.nightWorkCosts');
                    state.headerMap['actualNightWorkValue'].bgcolor = config.nightWorkValue ? "#FFFF99" : null;
                    state.headerMap['actualNightWorkValue'].DisplayLabel = (i) => { return (i.actualNightWorkValue/100).toFixed(2)};

                    state.headerMap['actualOvertimeShiftCount'] = {};
                    state.headerMap['actualOvertimeShiftCount'].sort = false;
                    state.headerMap['actualOvertimeShiftCount'].label = this.$t('workBalance.payroll.overTimeShiftsShort');
                    state.headerMap['actualOvertimeShiftCount'].key = 'actualOvertimeShiftCount';
                    state.headerMap['actualOvertimeShiftCount'].tooltip = this.$t('indicator.eval.overtimeShiftsAmount') + this.$t('roster.comp.actualBubble');
                    state.headerMap['actualOvertimeShiftCount'].DisplayLabel = (i) => { return (i.actualOvertimeShiftCount).toFixed(2)}; 

                    state.headerMap['actualOvertimeShiftFlatValue'] = {};
                    state.headerMap['actualOvertimeShiftFlatValue'].sort = false;
                    state.headerMap['actualOvertimeShiftFlatValue'].key = 'actualOvertimeShiftFlatValue';
                    state.headerMap['actualOvertimeShiftFlatValue'].label = this.$t('indicator.eval.overtimeFixedCosts');
                    state.headerMap['actualOvertimeShiftFlatValue'].tooltip = this.$t('indicator.eval.overtimeFlatCosts');
                    state.headerMap['actualOvertimeShiftFlatValue'].bgcolor = config.overtimeShiftFlatValue ? "#FFFF99" : null;
                    state.headerMap['actualOvertimeShiftFlatValue'].DisplayLabel = (i) => { return (i.actualOvertimeShiftFlatValue/100).toFixed(2)};
                    
                    state.headerMap['actualOvertime'] = {};
                    state.headerMap['actualOvertime'].sort = false;
                    state.headerMap['actualOvertime'].label = this.$t('workBalance.payroll.overTimeShort');
                    state.headerMap['actualOvertime'].key = 'actualOvertime';
                    state.headerMap['actualOvertime'].tooltip = this.$t('workBalance.payroll.overTime') + this.$t('roster.comp.actualBubble');
                    state.headerMap['actualOvertime'].DisplayLabel = (i) => { return (i.actualOvertime/3600).toFixed(2)}; 

                    state.headerMap['actualOvertimeValue'] = {};
                    state.headerMap['actualOvertimeValue'].sort = false;
                    state.headerMap['actualOvertimeValue'].key = 'actualOvertimeValue';
                    state.headerMap['actualOvertimeValue'].label = this.$t('indicator.eval.overtimeCostsShort');
                    state.headerMap['actualOvertimeValue'].tooltip = this.$t('indicator.eval.overtimeCosts');
                    state.headerMap['actualOvertimeValue'].bgcolor = config.overtimeValue ? "#FFFF99" : null;
                    state.headerMap['actualOvertimeValue'].DisplayLabel = (i) => { return (i.actualOvertimeValue/100).toFixed(2)};

                    state.headerMap['actualHolidayWorkTime'] = {};
                    state.headerMap['actualHolidayWorkTime'].sort = false;
                    state.headerMap['actualHolidayWorkTime'].key = 'actualHolidayWorkTime';
                    state.headerMap['actualHolidayWorkTime'].label = this.$t('workBalance.payroll.holidayShort');
                    state.headerMap['actualHolidayWorkTime'].tooltip = this.$t('workBalance.payroll.holidayWorkTime') + this.$t('roster.comp.actualBubble');
                    state.headerMap['actualHolidayWorkTime'].DisplayLabel = (i) => { return (i.actualHolidayWorkTime/3600).toFixed(2)}; 
                    
                    state.headerMap['actualHolidayWorkValue'] = {};
                    state.headerMap['actualHolidayWorkValue'].sort = false;
                    state.headerMap['actualHolidayWorkValue'].key = 'actualHolidayWorkValue';
                    state.headerMap['actualHolidayWorkValue'].label = this.$t('indicator.eval.holidayCostsShort');
                    state.headerMap['actualHolidayWorkValue'].tooltip = this.$t('indicator.eval.holidayCosts');
                    state.headerMap['actualHolidayWorkValue'].bgcolor = config.holidayWorkValue ? "#FFFF99" : null;
                    state.headerMap['actualHolidayWorkValue'].DisplayLabel = (i) => { return (i.actualHolidayWorkValue/100).toFixed(2)};
                }
                

                
            }
                
            if(!this.crewLaborDetail && this.unproductiveDetail && !this.planCrewLaborDetail){
                if(this.showPlanned){
                    if(!config.openWorkValue){
                        state.headerMap['unproductivePlannedWorkTime'] = {};
                        state.headerMap['unproductivePlannedWorkTime'].sort = false;
                        state.headerMap['unproductivePlannedWorkTime'].key = 'unproductivePlannedWorkTime';
                        state.headerMap['unproductivePlannedWorkTime'].label = this.$t('indicator.eval.unproductiveWorkTimeShort');
                        state.headerMap['unproductivePlannedWorkTime'].tooltip = this.$t('workBalance.payroll.unproductiveWorkTime') + this.$t('indicator.vlh.targetBubbleCaps');
                        state.headerMap['unproductivePlannedWorkTime'].DisplayLabel = (i) => { return ((i.plannedWorkTime - i.productivePlannedWorkTime)/3600).toFixed(2)};
                        state.headerMap['unproductivePlannedWorkTime'].labelicon = this.unproductiveDetail ? 'fas fa-eye-slash' : 'fas fa-eye';
                        state.headerMap['unproductivePlannedWorkTime'].action = ()=> {
                                                                this.crewLaborDetail = false;
                                                                this.unproductiveDetail = !this.unproductiveDetail;
                                                                this.planCrewLaborDetail = false;
                                                            } 
                        
                        state.headerMap['unproductivePlannedWorkValue'] = {};
                        state.headerMap['unproductivePlannedWorkValue'].sort = false;
                        state.headerMap['unproductivePlannedWorkValue'].key = 'unproductivePlannedWorkValue';
                        state.headerMap['unproductivePlannedWorkValue'].label = this.$t('indicator.eval.unproductiveWorkTimeCostShort');
                        state.headerMap['unproductivePlannedWorkValue'].tooltip = this.$t('indicator.eval.unproductiveWorkTimeCosts') + this.$t('indicator.vlh.targetBubbleCaps');
                        state.headerMap['unproductivePlannedWorkValue'].bgcolor = config.workValue ? "#FFFF99" : null;
                        state.headerMap['unproductivePlannedWorkValue'].DisplayLabel = (i) => { return ((i.plannedWorkValue - i.productivePlannedWorkValue)/100).toFixed(2)};
                    } else {
                        state.headerMap['unproductivePlannedOpenWorkTime'] = {};
                        state.headerMap['unproductivePlannedOpenWorkTime'].sort = false;
                        state.headerMap['unproductivePlannedOpenWorkTime'].key = 'unproductivePlannedOpenWorkTime';
                        state.headerMap['unproductivePlannedOpenWorkTime'].label = this.$t('indicator.eval.unproductiveWorkTimeShort');
                        state.headerMap['unproductivePlannedOpenWorkTime'].tooltip = this.$t('indicator.eval.openUnproductiveWorkTime') + this.$t('indicator.vlh.targetBubbleCaps');
                        state.headerMap['unproductivePlannedOpenWorkTime'].DisplayLabel = (i) => { return ((i.plannedOpenWorkTime - i.productivePlannedOpenWorkTime)/3600).toFixed(2)};
                        state.headerMap['unproductivePlannedOpenWorkTime'].labelicon = this.unproductiveDetail ? 'fas fa-eye-slash' : 'fas fa-eye';
                        state.headerMap['unproductivePlannedOpenWorkTime'].action = ()=> {
                                                                this.crewLaborDetail = false;
                                                                this.unproductiveDetail = !this.unproductiveDetail;
                                                                this.planCrewLaborDetail = false;
                                                            } 
                        
                        state.headerMap['unproductivePlannedOpenWorkValue'] = {};
                        state.headerMap['unproductivePlannedOpenWorkValue'].sort = false;
                        state.headerMap['unproductivePlannedOpenWorkValue'].key = 'unproductivePlannedOpenWorkValue';
                        state.headerMap['unproductivePlannedOpenWorkValue'].label = this.$t('indicator.eval.unproductiveWorkTimeCostShort');
                        state.headerMap['unproductivePlannedOpenWorkValue'].tooltip = this.$t('indicator.eval.openUnproductiveWorkTimeCosts') + this.$t('indicator.vlh.targetBubbleCaps');
                        state.headerMap['unproductivePlannedOpenWorkValue'].bgcolor = config.workValue ? "#FFFF99" : null;
                        state.headerMap['unproductivePlannedOpenWorkValue'].DisplayLabel = (i) => { return ((i.plannedOpenWorkValue - i.productivePlannedOpenWorkValue)/100).toFixed(2)};
                    } 
                    
                } else {
                    if(!config.openWorkValue){
                        state.headerMap['unproductiveActualWorkTime'] = {};
                        state.headerMap['unproductiveActualWorkTime'].sort = false;
                        state.headerMap['unproductiveActualWorkTime'].key = 'unproductiveActualWorkTime';
                        state.headerMap['unproductiveActualWorkTime'].label = this.$t('indicator.eval.unproductiveWorkTimeShort');
                        state.headerMap['unproductiveActualWorkTime'].tooltip = this.$t('workBalance.payroll.unproductiveWorkTime') + this.$t('roster.comp.actualBubble');
                        state.headerMap['unproductiveActualWorkTime'].DisplayLabel = (i) => { return ((i.actualWorkTime - i.productiveActualWorkTime)/3600).toFixed(2)};
                        state.headerMap['unproductiveActualWorkTime'].labelicon = this.unproductiveDetail ? 'fas fa-eye-slash' : 'fas fa-eye';
                        state.headerMap['unproductiveActualWorkTime'].action = ()=> {
                                                                this.crewLaborDetail = false;
                                                                this.unproductiveDetail = !this.unproductiveDetail;
                                                                this.planCrewLaborDetail = false;
                                                            } 
                        
                        state.headerMap['unproductiveActualWorkValue'] = {};
                        state.headerMap['unproductiveActualWorkValue'].sort = false;
                        state.headerMap['unproductiveActualWorkValue'].key = 'unproductiveActualWorkValue';
                        state.headerMap['unproductiveActualWorkValue'].label = this.$t('indicator.eval.unproductiveWorkTimeCostShort');
                        state.headerMap['unproductiveActualWorkValue'].tooltip = this.$t('indicator.eval.unproductiveWorkTimeCosts') + this.$t('roster.comp.actualBubble');
                        state.headerMap['unproductiveActualWorkValue'].bgcolor = config.workValue ? "#FFFF99" : null;
                        state.headerMap['unproductiveActualWorkValue'].DisplayLabel = (i) => { return ((i.actualWorkValue - i.productiveActualWorkValue)/100).toFixed(2)};
                    } else {
                        state.headerMap['unproductiveActualOpenWorkTime'] = {};
                        state.headerMap['unproductiveActualOpenWorkTime'].sort = false;
                        state.headerMap['unproductiveActualOpenWorkTime'].key = 'unproductiveActualOpenWorkTime';
                        state.headerMap['unproductiveActualOpenWorkTime'].label = this.$t('indicator.eval.unproductiveWorkTimeShort');
                        state.headerMap['unproductiveActualOpenWorkTime'].tooltip = this.$t('indicator.eval.openUnproductiveWorkTime') + this.$t('roster.comp.actualBubble');
                        state.headerMap['unproductiveActualOpenWorkTime'].DisplayLabel = (i) => { return ((i.actualOpenWorkTime - i.productiveActualOpenWorkTime)/3600).toFixed(2)};
                        state.headerMap['unproductiveActualOpenWorkTime'].labelicon = this.unproductiveDetail ? 'fas fa-eye-slash' : 'fas fa-eye';
                        state.headerMap['unproductiveActualOpenWorkTime'].action = ()=> {
                                                                this.crewLaborDetail = false;
                                                                this.unproductiveDetail = !this.unproductiveDetail;
                                                                this.planCrewLaborDetail = false;
                                                            } 
                        
                        state.headerMap['unproductiveActualOpenWorkValue'] = {};
                        state.headerMap['unproductiveActualOpenWorkValue'].sort = false;
                        state.headerMap['unproductiveActualOpenWorkValue'].key = 'unproductiveActualOpenWorkValue';
                        state.headerMap['unproductiveActualOpenWorkValue'].label = this.$t('indicator.eval.unproductiveWorkTimeCostShort');
                        state.headerMap['unproductiveActualOpenWorkValue'].tooltip = this.$t('indicator.eval.openUnproductiveWorkTimeCosts') + this.$t('roster.comp.actualBubble');
                        state.headerMap['unproductiveActualOpenWorkValue'].bgcolor = config.workValue ? "#FFFF99" : null;
                        state.headerMap['unproductiveActualOpenWorkValue'].DisplayLabel = (i) => { return ((i.actualOpenWorkValue - i.productiveActualOpenWorkValue)/100).toFixed(2)};
                    } 
                }
                

                state.headerMap['vacationWorkTime'] = {};
                state.headerMap['vacationWorkTime'].sort = false;
                state.headerMap['vacationWorkTime'].key = 'vacationWorkTime';
                state.headerMap['vacationWorkTime'].label = this.$t('indicator.eval.vacationWorkTimeShort');
                state.headerMap['vacationWorkTime'].tooltip = this.$t('indicator.eval.vacationWorkTime');
                state.headerMap['vacationWorkTime'].DisplayLabel = (i) => { return (i.vacationWorkTime/3600).toFixed(2)};
                
                
                
                state.headerMap['vacationWorkValue'] = {};
                state.headerMap['vacationWorkValue'].sort = false;
                state.headerMap['vacationWorkValue'].key = 'vacationWorkValue';
                state.headerMap['vacationWorkValue'].label = this.$t('indicator.eval.vacationWorkTimeShortCosts');
                state.headerMap['vacationWorkValue'].tooltip = this.$t('indicator.eval.vacationWorkTimeCosts');
                state.headerMap['vacationWorkValue'].bgcolor = config.vacationWorkValue ? "#FFFF99" : null;
                state.headerMap['vacationWorkValue'].DisplayLabel = (i) => { return (i.vacationWorkValue/100).toFixed(2)};

                state.headerMap['sickWorkTime'] = {};
                state.headerMap['sickWorkTime'].sort = false;
                state.headerMap['sickWorkTime'].key = 'sickWorkTime';
                state.headerMap['sickWorkTime'].label = this.$t('indicator.eval.sickLeaveWorkTimeShort');
                state.headerMap['sickWorkTime'].tooltip = this.$t('indicator.eval.sickLeaveWorkTime');
                state.headerMap['sickWorkTime'].DisplayLabel = (i) => { return (i.sickWorkTime/3600).toFixed(2)}; 
                
                state.headerMap['sickWorkValue'] = {};
                state.headerMap['sickWorkValue'].sort = false;
                state.headerMap['sickWorkValue'].key = 'sickWorkValue';
                state.headerMap['sickWorkValue'].label = this.$t('indicator.eval.sickLeaveWorkTimeCostShort');
                state.headerMap['sickWorkValue'].tooltip = this.$t('indicator.eval.sickLeaveWorkTimeCosts');
                state.headerMap['sickWorkValue'].bgcolor = config.sickWorkValue ? "#FFFF99" : null;
                state.headerMap['sickWorkValue'].DisplayLabel = (i) => { return (i.sickWorkValue/100).toFixed(2)};

                state.headerMap['holidayAdjustWorkTime'] = {};
                state.headerMap['holidayAdjustWorkTime'].sort = false;
                state.headerMap['holidayAdjustWorkTime'].key = 'holidayAdjustWorkTime';
                state.headerMap['holidayAdjustWorkTime'].label = this.$t('workBalance.payroll.holidayCompensationShort');
                state.headerMap['holidayAdjustWorkTime'].tooltip = this.$t('indicator.eval.holidayCompensationWorkTime');
                state.headerMap['holidayAdjustWorkTime'].DisplayLabel = (i) => { return (i.holidayAdjustWorkTime/3600).toFixed(2)}; 
                
                state.headerMap['holidayAdjustWorkValue'] = {};
                state.headerMap['holidayAdjustWorkValue'].sort = false;
                state.headerMap['holidayAdjustWorkValue'].key = 'holidayAdjustWorkValue';
                state.headerMap['holidayAdjustWorkValue'].label = this.$t('indicator.eval.holidayCompensationCostsShort');
                state.headerMap['holidayAdjustWorkValue'].tooltip = this.$t('indicator.eval.holidayCompensationWorkTimeCosts');
                state.headerMap['holidayAdjustWorkValue'].bgcolor = config.holidayAdjustWorkValue ? "#FFFF99" : null;
                state.headerMap['holidayAdjustWorkValue'].DisplayLabel = (i) => { return (i.holidayAdjustWorkValue/100).toFixed(2)};

                state.headerMap['miscWorkTime'] = {};
                state.headerMap['miscWorkTime'].sort = false;
                state.headerMap['miscWorkTime'].key = 'miscWorkTime';
                state.headerMap['miscWorkTime'].label = this.$t('indicator.eval.otherAbsencesShort');
                state.headerMap['miscWorkTime'].tooltip = this.$t('indicator.eval.otherAbsencesWorkTime');
                state.headerMap['miscWorkTime'].DisplayLabel = (i) => { return (i.miscWorkTime/3600).toFixed(2)}; 
                
                state.headerMap['miscWorkValue'] = {};
                state.headerMap['miscWorkValue'].sort = false;
                state.headerMap['miscWorkValue'].key = 'miscWorkValue';
                state.headerMap['miscWorkValue'].label = this.$t('indicator.eval.otherAbsencesShortCosts');
                state.headerMap['miscWorkValue'].tooltip = this.$t('indicator.eval.otherAbsencesWorkTimeCosts');
                state.headerMap['miscWorkValue'].bgcolor = config.miscWorkValue ? "#FFFF99" : null;
                state.headerMap['miscWorkValue'].DisplayLabel = (i) => { return (i.miscWorkValue/100).toFixed(2)};

                state.headerMap['nursingVacationWorkTime'] = {};
                state.headerMap['nursingVacationWorkTime'].sort = false;
                state.headerMap['nursingVacationWorkTime'].key = 'nursingVacationWorkTime';
                state.headerMap['nursingVacationWorkTime'].label = this.$t('indicator.eval.nursingLeaveWorkTimeShort');
                state.headerMap['nursingVacationWorkTime'].tooltip = this.$t('indicator.eval.nursingLeaveWorkTime');
                state.headerMap['nursingVacationWorkTime'].DisplayLabel = (i) => { return (i.nursingVacationWorkTime/3600).toFixed(2)}; 
                
                state.headerMap['nursingVacationWorkValue'] = {};
                state.headerMap['nursingVacationWorkValue'].sort = false;
                state.headerMap['nursingVacationWorkValue'].key = 'nursingVacationWorkValue';
                state.headerMap['nursingVacationWorkValue'].label = this.$t('indicator.eval.nursingLeaveWorkTimeCostsShort');
                state.headerMap['nursingVacationWorkValue'].tooltip = this.$t('indicator.eval.nursingLeaveWorkTimeCosts');
                state.headerMap['nursingVacationWorkValue'].bgcolor = config.nursingVacationWorkValue ? "#FFFF99" : null;
                state.headerMap['nursingVacationWorkValue'].DisplayLabel = (i) => { return (i.nursingVacationWorkValue/100).toFixed(2)};

                state.headerMap['eduWorkTime'] = {};
                state.headerMap['eduWorkTime'].sort = false;
                state.headerMap['eduWorkTime'].key = 'eduWorkTime';
                state.headerMap['eduWorkTime'].label = this.$t('indicator.eval.traineeWorkTimeShort');
                state.headerMap['eduWorkTime'].tooltip = this.$t('indicator.eval.traineeWorkTime');
                state.headerMap['eduWorkTime'].DisplayLabel = (i) => { return (i.eduWorkTime/3600).toFixed(2)}; 
                
                state.headerMap['eduWorkValue'] = {};
                state.headerMap['eduWorkValue'].sort = false;
                state.headerMap['eduWorkValue'].key = 'eduWorkValue';
                state.headerMap['eduWorkValue'].label = this.$t('indicator.eval.traineeWorkTimeCostsShort');
                state.headerMap['eduWorkValue'].tooltip = this.$t('indicator.eval.traineeWorkTimeCosts');
                state.headerMap['eduWorkValue'].bgcolor = config.eduWorkValue ? "#FFFF99" : null;
                state.headerMap['eduWorkValue'].DisplayLabel = (i) => { return (i.eduWorkValue/100).toFixed(2)};

                state.headerMap['wageContinuationWorkTime'] = {};
                state.headerMap['wageContinuationWorkTime'].sort = false;
                state.headerMap['wageContinuationWorkTime'].key = 'wageContinuationWorkTime';
                state.headerMap['wageContinuationWorkTime'].label = this.$t('workBalance.summary.sickPayShort');
                state.headerMap['wageContinuationWorkTime'].tooltip = this.$t('indicator.eval.payContinuationWorkTime');
                state.headerMap['wageContinuationWorkTime'].DisplayLabel = (i) => { return (i.wageContinuationWorkTime/3600).toFixed(2)}; 
                
                state.headerMap['wageContinuationWorkValue'] = {};
                state.headerMap['wageContinuationWorkValue'].sort = false;
                state.headerMap['wageContinuationWorkValue'].key = 'wageContinuationWorkValue';
                state.headerMap['wageContinuationWorkValue'].label = this.$t('indicator.eval.payContinuationCostsShort');
                state.headerMap['wageContinuationWorkValue'].tooltip = this.$t('indicator.eval.payContinuationCosts');
                state.headerMap['wageContinuationWorkValue'].bgcolor = config.wageContinuationWorkValue ? "#FFFF99" : null;
                state.headerMap['wageContinuationWorkValue'].DisplayLabel = (i) => { return (i.wageContinuationWorkValue/100).toFixed(2)};

                state.headerMap['fixedCostValue'] = {};
                state.headerMap['fixedCostValue'].sort = false;
                state.headerMap['fixedCostValue'].key = 'fixedCostValue';
                state.headerMap['fixedCostValue'].label = this.$t('indicator.eval.fixCostsShort');
                state.headerMap['fixedCostValue'].tooltip = this.$t('indicator.main.fixCosts');
                state.headerMap['fixedCostValue'].bgcolor = "#FFFF99";
                state.headerMap['fixedCostValue'].DisplayLabel = (i) => { return (i.fixedCostValue/100).toFixed(2)};
            }

            if(!this.crewLaborDetail && !this.unproductiveDetail && this.planCrewLaborDetail){
                if(this.showPlanned){
                    state.headerMap['plannedIndicatorValue'] = {};
                    state.headerMap['plannedIndicatorValue'].sort = false
                    state.headerMap['plannedIndicatorValue'].key = 'plannedIndicatorValue';
                    state.headerMap['plannedIndicatorValue'].label = mainType ? mainType.name : this.$t('roster.view.keyFigure');
                    state.headerMap['plannedIndicatorValue'].DisplayLabel = (i) => { return view.anonMode ? '-' : i.plannedIndicatorValue.toFixed(2)};

                     
                } else {
                    state.headerMap['actualIndicatorValue'] = {};
                    state.headerMap['actualIndicatorValue'].sort = false
                    state.headerMap['actualIndicatorValue'].key = 'actualIndicatorValue';
                    state.headerMap['actualIndicatorValue'].label = mainType ? mainType.name : this.$t('roster.view.keyFigure');
                    state.headerMap['actualIndicatorValue'].DisplayLabel = (i) => { return view.anonMode ? '-' : i.actualIndicatorValue.toFixed(2)};

                }

                state.headerMap['totalWorkTimeSum'] = {};
                state.headerMap['totalWorkTimeSum'].sort = false;
                state.headerMap['totalWorkTimeSum'].label = this.$t('indicator.eval.totalWorkTimeShort');
                state.headerMap['totalWorkTimeSum'].key = 'totalWorkTimeSum';
                state.headerMap['totalWorkTimeSum'].tooltip = this.$t('indicator.eval.totalWorkTime');
                state.headerMap['totalWorkTimeSum'].DisplayLabel = (i) => { return ((view.$helpers.calculateCLWorkTimeSum(i, config, view.showPlanned) + view.$helpers.calculateCLUnproductiveWorkTimeSum(i, config, view.showPlanned))/3600).toFixed(2)};
                
                state.headerMap['contractWorkTime'] = {};
                state.headerMap['contractWorkTime'].sort = false;
                state.headerMap['contractWorkTime'].label = this.$t('indicator.eval.contractWorkTimeShort');
                state.headerMap['contractWorkTime'].key = 'contractWorkTime';
                state.headerMap['contractWorkTime'].tooltip = this.$t('indicator.eval.contractedWorkTime');
                state.headerMap['contractWorkTime'].DisplayLabel = (i) => { return (Math.round(i.contractWorkTime)/3600).toFixed(2)};
                state.headerMap['contractWorkTime'].labelicon = this.planCrewLaborDetail ? 'fas fa-eye-slash' : 'fas fa-eye';
                state.headerMap['contractWorkTime'].action = ()=> {
                                                        this.crewLaborDetail = false;
                                                        this.unproductiveDetail = false;
                                                        this.planCrewLaborDetail = !this.planCrewLaborDetail;
                                                    }

                state.headerMap['pWorkTimeDiff'] = {};
                state.headerMap['pWorkTimeDiff'].sort = false;
                state.headerMap['pWorkTimeDiff'].label = this.$t('indicator.eval.plusDiff');
                state.headerMap['pWorkTimeDiff'].key = 'pWorkTimeDiff';
                state.headerMap['pWorkTimeDiff'].tooltip = this.$t('indicator.eval.positiveWorkTimeDifference');
                state.headerMap['pWorkTimeDiff'].DisplayLabel = (i) => {
                    let wt = view.$helpers.calculateCLWorkTimeSum(i, config, view.showPlanned) + view.$helpers.calculateCLUnproductiveWorkTimeSum(i, config, view.showPlanned);
                    let ct = i.contractWorkTime;
                    let res = wt - ct;
                    if(res >= 0){
                        return (Math.round(res)/3600).toFixed(2)
                    } else {
                        return (0).toFixed(2)
                    }
                     
                };

                state.headerMap['nWorkTimeDiff'] = {};
                state.headerMap['nWorkTimeDiff'].sort = false;
                state.headerMap['nWorkTimeDiff'].label = this.$t('indicator.eval.minusDiff');
                state.headerMap['nWorkTimeDiff'].key = 'nWorkTimeDiff';
                state.headerMap['nWorkTimeDiff'].tooltip = this.$t('indicator.eval.negativeWorkTimeDifference');
                state.headerMap['nWorkTimeDiff'].DisplayLabel = (i) => {
                    let wt = view.$helpers.calculateCLWorkTimeSum(i, config, view.showPlanned) + view.$helpers.calculateCLUnproductiveWorkTimeSum(i, config, view.showPlanned);
                    let ct = i.contractWorkTime;
                    let res = wt - ct;
                    if(res < 0){
                        return (Math.round(res)/3600).toFixed(2)
                    } else {
                        return (0).toFixed(2)
                    }
                     
                };
                                                    
                state.headerMap['totalWorkValueSum'] = {};
                state.headerMap['totalWorkValueSum'].sort = false;
                state.headerMap['totalWorkValueSum'].key = 'totalWorkValueSum';
                state.headerMap['totalWorkValueSum'].label = this.$t('indicator.eval.crewLaborShort');
                state.headerMap['totalWorkValueSum'].tooltip = this.$t('indicator.crew.crewLabor');
                state.headerMap['totalWorkValueSum'].bgcolor = "#FFFF99";
                state.headerMap['totalWorkValueSum'].DisplayLabel = (i) => { return (view.$helpers.calculateCLCrewLaborSum(i, config, view.showPlanned)/100).toFixed(2)};
 
                state.headerMap['contractWorkValue'] = {};
                state.headerMap['contractWorkValue'].sort = false;
                state.headerMap['contractWorkValue'].key = 'contractWorkValue';
                state.headerMap['contractWorkValue'].label = this.$t('indicator.eval.contractedCrewLaborShort');
                state.headerMap['contractWorkValue'].tooltip = this.$t('indicator.eval.contractedCrewLabor');
                state.headerMap['contractWorkValue'].DisplayLabel = (i) => { return ((Math.round(i.contractWorkValue))/100).toFixed(2)};
               
                

                state.headerMap['pWorkValueDiff'] = {};
                state.headerMap['pWorkValueDiff'].sort = false;
                state.headerMap['pWorkValueDiff'].label = this.$t('indicator.eval.plusDiff');
                state.headerMap['pWorkValueDiff'].key = 'pWorkValueDiff';
                state.headerMap['pWorkValueDiff'].tooltip = this.$t('indicator.eval.positiveCrewLaborDifference');
                state.headerMap['pWorkValueDiff'].DisplayLabel = (i) => {
                    let wt = view.$helpers.calculateCLCrewLaborSum(i, config, view.showPlanned);
                    let ct = i.contractWorkValue;
                    let res = wt - ct;
                    if(res >= 0){
                        return (Math.round(res)/100).toFixed(2)
                    } else {
                        return (0).toFixed(2)
                    }
                     
                };

                state.headerMap['nWorkValueDiff'] = {};
                state.headerMap['nWorkValueDiff'].sort = false;
                state.headerMap['nWorkValueDiff'].label = this.$t('indicator.eval.minusDiff');
                state.headerMap['nWorkValueDiff'].key = 'nWorkValueDiff';
                state.headerMap['nWorkValueDiff'].tooltip = this.$t('indicator.eval.negativeCrewLaborDifference');
                state.headerMap['nWorkValueDiff'].DisplayLabel = (i) => {
                    let wt = view.$helpers.calculateCLCrewLaborSum(i, config, view.showPlanned);
                    let ct = i.contractWorkValue;
                    let res = wt - ct;
                    if(res < 0){
                        return (Math.round(res)/100).toFixed(2)
                    } else {
                        return (0).toFixed(2)
                    }
                     
                };

                if(this.showPlanned){
                    state.headerMap['plannedWorkValuePercentage'] = {};
                    state.headerMap['plannedWorkValuePercentage'].sort = false;
                    state.headerMap['plannedWorkValuePercentage'].key = 'plannedWorkValuePercentage';
                    state.headerMap['plannedWorkValuePercentage'].label = this.$t('indicator.eval.crewLaborShort') + "%";
                    state.headerMap['plannedWorkValuePercentage'].tooltip = this.$t('indicator.eval.crewLaborPercentage');
                    state.headerMap['plannedWorkValuePercentage'].DisplayLabel = (i) => { 
                        if(i.plannedIndicatorValue > 0){
                            return ((view.$helpers.calculateCLCrewLaborSum(i, config, view.showPlanned)/100/i.plannedIndicatorValue)*100).toFixed(2)+' %';
                        } else {
                            return '-';
                        }
                        
                    };

                } else {
                    state.headerMap['actualWorkValuePercentage'] = {};
                    state.headerMap['actualWorkValuePercentage'].sort = false;
                    state.headerMap['actualWorkValuePercentage'].key = 'actualWorkValuePercentage';
                    state.headerMap['actualWorkValuePercentage'].label = this.$t('indicator.eval.crewLaborShort') + "%";
                    state.headerMap['actualWorkValuePercentage'].tooltip = this.$t('indicator.eval.crewLaborPercentage');
                    state.headerMap['actualWorkValuePercentage'].DisplayLabel = (i) => { 
                        if(i.actualIndicatorValue > 0 && !view.anonMode){
                            return ((view.$helpers.calculateCLCrewLaborSum(i, config, view.showPlanned)/100/i.actualIndicatorValue)*100).toFixed(2)+' %';
                        } else {
                            return '-';
                        }
                        
                    };

                    
                }

                state.headerMap['contractWorkValuePercentage'] = {};
                state.headerMap['contractWorkValuePercentage'].sort = false;
                state.headerMap['contractWorkValuePercentage'].key = 'contractWorkValuePercentage';
                state.headerMap['contractWorkValuePercentage'].label = this.$t('indicator.eval.contractedCrewLaborShort') + "%";
                state.headerMap['contractWorkValuePercentage'].tooltip = this.$t('indicator.eval.contractedCrewLaborPercentage');
                state.headerMap['contractWorkValuePercentage'].DisplayLabel = (i) => { 
                    if(view.showPlanned){
                        if(i.plannedIndicatorValue > 0 && !view.anonMode){
                            return ((i.contractWorkValue/100/i.plannedIndicatorValue)*100).toFixed(2)+' %';
                        } else {
                            return "-"
                        }
                    } else {
                        if(i.actualIndicatorValue > 0 && !view.anonMode){
                            return ((i.contractWorkValue/100/i.actualIndicatorValue)*100).toFixed(2)+' %';
                        } else {
                            return "-"
                        }
                    }   
                    
                };

                

                
                
            }
           

            
                
            
            
            if(!this.hourMode){
                state.headerMap['actions'] = {align: 'center',
                    buttons:[
                        {icon: 'fas fa-eye', action: ($event, data) => view.ToggleHourMode(data)}, 
                    ]
                };
            }
            let summary =  {from: this.$t('global.ui.sum'),
                            plannedIndicatorValue: 0, 
                            contractWorkTime: 0, contractWorkValue: 0,
                            plannedWorkTime: 0, plannedWorkValue: 0,
                            plannedOpenWorkTime: 0, plannedOpenWorkValue: 0,
                            plannedIndicatorWorkTime: 0, plannedIndicatorWorkValue: 0,
                            productivePlannedWorkTime: 0, productivePlannedWorkValue: 0,
                            productivePlannedOpenWorkTime: 0, productivePlannedOpenWorkValue: 0,
                            productivePlannedIndicatorWorkTime: 0, productivePlannedIndicatorWorkValue: 0,
                            unproductivePlannedWorkTime: 0, unproductivePlannedWorkValue: 0,
                            unproductivePlannedOpenWorkTime: 0, unproductivePlannedOpenWorkValue: 0,
                            unproductivePlannedIndicatorWorkTime: 0, unproductivePlannedIndicatorWorkValue: 0,
                            plannedNightWorkTime: 0, plannedNightWorkValue: 0,
                            plannedNightWorkShiftCount: 0, plannedNightWorkShiftFlatValue: 0, 
                            plannedOvertime: 0, plannedOvertimeValue: 0, 
                            plannedOvertimeShiftCount: 0, plannedOvertimeShiftFlatValue: 0,
                            plannedHolidayWorkTime: 0, plannedHolidayWorkValue: 0,  
                            actualIndicatorValue: 0, 
                            actualWorkTime: 0, actualWorkValue: 0,
                            actualOpenWorkTime: 0, actualOpenWorkValue: 0,
                            actualIndicatorWorkTime: 0, actualIndicatorWorkValue: 0,
                            productiveActualWorkTime: 0, productiveActualWorkValue: 0,
                            productiveActualOpenWorkTime: 0, productiveActualOpenWorkValue: 0,
                            productiveActualIndicatorWorkTime: 0, productiveActualIndicatorWorkValue: 0,
                            unproductiveActualWorkTime: 0, unproductiveActualWorkValue: 0,
                            unproductiveActualOpenWorkTime: 0, unproductiveActualOpenWorkValue: 0,
                            unproductiveActualIndicatorWorkTime: 0, unproductiveActualIndicatorWorkValue: 0,
                            actualNightWorkTime: 0, actualNightWorkValue: 0,
                            actualNightWorkShiftCount: 0, actualNightWorkShiftFlatValue: 0, 
                            actualOvertime: 0, actualOvertimeValue: 0,
                            actualOvertimeShiftCount: 0, actualOvertimeShiftFlatValue: 0,
                            actualHolidayWorkTime: 0, actualHolidayWorkValue: 0,
                            vacationWorkTime: 0, vacationWorkValue: 0, 
                            sickWorkTime: 0, sickWorkValue: 0,
                            holidayAdjustWorkTime: 0, holidayAdjustWorkValue: 0,
                            miscWorkTime: 0, miscWorkValue: 0,
                            nursingVacationWorkTime: 0, nursingVacationWorkValue: 0,
                            eduWorkTime: 0, eduWorkValue: 0,
                            wageContinuationWorkTime: 0, wageContinuationWorkValue: 0, 
                            unproductiveWorkTime: 0, unproductiveWorkValue: 0,
                            actualWorkTimeSum: 0, plannedWorkTimeSum: 0,
                            actualWorkValueSum: 0, plannedWorkValueSum: 0,
                            totalWorkValueSum: 0, totalWorkTimeSum: 0,
                            actualWorkValuePercentage: 0, plannedWorkValuePercentage: 0, contractWorkValuePercentage: 0,
                            pWorkTimeDiff: 0, nWorkTimeDiff: 0,
                            pWorkValueDiff: 0, nWorkValueDiff: 0,
                            fixedCostValue: 0};
            
            state.data.forEach(i => {
                summary.plannedIndicatorValue += i.plannedIndicatorValue;
                summary.actualIndicatorValue += i.actualIndicatorValue;

                summary.contractWorkTime += i.contractWorkTime;
                summary.contractWorkValue += i.contractWorkValue;

                summary.plannedWorkTime += i.plannedWorkTime;
                summary.plannedWorkValue += i.plannedWorkValue;

                summary.productivePlannedWorkTime += i.productivePlannedWorkTime;
                summary.productivePlannedWorkValue += i.productivePlannedWorkValue;

                summary.unproductivePlannedWorkTime += (i.plannedWorkTime - i.productivePlannedWorkTime);
                summary.unproductivePlannedWorkValue += (i.plannedWorkValue - i.productivePlannedWorkValue);

                summary.plannedOpenWorkTime += i.plannedOpenWorkTime;
                summary.plannedOpenWorkValue += i.plannedOpenWorkValue;

                summary.productivePlannedOpenWorkTime += i.productivePlannedOpenWorkTime;
                summary.productivePlannedOpenWorkValue += i.productivePlannedOpenWorkValue;

                summary.unproductivePlannedOpenWorkTime += (i.plannedOpenWorkTime - i.productivePlannedOpenWorkTime);
                summary.unproductivePlannedOpenWorkValue += (i.plannedOpenWorkValue - i.productivePlannedOpenWorkValue);

                summary.plannedIndicatorWorkTime += i.plannedIndicatorWorkTime;
                summary.plannedIndicatorWorkValue += i.plannedIndicatorWorkValue;

                summary.productivePlannedIndicatorWorkTime += i.productivePlannedIndicatorWorkTime;
                summary.productivePlannedIndicatorWorkValue += i.productivePlannedIndicatorWorkValue;

                summary.unproductivePlannedIndicatorWorkTime += (i.plannedIndicatorWorkTime - i.productivePlannedIndicatorWorkTime);
                summary.unproductivePlannedIndicatorWorkValue += (i.plannedIndicatorWorkValue - i.productivePlannedIndicatorWorkValue);

                summary.plannedNightWorkTime += i.plannedNightWorkTime;
                summary.plannedNightWorkValue += i.plannedNightWorkValue;

                summary.plannedNightWorkShiftCount += i.plannedNightWorkShiftCount;
                summary.plannedNightWorkShiftFlatValue += i.plannedNightWorkShiftFlatValue;

                summary.plannedOvertime += i.plannedOvertime;
                summary.plannedOvertimeValue += i.plannedOvertimeValue;

                summary.plannedHolidayWorkTime += i.plannedHolidayWorkTime;
                summary.plannedHolidayWorkValue += i.plannedHolidayWorkValue;

                summary.plannedOvertimeShiftCount += i.plannedOvertimeShiftCount;
                summary.plannedOvertimeShiftFlatValue += i.plannedOvertimeShiftFlatValue;

                summary.actualWorkTime += i.actualWorkTime;
                summary.actualWorkValue += i.actualWorkValue;

                summary.productiveActualWorkTime += i.productiveActualWorkTime;
                summary.productiveActualWorkValue += i.productiveActualWorkValue;

                summary.unproductiveActualWorkTime += (i.actualWorkTime - i.productiveActualWorkTime);
                summary.unproductiveActualWorkValue += (i.actualWorkValue - i.productiveActualWorkValue);

                summary.actualOpenWorkTime += i.actualOpenWorkTime;
                summary.actualOpenWorkValue += i.actualOpenWorkValue;

                summary.productiveActualOpenWorkTime += i.productiveActualOpenWorkTime;
                summary.productiveActualOpenWorkValue += i.productiveActualOpenWorkValue;

                summary.unproductiveActualOpenWorkTime += (i.actualOpenWorkTime - i.productiveActualOpenWorkTime);
                summary.unproductiveActualOpenWorkValue += (i.actualOpenWorkValue - i.productiveActualOpenWorkValue);

                summary.actualIndicatorWorkTime += i.actualIndicatorWorkTime;
                summary.actualIndicatorWorkValue += i.actualIndicatorWorkValue;

                summary.productiveActualIndicatorWorkTime += i.productiveActualIndicatorWorkTime;
                summary.productiveActualIndicatorWorkValue += i.productiveActualIndicatorWorkValue;

                summary.unproductiveActualIndicatorWorkTime += (i.actualIndicatorWorkTime - i.productiveActualIndicatorWorkTime);
                summary.unproductiveActualIndicatorWorkValue += (i.actualIndicatorWorkValue - i.productiveActualIndicatorWorkValue);

                summary.actualNightWorkTime += i.actualNightWorkTime;
                summary.actualNightWorkValue += i.actualNightWorkValue;

                summary.actualNightWorkShiftCount += i.actualNightWorkShiftCount;
                summary.actualNightWorkShiftFlatValue += i.actualNightWorkShiftFlatValue;

                summary.actualOvertime += i.actualOvertime;
                summary.actualOvertimeValue += i.actualOvertimeValue;

                summary.actualHolidayWorkTime += i.actualHolidayWorkTime;
                summary.actualHolidayWorkValue += i.actualHolidayWorkValue;

                summary.actualOvertimeShiftCount += i.actualOvertimeShiftCount;
                summary.actualOvertimeShiftFlatValue += i.actualOvertimeShiftFlatValue;

                summary.vacationWorkTime += i.vacationWorkTime;
                summary.vacationWorkValue += i.vacationWorkValue;

                summary.sickWorkTime += i.sickWorkTime;
                summary.sickWorkValue += i.sickWorkValue;

                summary.holidayAdjustWorkTime += i.holidayAdjustWorkTime;
                summary.holidayAdjustWorkValue += i.holidayAdjustWorkValue;

                summary.miscWorkTime += i.miscWorkTime;
                summary.miscWorkValue += i.miscWorkValue;

                summary.nursingVacationWorkTime += i.nursingVacationWorkTime;
                summary.nursingVacationWorkValue += i.nursingVacationWorkValue;

                summary.eduWorkTime += i.eduWorkTime;
                summary.eduWorkValue += i.eduWorkValue;

                summary.wageContinuationWorkTime += i.wageContinuationWorkTime;
                summary.wageContinuationWorkValue += i.wageContinuationWorkValue;

                summary.fixedCostValue += i.fixedCostValue;
                
                summary.unproductiveWorkTime += view.$helpers.calculateCLUnproductiveWorkTimeSum(i, config, view.showPlanned);
                summary.unproductiveWorkValue += view.$helpers.calculateCLUnproductiveWorkValueSum(i, config, view.showPlanned);
                
                summary.plannedWorkTimeSum += view.$helpers.calculateCLWorkTimeSum(i, config, true);
                summary.plannedWorkValueSum += view.$helpers.calculateCLWorkValueSum(i, config, true);
                
                summary.actualWorkTimeSum += view.$helpers.calculateCLWorkTimeSum(i, config, false);
                summary.actualWorkValueSum += view.$helpers.calculateCLWorkValueSum(i, config, false);
                summary.totalWorkTimeSum += (view.$helpers.calculateCLWorkTimeSum(i, config, view.showPlanned) + view.$helpers.calculateCLUnproductiveWorkTimeSum(i, config, view.showPlanned));
                summary.totalWorkValueSum += view.$helpers.calculateCLCrewLaborSum(i, config, view.showPlanned);

                let wt = (view.$helpers.calculateCLWorkTimeSum(i, config, view.showPlanned) + view.$helpers.calculateCLUnproductiveWorkTimeSum(i, config, view.showPlanned));
                let ct = i.contractWorkTime;
                let res = wt - ct ;
                summary.pWorkTimeDiff+= (res >= 0 ? res : 0); 
                summary.nWorkTimeDiff+= (res < 0 ? res : 0); 
                wt = view.$helpers.calculateCLCrewLaborSum(i, config, view.showPlanned);
                ct = i.contractWorkValue;
                res = wt - ct;
                summary.pWorkValueDiff+= (res >= 0 ? res : 0); 
                summary.nWorkValueDiff+= (res < 0 ? res : 0); 
                
            })
            let sumRow = {};
            sumRow.from = {label: this.$t('global.ui.sum'), key: 'from', align: 'center'};
            //PlANNED
            sumRow.contractWorkTime = {label: (summary.contractWorkTime/3600).toFixed(2), key: 'contractWorkTime', align: 'center'};
            sumRow.contractWorkValue = {label: (summary.contractWorkValue/100).toFixed(2), key: 'contractWorkValue', align: 'center'};
            if(this.showPlanned){
                sumRow.contractWorkValuePercentage = {label: summary.plannedIndicatorValue > 0 ?((((summary.contractWorkValue/100)/summary.plannedIndicatorValue)*100).toFixed(2)+' %') : '-', key: 'contractWorkValuePercentage', align: 'center'};
            } else {
                sumRow.contractWorkValuePercentage = {label: summary.actualIndicatorValue > 0 ?((((summary.contractWorkValue/100)/summary.actualIndicatorValue)*100).toFixed(2)+' %') : '-', key: 'contractWorkValuePercentage', align: 'center'};
            }
            

            sumRow.plannedIndicatorValue = {label: view.anonMode ? '-' : (summary.plannedIndicatorValue).toFixed(2), key: 'plannedIndicatorValue', align: 'center'};

            sumRow.plannedWorkTimeSum = {label: (summary.plannedWorkTimeSum/3600).toFixed(2), key: 'plannedWorkTimeSum', align: 'center'};
            sumRow.plannedWorkValueSum = {label: (summary.plannedWorkValueSum/100).toFixed(2), key: 'plannedWorkValueSum', align: 'center'};
            
            sumRow.plannedWorkTime = {label: (summary.plannedWorkTime/3600).toFixed(2), key: 'plannedWorkTime', align: 'center'};
            sumRow.plannedWorkValue = {label: (summary.plannedWorkValue/100).toFixed(2), key: 'plannedWorkValue', align: 'center'};

            sumRow.plannedOpenWorkTime = {label: (summary.plannedOpenWorkTime/3600).toFixed(2), key: 'plannedOpenWorkTime', align: 'center'};
            sumRow.plannedOpenWorkValue = {label: (summary.plannedOpenWorkValue/100).toFixed(2), key: 'plannedOpenWorkValue', align: 'center'};

            sumRow.productivePlannedWorkTime = {label: (summary.productivePlannedWorkTime/3600).toFixed(2), key: 'productivePlannedWorkTime', align: 'center'};
            sumRow.productivePlannedWorkValue = {label: (summary.productivePlannedWorkValue/100).toFixed(2), key: 'productivePlannedWorkValue', align: 'center'};

            sumRow.productivePlannedOpenWorkTime = {label: (summary.productivePlannedOpenWorkTime/3600).toFixed(2), key: 'productivePlannedOpenWorkTime', align: 'center'};
            sumRow.productivePlannedOpenWorkValue = {label: (summary.productivePlannedOpenWorkValue/100).toFixed(2), key: 'productivePlannedOpenWorkValue', align: 'center'};

            sumRow.unproductivePlannedWorkTime = {label: (summary.unproductivePlannedWorkTime/3600).toFixed(2), key: 'unproductivePlannedWorkTime', align: 'center'};
            sumRow.unproductivePlannedWorkValue = {label: (summary.unproductivePlannedWorkValue/100).toFixed(2), key: 'unproductivePlannedWorkValue', align: 'center'};

            sumRow.unproductivePlannedOpenWorkTime = {label: (summary.unproductivePlannedOpenWorkTime/3600).toFixed(2), key: 'unproductivePlannedOpenWorkTime', align: 'center'};
            sumRow.unproductivePlannedOpenWorkValue = {label: (summary.unproductivePlannedOpenWorkValue/100).toFixed(2), key: 'unproductivePlannedOpenWorkValue', align: 'center'};

            sumRow.plannedIndicatorWorkTime = {label: (summary.plannedIndicatorWorkTime/3600).toFixed(2), key: 'plannedIndicatorWorkTime', align: 'center'};
            sumRow.plannedIndicatorWorkValue = {label: (summary.plannedIndicatorWorkValue/100).toFixed(2), key: 'plannedIndicatorWorkValue', align: 'center'};

            sumRow.productivePlannedIndicatorWorkTime = {label: (summary.productivePlannedIndicatorWorkTime/3600).toFixed(2), key: 'productivePlannedIndicatorWorkTime', align: 'center'};
            sumRow.productivePlannedIndicatorWorkValue = {label: (summary.productivePlannedIndicatorWorkValue/100).toFixed(2), key: 'productivePlannedIndicatorWorkValue', align: 'center'};
            
            sumRow.unproductivePlannedIndicatorWorkTime = {label: (summary.unproductivePlannedIndicatorWorkTime/3600).toFixed(2), key: 'unproductivePlannedIndicatorWorkTime', align: 'center'};
            sumRow.unproductivePlannedIndicatorWorkValue = {label: (summary.unproductivePlannedIndicatorWorkValue/100).toFixed(2), key: 'unproductivePlannedIndicatorWorkValue', align: 'center'};
            

            sumRow.plannedHolidayWorkTime = {label: (summary.plannedHolidayWorkTime/3600).toFixed(2), key: 'plannedHolidayWorkTime', align: 'center'};
            sumRow.plannedHolidayWorkValue = {label: (summary.plannedHolidayWorkValue/100).toFixed(2), key: 'plannedHolidayWorkValue', align: 'center'};

            sumRow.plannedNightWorkTime = {label: (summary.plannedNightWorkTime/3600).toFixed(2), key: 'plannedNightWorkTime', align: 'center'};
            sumRow.plannedNightWorkValue = {label: (summary.plannedNightWorkValue/100).toFixed(2), key: 'plannedNightWorkValue', align: 'center'};

            sumRow.plannedNightWorkShiftCount = {label: (summary.plannedNightWorkShiftCount).toFixed(2), key: 'plannedNightWorkShiftCount', align: 'center'};
            sumRow.plannedNightWorkShiftFlatValue = {label: (summary.plannedNightWorkShiftFlatValue/100).toFixed(2), key: 'plannedNightWorkShiftFlatValue', align: 'center'};

            sumRow.plannedOvertime = {label: (summary.plannedOvertime/3600).toFixed(2), key: 'plannedOvertime', align: 'center'};
            sumRow.plannedOvertimeValue = {label: (summary.plannedOvertimeValue/100).toFixed(2), key: 'plannedOvertimeValue', align: 'center'};

            sumRow.plannedOvertimeShiftCount = {label: (summary.plannedOvertimeShiftCount).toFixed(2), key: 'plannedOvertimeShiftCount', align: 'center'};
            sumRow.plannedOvertimeShiftFlatValue = {label: (summary.plannedOvertimeShiftFlatValue/100).toFixed(2), key: 'plannedOvertimeShiftFlatValue', align: 'center'};
            
            
            sumRow.plannedWorkValuePercentage = {label: view.anonMode ? '-' : (summary.plannedIndicatorValue > 0 ?((((summary.totalWorkValueSum/100)/summary.plannedIndicatorValue)*100).toFixed(2)+' %') : '-'), key: 'plannedWorkValuePercentage', align: 'center'};
            
            //ACTUAL
            sumRow.actualIndicatorValue = {label: view.anonMode ? '-' : (summary.actualIndicatorValue).toFixed(2), key: 'actualIndicatorValue', align: 'center'};

            sumRow.actualWorkTimeSum = {label: (summary.actualWorkTimeSum/3600).toFixed(2), key: 'actualWorkTimeSum', align: 'center'};
            sumRow.actualWorkValueSum = {label: (summary.actualWorkValueSum/100).toFixed(2), key: 'actualWorkValueSum', align: 'center'};
            
            sumRow.actualWorkTime = {label: (summary.actualWorkTime/3600).toFixed(2), key: 'actualWorkTime', align: 'center'};
            sumRow.actualWorkValue = {label: (summary.actualWorkValue/100).toFixed(2), key: 'actualWorkValue', align: 'center'};

            sumRow.actualOpenWorkTime = {label: (summary.actualOpenWorkTime/3600).toFixed(2), key: 'actualOpenWorkTime', align: 'center'};
            sumRow.actualOpenWorkValue = {label: (summary.actualOpenWorkValue/100).toFixed(2), key: 'actualOpenWorkValue', align: 'center'};

            sumRow.productiveActualWorkTime = {label: (summary.productiveActualWorkTime/3600).toFixed(2), key: 'productiveActualWorkTime', align: 'center'};
            sumRow.productiveActualWorkValue = {label: (summary.productiveActualWorkValue/100).toFixed(2), key: 'productiveActualWorkValue', align: 'center'};

            sumRow.productiveActualOpenWorkTime = {label: (summary.productiveActualOpenWorkTime/3600).toFixed(2), key: 'productiveActualOpenWorkTime', align: 'center'};
            sumRow.productiveActualOpenWorkValue = {label: (summary.productiveActualOpenWorkValue/100).toFixed(2), key: 'productiveActualOpenWorkValue', align: 'center'};

            sumRow.unproductiveActualWorkTime = {label: (summary.unproductiveActualWorkTime/3600).toFixed(2), key: 'unproductiveActualWorkTime', align: 'center'};
            sumRow.unproductiveActualWorkValue = {label: (summary.unproductiveActualWorkValue/100).toFixed(2), key: 'unproductiveActualWorkValue', align: 'center'};

            sumRow.unproductiveActualOpenWorkTime = {label: (summary.unproductiveActualOpenWorkTime/3600).toFixed(2), key: 'unproductiveActualOpenWorkTime', align: 'center'};
            sumRow.unproductiveActualOpenWorkValue = {label: (summary.unproductiveActualOpenWorkValue/100).toFixed(2), key: 'unproductiveActualOpenWorkValue', align: 'center'};

            sumRow.actualIndicatorWorkTime = {label: (summary.actualIndicatorWorkTime/3600).toFixed(2), key: 'actualIndicatorWorkTime', align: 'center'};
            sumRow.actualIndicatorWorkValue = {label: (summary.actualIndicatorWorkValue/100).toFixed(2), key: 'actualIndicatorWorkValue', align: 'center'};

            sumRow.productiveActualIndicatorWorkTime = {label: (summary.productiveActualIndicatorWorkTime/3600).toFixed(2), key: 'productiveActualIndicatorWorkTime', align: 'center'};
            sumRow.productiveActualIndicatorWorkValue = {label: (summary.productiveActualIndicatorWorkValue/100).toFixed(2), key: 'productiveActualIndicatorWorkValue', align: 'center'};
            
            sumRow.unproductiveActualIndicatorWorkTime = {label: (summary.unproductiveActualIndicatorWorkTime/3600).toFixed(2), key: 'unproductiveActualIndicatorWorkTime', align: 'center'};
            sumRow.unproductiveActualIndicatorWorkValue = {label: (summary.unproductiveActualIndicatorWorkValue/100).toFixed(2), key: 'unproductiveActualIndicatorWorkValue', align: 'center'};
            

            sumRow.actualHolidayWorkTime = {label: (summary.actualHolidayWorkTime/3600).toFixed(2), key: 'actualHolidayWorkTime', align: 'center'};
            sumRow.actualHolidayWorkValue = {label: (summary.actualHolidayWorkValue/100).toFixed(2), key: 'actualHolidayWorkValue', align: 'center'};

            sumRow.actualNightWorkTime = {label: (summary.actualNightWorkTime/3600).toFixed(2), key: 'actualNightWorkTime', align: 'center'};
            sumRow.actualNightWorkValue = {label: (summary.actualNightWorkValue/100).toFixed(2), key: 'actualNightWorkValue', align: 'center'};

            sumRow.actualNightWorkShiftCount = {label: (summary.actualNightWorkShiftCount).toFixed(2), key: 'actualNightWorkShiftCount', align: 'center'};
            sumRow.actualNightWorkShiftFlatValue = {label: (summary.actualNightWorkShiftFlatValue/100).toFixed(2), key: 'actualNightWorkShiftFlatValue', align: 'center'};

            sumRow.actualOvertime = {label: (summary.actualOvertime/3600).toFixed(2), key: 'actualOvertime', align: 'center'};
            sumRow.actualOvertimeValue = {label: (summary.actualOvertimeValue/100).toFixed(2), key: 'actualOvertimeValue', align: 'center'};

            sumRow.actualOvertimeShiftCount = {label: (summary.actualOvertimeShiftCount).toFixed(2), key: 'actualOvertimeShiftCount', align: 'center'};
            sumRow.actualOvertimeShiftFlatValue = {label: (summary.actualOvertimeShiftFlatValue/100).toFixed(2), key: 'actualOvertimeShiftFlatValue', align: 'center'};

            sumRow.actualWorkValuePercentage = {label: view.anonMode ? '-' : (summary.actualIndicatorValue > 0 ?((((summary.totalWorkValueSum/100)/summary.actualIndicatorValue)*100).toFixed(2)+' %') : '-'), key: 'actualWorkValuePercentage', align: 'center'};
            
            //UNPRODUCTIVE
            sumRow.vacationWorkTime = {label: (summary.vacationWorkTime/3600).toFixed(2), key: 'vacationWorkTime', align: 'center'};
            sumRow.vacationWorkValue = {label: (summary.vacationWorkValue/100).toFixed(2), key: 'vacationWorkValue', align: 'center'};

            sumRow.sickWorkTime = {label: (summary.sickWorkTime/3600).toFixed(2), key: 'sickWorkTime', align: 'center'};
            sumRow.sickWorkValue = {label: (summary.sickWorkValue/100).toFixed(2), key: 'sickWorkValue', align: 'center'};

            sumRow.holidayAdjustWorkTime = {label: (summary.holidayAdjustWorkTime/3600).toFixed(2), key: 'holidayAdjustWorkTime', align: 'center'};
            sumRow.holidayAdjustWorkValue = {label: (summary.holidayAdjustWorkValue/100).toFixed(2), key: 'holidayAdjustWorkValue', align: 'center'};

            sumRow.miscWorkTime = {label: (summary.miscWorkTime/3600).toFixed(2), key: 'miscWorkTime', align: 'center'};
            sumRow.miscWorkValue = {label: (summary.miscWorkValue/100).toFixed(2), key: 'miscWorkValue', align: 'center'};

            sumRow.nursingVacationWorkTime = {label: (summary.nursingVacationWorkTime/3600).toFixed(2), key: 'nursingVacationWorkTime', align: 'center'};
            sumRow.nursingVacationWorkValue = {label: (summary.nursingVacationWorkValue/100).toFixed(2), key: 'nursingVacationWorkValue', align: 'center'};

            sumRow.eduWorkTime = {label: (summary.eduWorkTime/3600).toFixed(2), key: 'eduWorkTime', align: 'center'};
            sumRow.eduWorkValue = {label: (summary.eduWorkValue/100).toFixed(2), key: 'eduWorkValue', align: 'center'};

            sumRow.wageContinuationWorkTime = {label: (summary.wageContinuationWorkTime/3600).toFixed(2), key: 'wageContinuationWorkTime', align: 'center'};
            sumRow.wageContinuationWorkValue = {label: (summary.wageContinuationWorkValue/100).toFixed(2), key: 'wageContinuationWorkValue', align: 'center'};

            sumRow.fixedCostValue = {label: (summary.fixedCostValue/100).toFixed(2), key: 'fixedCostValue', align: 'center'};

            sumRow.unproductiveWorkTime = {label: (summary.unproductiveWorkTime/3600).toFixed(2), key: 'unproductiveWorkTime', align: 'center'};
            sumRow.unproductiveWorkValue = {label: (summary.unproductiveWorkValue/100).toFixed(2), key: 'unproductiveWorkValue', align: 'center'};


            sumRow.totalWorkValueSum = {label: (summary.totalWorkValueSum/100).toFixed(2), key: 'totalWorkValueSum', align: 'center'};
            sumRow.totalWorkTimeSum = {label: (summary.totalWorkTimeSum/3600).toFixed(2), key: 'totalWorkTimeSum', align: 'center'};
            sumRow.pWorkTimeDiff = {label: (summary.pWorkTimeDiff/3600).toFixed(2), key: 'pWorkTimeDiff', align: 'center'};
            sumRow.nWorkTimeDiff = {label: (summary.nWorkTimeDiff/3600).toFixed(2), key: 'nWorkTimeDiff', align: 'center'};
            sumRow.pWorkValueDiff = {label: (summary.pWorkValueDiff/100).toFixed(2), key: 'pWorkValueDiff', align: 'center'};
            sumRow.nWorkValueDiff = {label: (summary.nWorkValueDiff/100).toFixed(2), key: 'nWorkValueDiff', align: 'center'};
            

            sumRow.productivity = {label: view.showPlanned ? (summary.plannedWorkTimeSum > 0 ?(summary.plannedIndicatorValue/(Math.round(summary.plannedWorkTimeSum)/3600)).toFixed(2) : '-') : (summary.actualWorkTimeSum > 0 ?(summary.actualIndicatorValue/(Math.round(summary.actualWorkTimeSum)/3600)).toFixed(2) : '-'), key: 'productivity', align: 'center'};

            state.dataSum = [sumRow];
            
            
            return state;
        },
    },
    watch: { 
        storeId: function(val, oldVal) {
            this.refresh(true);
        },
        rosterFromTo(newVal, oldVal) {
            if(newVal != null && this.$store.state.jwt != undefined && this.$store.state.storeId != undefined){
                this.refresh();
            }
        },
    },
  // methods that implement data logic.
    methods: {
        translateDayShort(val) {
            return this.daysShort[val] || "In";
        },
        OpenChartPopup($event){
            let view = this;
            const mainType = this.mainType;
            const config = this.crewLaborConfig ? this.crewLaborConfig : this.defaultCrewLaborConfig;
            let datasetsObject = {
                DisplayLabel: this.hourMode ? 
                    (valueX) => { return valueX.format('HH:mm') }  : 
                    (valueX) => { return valueX.format('DD').substring(0,2) + '.' + valueX.format('MM').substring(0,2) },
                datasetsList: 
                    [{ 
                        text: 'Produktive Arbeitszeit (Soll)', color: '#94b976', toggled: true,
                        dataLoad: (valueX) => { 
                            return (view.$helpers.calculateCLWorkTimeSum(view.dayStatistics[valueX.date() - 1], config, true)/3600).toFixed(2) 
                        }
                    }, { 
                        text: this.$t('roster.comp.actualBubble') + this.$t('roster.comp.actualBubble'), color: '#d54e5c', toggled: true,
                        dataLoad: (valueX) => { 
                            return (view.$helpers.calculateCLWorkTimeSum(view.dayStatistics[valueX.date() - 1], config, false)/3600).toFixed(2) 
                        }
                    }],
                updateChart: () => {}
            };
                    
            let date = this.dateSelectionStart.clone().minutes(0).seconds(0).milliseconds(0);
            let dataPoints = [];
            if(this.hourMode){
                for(let x = 0; x < Object.values(this.statisticsHourMap).length; x++){
                    dataPoints.push(this.$helpers.getMomentTZ().startOf('day').add(x, 'hours'));
                }
            } else {
                for(let x = 0; x < date.daysInMonth(); x++){
                    date.date(x + 1);
                    dataPoints.push(date.clone());
                }
            }

            let groupWorkTime = this.$t('shift.main.group') + ': ' + this.$t('shift.template.workTime');
            let groupCosts = this.$t('shift.main.group') + ': ' + this.$t('workBalance.extraPay.costs');
            let groupKeyFigures = this.$t('shift.main.group') + ': ' + this.$t('roster.view.keyFigure');
            let groupCrewLaborPercent = this.$t('shift.main.group') + ': ' + this.$t('indicator.eval.crewLaborShort') + '%';
            let groupProductivity = this.$t('shift.main.group') + ': ' + this.$t('roster.view.productivity');
            
            this.$helpers.OpenPopup({
                type: 'chartcomponent',
                propContainer: {
                    dataPoints: dataPoints,
                    datasetsInit: datasetsObject,
                    options: {},
                    dataTableState: this.dataTableState,
                    hiddenDataTableKeys: ['from'],
                    dataTableSelectedDefault: {[groupWorkTime]: true},//Object.fromEntries(Object.entries(this.dataTableState.headerMap).map(e => { return [e[0], (e[1].bgcolor === '#FFFF99')]})),
                    //keyDataOverride: {productivity: (row) => {return row.plannedWorkTime}},
                    //keyDisplayOverride: {productivity: (row) => {return row.plannedWorkTime}},
                    axisGroups: {
                      [groupWorkTime]: [
                            this.showPlanned ? 'plannedWorkTimeSum' : 'actualWorkTimeSum',
                            this.showPlanned ? 'plannedWorkTime' : 'actualWorkTime',
                            this.showPlanned ? 'plannedOpenWorkTime' : 'actualOpenWorkTime',
                            this.showPlanned ? 'plannedNightWorkTime' : 'actualNightWorkTime',
                            this.showPlanned ? 'plannedHolidayWorkTime' : 'actualHolidayWorkTime',
                            this.showPlanned ? 'plannedOvertime' : 'actualOvertime',
                            'unproductiveWorkTime',
                            'contractWorkTime',
                            'vacationWorkTime',
                            'sickWorkTime',
                            'holidayAdjustWorkTime',
                            'miscWorkTime',
                            'nursingVacationWorkTime',
                            'eduWorkTime',
                            'wageContinuationWorkTime',
                            'totalWorkTimeSum',
                            ],//Object.entries(this.dataTableState.headerMap).filter(h => h[0].substr(-4) === 'Time').map(h => h[0]),  
                      [groupCosts]: [
                        this.showPlanned ? 'plannedWorkValueSum' : 'actualWorkValueSum',
                        this.showPlanned ? 'plannedWorkValue' : 'actualWorkValue',
                        this.showPlanned ? 'plannedOpenWorkValue' : 'actualOpenWorkValue',
                        this.showPlanned ? 'plannedWorkValue' : 'actualWorkValue',
                        this.showPlanned ? 'plannedNightWorkShiftFlatValue' : 'actualNightWorkShiftFlatValue',
                        this.showPlanned ? 'plannedNightWorkValue' : 'actualNightWorkValue',
                        this.showPlanned ? 'plannedOvertimeValue' : 'actualOvertimeValue',
                        this.showPlanned ? 'plannedOvertimeShiftFlatValue' : 'actualOvertimeShiftFlatValue',
                        this.showPlanned ? 'plannedHolidayWorkValue' : 'actualHolidayWorkValue',
                        'unproductiveWorkValue',
                        'totalWorkValueSum',
                        'contractWorkValue',
                        'vacationWorkValue',
                        'sickWorkValue',
                        'holidayAdjustWorkValue',
                        'miscWorkValue',
                        'nursingVacationWorkValue',
                        'eduWorkValue',
                        'wageContinuationWorkValue',
                      ],//Object.entries(this.dataTableState.headerMap).filter(h => h[0].substr(-5) === 'Value' && h[0] !== 'plannedIndicatorValue' && h[0] !== 'actualIndicatorValue').map(h => h[0]),
                      [groupKeyFigures]: [
                        'plannedIndicatorValue',
                        'actualIndicatorValue',
                      ],
                      [groupCrewLaborPercent]: [
                          this.showPlanned ? 'plannedWorkValuePercentage' : 'actualWorkValuePercentage',
                           'contractWorkValuePercentage'
                       ],  
                      [groupProductivity]: ['productivity'],
                    },
                },
                expanded: true,
                centered: true,
            });
        },
        OpenEditCrewLaborConfigMenu(){
                let view = this;
                let config = this.crewLaborConfig ? this.crewLaborConfig : this.defaultCrewLaborConfig;
                let description = this.$t('indicator.eval.crewLaborCalcQuery') + "<br/>";
                let dataEntries = [];
                let incomeIndicatorItems = Object.values(this.planningIndicatorTypeMap).map(i => {return {label: i.name, value: i.id}});
                let selectedIndicatorItem = config.incomeIndicatorId ? (incomeIndicatorItems.find( i => i.value == config.incomeIndicatorId)) : (view.mainType ? (incomeIndicatorItems.find( i => i.value == view.mainType.id)) : null);

                let productiveWorkTimeItems = [
                    {label: this.$t('indicator.eval.normalWorkTime'), value: 1, selected: config.workValue},
                    
                    {label: this.$t('indicator.eval.openWorkTime'), value: 3, selected: config.openWorkValue},
                    {label: this.$t('indicator.eval.noWorkTime'), value: 4, selected: !config.workValue && !config.workValue},
                ]
                let pselected = productiveWorkTimeItems.find(i => i.selected);

                let holidayWorkTimeItems = [
                    {label: this.$t('workBalance.payroll.holidayWorkTime'), value: 1, selected: config.holidayWorkValue},
                    {label: this.$t('indicator.eval.holidayCompensationWorkTime'), value: 2, selected: config.holidayAdjustWorkValue},
                    {label: this.$t('indicator.eval.noWorkTime'), value: 3, selected: !config.holidayWorkValue && !config.holidayAdjustWorkValue},
                ]
                let hselected = holidayWorkTimeItems.find(i => i.selected);
                dataEntries.push({
                    label: this.$t('store.settings.salesKeyFigure'), key: 'incomeIndicatorId', hidden: false, type: 'dropdownsearch', value: config ? config.incomeIndicatorId:null, selectMultiple: false, flexGroup: false,
                    dropdownSearchState:{
                        toggled: false,
                        displayedItems: [],
                        input: '',
                        items: incomeIndicatorItems,
                        selectMultiple: false,
                        selectFirst: false,
                        selectedItems: [selectedIndicatorItem],
                        selectedItem: selectedIndicatorItem,
                        onceSelected: function ($event, item, searchbar){
                        },
                        styleLight: true,
                        placeholder: this.$t('store.settings.dataSelect'),
                    }
                })
                dataEntries.push({
                    label: this.$t('workBalance.payroll.productiveWorkTime'), key: 'productiveWorkTimeType', hidden: false, type: 'dropdownsearch', value: pselected ? pselected.value : 4, selectMultiple: false, flexGroup: false,
                    dropdownSearchState:{
                        toggled: false,
                        displayedItems: [],
                        input: '',
                        items: productiveWorkTimeItems,
                        selectMultiple: false,
                        selectFirst: false,
                        selectedItems: pselected ? [pselected] : [],
                        selectedItem: pselected ? pselected : {},
                        onceSelected: function ($event, item, searchbar){
                        },
                        styleLight: true,
                        placeholder: this.$t('store.settings.dataSelect'),
                    }
                })
                dataEntries.push({
                    label: this.$t('workBalance.payroll.holidayWorkTime'), key: 'holidayWorkTimeType', hidden: false, type: 'dropdownsearch', value:  hselected ?  hselected.value : 3, selectMultiple: false, flexGroup: false,
                    dropdownSearchState:{
                        toggled: false,
                        displayedItems: [],
                        input: '',
                        items: holidayWorkTimeItems,
                        selectMultiple: false,
                        selectFirst: false,
                        selectedItems: hselected ? [hselected] : [],
                        selectedItem:  hselected ? hselected : {},
                        onceSelected: function ($event, item, searchbar){
                        },
                        styleLight: true,
                        placeholder: this.$t('store.settings.dataSelect'),
                    }
                })
                
                dataEntries.push({label: this.$t('indicator.eval.nightWorkFlat'), key: 'nightWorkShiftFlatValue', hidden: false, type: 'bool', value: config.nightWorkShiftFlatValue});
                dataEntries.push({label: this.$t('workBalance.payroll.nightWorkTime'), key: 'nightWorkValue', hidden: false, type: 'bool', value: config.nightWorkValue});
                dataEntries.push({label: this.$t('indicator.eval.overtimeFlat'), key: 'overtimeShiftFlatValue', hidden: false, type: 'bool', value: config.overtimeShiftFlatValue});
                dataEntries.push({label: this.$t('indicator.eval.dailyOvertime'), key: 'overtimeValue', hidden: false, type: 'bool', value: config.overtimeValue});
                dataEntries.push({label: this.$t('workBalance.summary.vacation'), key: 'vacationWorkValue', hidden: false, type: 'bool', value: config.vacationWorkValue});
                dataEntries.push({label: this.$t('workBalance.summary.nursingLeave'), key: 'nursingVacationWorkValue', hidden: false, type: 'bool', value: config.nursingVacationWorkValue});
                dataEntries.push({label: this.$t('workBalance.summary.sickLeave'), key: 'sickWorkValue', hidden: false, type: 'bool', value: config.sickWorkValue});
                dataEntries.push({label: this.$t('workBalance.summary.trainee'), key: 'eduWorkValue', hidden: false, type: 'bool', value: config.eduWorkValue});
                dataEntries.push({label: this.$t('workBalance.summary.sickPay'), key: 'wageContinuationWorkValue', hidden: false, type: 'bool', value: config.wageContinuationWorkValue});
                dataEntries.push({label: this.$t('workBalance.summary.otherAbsences'), key: 'miscWorkValue', hidden: false, type: 'bool', value: config.miscWorkValue});
                

                view.$helpers.OpenPopup({
                    type: 'datafill',
                    componentState: {
                        entries: dataEntries,
                        description: description,
                        selectCallback: function (data) {
                            let config =  {
                                incomeIndicatorId: data.incomeIndicatorId,
                                holidayWorkValue: data.holidayWorkTimeType == 1,
                                workValue: data.productiveWorkTimeType == 1,
                                openWorkValue: data.productiveWorkTimeType == 3,
                                nightWorkShiftFlatValue: data.nightWorkShiftFlatValue,
                                nightWorkValue: data.nightWorkValue,
                                overtimeShiftFlatValue: data.overtimeShiftFlatValue,
                                overtimeValue: data.overtimeValue,
                                vacationWorkValue: data.vacationWorkValue,
                                sickWorkValue: data.sickWorkValue,
                                holidayAdjustWorkValue: data.holidayWorkTimeType == 2,
                                miscWorkValue: data.miscWorkValue,
                                nursingVacationWorkValue: data.nursingVacationWorkValue,
                                eduWorkValue: data.eduWorkValue,
                                wageContinuationWorkValue:data.wageContinuationWorkValue,

                            }
                            console.log(config);
                            view.saveStatisticsSetting(config)
                            .then(result => {
                                view.$helpers.success(view.$t('global.notifications.success'), view.$t('indicator.eval.settingsEdited'));
                                view.$store.commit('setCrewLaborConfig', {
                                    crewLaborConfig: config
                                });
                                view.refreshStatistics();
                            }) .catch(function (error) {
                                view.$helpers.error(view.$t('global.notifications.error'), view.$t('global.notifications.errorMessage'));
                                console.log(error)
                            });
                            
                           
                        }
                    },
                    header: this.$t('indicator.eval.crewLaborCalculation'),
                    expanded: true,
                    centered: true
                });
        },

        

        refresh: function(force = false) {
            let view = this;
            this.hourMode = false;
            this.loading = true;
            this.crewLaborConfig = null;
            this.$helpers.GetActiveEmployeeMap(force, false, this.storeSettings.hideDeactivatedEmployees)
            .then(map => {
                return  this.$helpers.GetSpotMap(force);
            }).then(map => {
                view.LoadFilterDropdown();
                return view.$helpers.GetPlanningIndicatorTypeMap(force);
            }).then(map => {
                return view.$helpers.GetPlanningEmployeeThresholdMap(force);
            }).then(map => {
                return view.$helpers.GetStatisticsSetting(force);
            }).then(data=>{
                if(view.minuteOffset > 0){
                    return view.loadDailyStatisticsAsHourlyInterval(view.minuteOffset);
                } else {
                    return view.loadDailyStatistics();
                }
                
            }).then(data=>{
                
                view.dayStatistics = data;
                view.$helpers.success(view.$t('global.notifications.success'), view.$t('indicator.eval.statisticsLoaded'));
                view.loading = false;
                
            })
            .catch(function (error) {
                view.$helpers.error(view.$t('global.notifications.error'), view.$t('global.notifications.dataLoadingError'));
                view.loading = false;
                console.log(error)
            });
        },
        refreshStatistics(){
            let view = this;
            this.hourMode = false;
            this.loading = true;
            this.dayStatistics = [];
            let f;
            if(view.minuteOffset > 0){
                f = view.loadDailyStatisticsAsHourlyInterval(view.minuteOffset);
            } else {
                f = view.loadDailyStatistics();
            }
            
            f
            .then(data=>{
                view.dayStatistics = data;
                view.$helpers.success(view.$t('global.notifications.success'), view.$t('indicator.eval.statisticsLoaded'));
                view.loading = false;
            })
            .catch(function (error) {
                view.$helpers.error(view.$t('global.notifications.error'), view.$t('global.notifications.dataLoadingError'));
                view.loading = false;
                console.log(error)
            });
        },

        OpenFilterDropdown($event){
                var view = this;
                var target = $event.currentTarget;


                this.$helpers.OpenPopup({
                    elRelative: target,
                    type: 'list',
                    componentState: {
                        entries: view.filterDropdownOptions,
                    },
                    remainAfterSelect: true,
                    pointerDirection: 0,
                    iconsLeft: true,
                    selectCallback: function($event, item, dropdown){
                        item.toggled = !item.toggled;
                       
                        if(item.all) {
                            view.filterDropdownOptions.forEach(option => {
                                option.toggled = item.toggled;
                            })
                        }
                        view.filterDropdownOptions = view.filterDropdownOptions.slice();
                        view.refreshStatistics();
                    },
                });
        },
        LoadFilterDropdown(){
            
            let filterDropdownOptions = [];
            Object.values(this.spotMap).forEach(function(spot){
                let option =  {label: spot.name, toggled: spot.employeeLevel == 1, color: spot.color, id: spot.id};
                 filterDropdownOptions.push(option); 
            });
            filterDropdownOptions.push({label: this.$t('indicator.eval.notAssigned'), toggled: true, color: "#6d8d23", id: -2});
            filterDropdownOptions.push({label: this.$t('global.ui.all'), toggled: false, all: true, color: "#eeeeee", id: -1});
            this.filterDropdownOptions = filterDropdownOptions;
        },

        OpenDateSelection($event){
            let view = this;
            this.$helpers.OpenDatepickerPopup(
                { viewsEnabled: ['M'], date: this.dateSelectionStart.clone() },
                {
                    OnDateSelect: (date) => { view.onDatePicked(date) },
                },
                { elRelative: $event ? $event.currentTarget : null });
        },
        toggleDatePicker($event) {
            let view = this;
            this.$helpers.OpenDatepickerPopup(
                { viewsEnabled: ['M'], date: this.dateSelectionStart.clone() },
                {
                    OnDateSelect: (date) => { view.setDateSelection(date) },
                },
                { elRelative: $event ? $event.currentTarget : null });
        },
        setDateSelection(date, calculateRosterFromTo){
            let fixedDate = this.$helpers.getMomentTZ().year(date.year()).month(date.month()).date(date.date()).startOf('day');
            this.dateSelectionStart = fixedDate;
            if(this.indicatorDateView) {
                this.indicatorDateView = date.clone();
            } else {
                this.indicatorDateMonth = date.clone().startOf('month');
            }
            if(calculateRosterFromTo){
                //update vuex store with calculated from to => triggers reload of data via refresh
                let rosterFromTo = this.$helpers.CalculateRosterFromTo(date);
                this.$store.commit('setRosterFromTo', {rosterFromTo: rosterFromTo});
            } else {
                //dont update vuex from to, only update client side view
            }
        },
        onDatePicked(date){        
            this.setDateSelection(date, true);
        },
        ToggleHourMode(item){
            let view = this;
            
            let from = this.$helpers.getMomentFromStringTZ(item.from).startOf('day');
            if(this.minuteOffset > 0){
                from = from.add(this.minuteOffset, 'minutes');
            }
            
            let to = from.clone().add(1, 'days').add(-1, 'hours');
            
            view.loading = true;
            this.loadHourlyStatistics(from, to)
            .then(data => {
                view.hourDate = from;
                view.hourStatistics = data;
                view.hourMode = true;
                view.$helpers.success(view.$t('global.notifications.success'), view.$t('indicator.eval.statisticsLoaded'));
                view.loading = false;
            }).catch(function (error) {
                view.$helpers.error(view.$t('global.notifications.error'), view.$t('global.notifications.dataLoadingError'));
                view.loading = false;
                view.hourMode = false;
                view.hourStatistics = [];
                console.log(error)
            });
        },
        loadHourStatisticsFully(from, to, spotIds = null, unassigned = null, typeId = null, employeeLevels = null, data = [], loadingText = false){
            let view = this;
            if(from < to){
                view.loadingText = loadingText ? 'Lade Auswertung: ' + from.format('DD.MM.YYYY HH:mm')+' - '+from.clone().add(1,'days').format('DD.MM.YYYY HH:mm') : '';
                let fromDate = from.clone();
                let toDate = fromDate.clone().add(23, 'hours');
                return view.loadHourlyStatistics(fromDate, toDate, spotIds, unassigned, typeId, employeeLevels)
                    .then(rdata => {
                        data = data.concat(rdata);
                        return view.loadHourStatisticsFully(fromDate.add(24, 'hours'), to, spotIds, unassigned, typeId, employeeLevels, data, loadingText);
                    }).catch(error => {
                        return new Promise((resolve, reject) => {
                            reject(error);
                        })
                    })

            } else {
                return new Promise((resolve, reject) => {
                    view.loadingText = '';
                    resolve(data);
                });
                    
            }
            
            
        },
        loadHourlyStatistics: function(from, to, spotIds = null, unassigned = null, typeId = null, employeeLevels = null){
            let spots;
            if(spotIds == null){
                spots = Object.values(this.spotMap).map(s => s.id).filter(id => this.filterDropdownOptions.filter(o => o.id == id && o.toggled).length > 0);
            } else {
                spots = spotIds;
            }
            
            let el;
            if(employeeLevels == null){
                el = [];
                if(Object.values(this.spotMap).filter(s => s.employeeLevel == 1 && spots.includes(s.id)).length > 0){
                    el.push(1);
                }
                if(Object.values(this.spotMap).filter(s => s.employeeLevel == 2 && spots.includes(s.id)).length > 0){
                    el.push(2);
                }
            } else {
                el = employeeLevels;
            }
            
            let ua = unassigned == null ? this.filterDropdownOptions.filter(o => o.id == -2 && o.toggled).length > 0 : unassigned;
            let type = typeId == null ? this.mainType.id : typeId;

            if((spots.length == 0 && !ua) || type == null || this.rosterFromTo == null){
                return new Promise((resolve, reject) => {
                    resolve([]);
                });
            } else {
                let view = this;
                let url = '/api/sec/statistics/hourly';
                let params = {
                    storeId: this.storeId,
                }
                

                let payload = {
                    from: from.format(),
                    to: to.format(),
                    typeId: type,
                    spotIds: spots,
                    unassigned: ua,
                    employeeLevels: el
                };

                return new Promise((resolve, reject) => {
                   this.axios({
                        method: 'post',
                        headers: {
                            'AUTHORIZATION': "bearer "+this.$store.state.jwt
                        },
                        url: url,
                        params: params,
                        data: payload
                    }).then(response => {
                        //view.$helpers.success('Erfolg', 'Statistiken wurden erfolgreich geladen');
                        resolve(response.data);
                        
                    }).catch(function (error) {
                        
                        reject(error)
                    })
                });
            }
            

        },

        loadDailyStatisticsAsHourlyInterval: function(offset, fromDate = null, toDate = null, spotIds = null, unassigned = null, typeId = null, employeeLevels = null, currentLastHour = null){
            let view = this;
            let spots = spotIds == null ? Object.values(this.spotMap).map(s => s.id).filter(id => this.filterDropdownOptions.filter(o => o.id == id && o.toggled).length > 0) : spotIds;

            
            let from = fromDate == null ? this.$helpers.getMomentFromValuesTZ(this.rosterFromTo.year,this.rosterFromTo.month, 1) : fromDate;
            let to = toDate == null ? from.clone().endOf('month').startOf('day').add(offset, 'minutes') : toDate;

            if(offset != null && offset > 0){
                from = from.add(offset, 'minutes');
                to = to.add(offset, 'minutes');
            }

            let checkCurrentLastHour = currentLastHour != null && currentLastHour > from && currentLastHour < to;
            
            
            let resultMap = {};
            return this.loadHourStatisticsFully(from, to, spots, unassigned, typeId, employeeLevels, [], true)
            .then(data => {
                data.forEach(entry => {
                    let key;
                    let date = view.$helpers.getMomentFromStringTZ(entry.from);
                    if(!checkCurrentLastHour || date < currentLastHour){
                        let baseDate = date.clone().startOf('day');
                        let beforeDate = date.clone().startOf('day').add(-1, 'days');

                        let offsetFrom = baseDate.clone().add(offset, 'minutes');
                        if(date >= offsetFrom){
                            key = baseDate.format();
                        } else {
                            key = beforeDate.format();
                        }

                        if(resultMap[key] == undefined){
                            resultMap[key] = {
                                from: key,
                            };
                            for (let x in entry){
                                if (x != 'from'){
                                    resultMap[key][x] = 0;
                                }
                            }
                        }
                        for (let x in entry){
                            if (x != 'from'){
                                resultMap[key][x] += entry[x];
                            }
                        }
                    }
                    
                    
                
                })
                return new Promise((resolve, reject) => {
                    resolve(Object.values(resultMap));
                });

            }).catch((e) => {
                return new Promise((resolve, reject) => {
                    reject(e);
                });
            });

        },
        
        loadDailyStatistics: function(){
            let spotIds = Object.values(this.spotMap).map(s => s.id).filter(id => this.filterDropdownOptions.filter(o => o.id == id && o.toggled).length > 0);

            let employeeLevels = [];
            if(Object.values(this.spotMap).filter(s => s.employeeLevel == 1 && spotIds.includes(s.id)).length > 0){
                employeeLevels.push(1);
            }
            if(Object.values(this.spotMap).filter(s => s.employeeLevel == 2 && spotIds.includes(s.id)).length > 0){
                employeeLevels.push(2);
            }
            let unassigned = this.filterDropdownOptions.filter(o => o.id == -2 && o.toggled).length > 0
            let from = this.$helpers.getMomentFromValuesTZ(this.rosterFromTo.year,this.rosterFromTo.month, 1);
            let to = from.clone().endOf('month').startOf('day');

            
            let typeId = this.mainType.id

            return this.$helpers.loadDailyStatistics(from, to, spotIds, unassigned, typeId, employeeLevels);
            
            

        },
        loadStatsForYear(spotIds, fromYear, toYear) {
            console.log(fromYear.format());
            console.log(toYear.format());
            let view = this;
            view.loading = true;
            let years = [];
            let yearIter = fromYear.clone().startOf('year');
            while(yearIter <= toYear){
                if(years.find(y => y == yearIter.year()) == undefined){
                    years.push(yearIter.year());
                    
                }
                
                yearIter = yearIter.add(1, 'years');
            }
            years.sort((a, b) => a - b);

            const requests = [];
            for(let i = 0; i < years.length; i++){
                let year = years[i];
                for(let i = 0; i < 12; i++){
                    let from = view.$helpers.getMomentFromValuesTZ(year, i, 1);
                    let to = from.clone().endOf('month').startOf('day');
                    requests.push(() => view.loadDailyStatisticsAndSum(spotIds, from, to));
                }
            }
            
            const makeRequests = (reqs, retryCount = 2) => Promise.allSettled(reqs.map(req => req()))
            .then(results => {
                //console.log(results);
                let needsRetry = false;
                const promises = results.map((result, i) => {
                if (result.status === "rejected") {
                    if (!needsRetry)
                        needsRetry = true;
                        return reqs[i];
                    }
                    return () => Promise.resolve(result);
                });
                if (needsRetry) {
                    if (retryCount > 0) {
                        return makeRequests(promises, retryCount - 1);
                    } else {
                        return Promise.reject(promises);
                    }
                }
                return promises;
            });
            return new Promise((resolve, reject) => {
                makeRequests(requests).then(reqs => {
                    Promise.allSettled(reqs.map(req => req()))
                    .then(results => {
                        
                        let data = [];
                        results.filter(result => result.status === "fulfilled" && result.value.status === "fulfilled")
                        .forEach(res => {
                            data.push(res.value.value);
                        })
                        
                        view.loading = false;
                        resolve(data);
                    });
                }).catch(error => {
                    console.log(error)
                    view.loading = false;
                    view.$helpers.error(view.$t('global.notifications.error'), view.$t('global.notifications.dataLoadingError'));
                     reject(error)
                });
            });
            
        },
        loadDailyStatisticsByDate: function(spotIds, from, to){
            if(spotIds == null){
                spotIds = Object.values(this.spotMap).map(s => s.id).filter(id => this.filterDropdownOptions.filter(o => o.id == id && o.toggled).length > 0);
            }
            
            let employeeLevels = [];
            if(Object.values(this.spotMap).filter(s => s.employeeLevel == 1 && spotIds.includes(s.id)).length > 0){
                employeeLevels.push(1);
            }
            if(Object.values(this.spotMap).filter(s => s.employeeLevel == 2 && spotIds.includes(s.id)).length > 0){
                employeeLevels.push(2);
            }
            let unassigned = this.filterDropdownOptions.filter(o => o.id == -2 && o.toggled).length > 0
            if((spotIds.length == 0 && !unassigned) || this.mainType == null){
                return new Promise((resolve, reject) => {
                    resolve([]);
                });
            } else {
                let view = this;
                let url = '/api/sec/statistics/daily';
                let params = {
                    storeId: this.storeId,
                }
                

                let payload = {
                    from: from.format(),
                    to: to.format(),
                    typeId: this.mainType.id,
                    spotIds: spotIds,
                    unassigned: unassigned,
                    employeeLevels: employeeLevels,
                };

                return new Promise((resolve, reject) => {
                   this.axios({
                        method: 'post',
                        headers: {
                            'AUTHORIZATION': "bearer "+this.$store.state.jwt
                        },
                        url: url,
                        params: params,
                        data: payload
                    }).then(response => {
                        //view.$helpers.success('Erfolg', 'Statistiken wurden erfolgreich geladen');
                        
                        resolve(response.data);
                        
                    }).catch(function (error) {
                        
                        reject(error)
                    })
                });
            }
            

        },
        loadDailyStatisticsAndSum: function(spotIds, from, to){
            return new Promise((resolve, reject) => {
                this.loadDailyStatisticsByDate(spotIds, from, to)
                .then(data => {
                    let sum = {};
                    data.forEach(entry => {
                        for(const key in entry){
                            if(key != 'from'){
                                if(!sum[key]){
                                    sum[key] = entry[key];
                                } else {
                                    sum[key] += entry[key];
                                }
                            }
                        }
                    })
                    sum.from = from.format();
                    resolve(sum)
                        
                }).catch(function (error) {
                        
                    reject(error)
                })
            });
            
        },
        loadHourStatisticsFullyPerEmployee(spotIds = null, from, to, data = []){
            let view = this;
            if(from < to){
               
                let fromDate = from.clone();
                let toDate = fromDate.clone().add(23, 'hours');
                return view.loadHourlyStatisticsPerEmployee(spotIds, fromDate, toDate)
                    .then(rdata => {
                        data = data.concat(rdata);
                        return view.loadHourStatisticsFullyPerEmployee(spotIds, fromDate.add(24, 'hours'), to, data);
                    }).catch(error => {
                        return new Promise((resolve, reject) => {
                            reject(error);
                        })
                    })

            } else {
                return new Promise((resolve, reject) => {
                    resolve(data);
                });
                    
            }
            
            
        },
        loadHourlyStatisticsPerEmployee: function(spotIds = null, from, to){
            if(spotIds == null){
                spotIds = Object.values(this.spotMap).map(s => s.id).filter(id => this.filterDropdownOptions.filter(o => o.id == id && o.toggled).length > 0);
            }
            
            let unassigned = this.filterDropdownOptions.filter(o => o.id == -2 && o.toggled).length > 0
            if((spotIds.length == 0 && !unassigned) || this.mainType == null || this.rosterFromTo == null){
                return new Promise((resolve, reject) => {
                    resolve([]);
                });
            } else {
                let view = this;
                let url = '/api/sec/statistics/peremployee/hourly';
                let params = {
                    storeId: this.storeId,
                }
                

                let payload = {
                    from: from.format(),
                    to:  to.format(),
                    typeId: this.mainType.id,
                    spotIds: spotIds,
                    unassigned: unassigned
                };

                return new Promise((resolve, reject) => {
                   this.axios({
                        method: 'post',
                        headers: {
                            'AUTHORIZATION': "bearer "+this.$store.state.jwt
                        },
                        url: url,
                        params: params,
                        data: payload
                    }).then(response => {
                        //view.$helpers.success('Erfolg', 'Statistiken wurden erfolgreich geladen');
                        resolve(response.data);
                        
                    }).catch(function (error) {
                        
                        reject(error)
                    })
                });
            }
            

        },
        
        loadDailyStatisticsPerEmployee: function(spotIds = null){
            if(spotIds == null){
                spotIds = Object.values(this.spotMap).map(s => s.id).filter(id => this.filterDropdownOptions.filter(o => o.id == id && o.toggled).length > 0);
            }
            
            let unassigned = this.filterDropdownOptions.filter(o => o.id == -2 && o.toggled).length > 0
            if((spotIds.length == 0 && !unassigned) || this.mainType == null || this.rosterFromTo == null){
                return new Promise((resolve, reject) => {
                    resolve([]);
                });
            } else {
                let view = this;
                let url = '/api/sec/statistics/peremployee/daily';
                let params = {
                    storeId: this.storeId,
                }
                let from = this.$helpers.getMomentFromValuesTZ(this.rosterFromTo.year,this.rosterFromTo.month, 1);
                let to = from.clone().endOf('month').startOf('day');

                let payload = {
                    from: from.format(),
                    to: to.format(),
                    typeId: this.mainType.id,
                    spotIds: spotIds,
                    unassigned: unassigned,
                };

                return new Promise((resolve, reject) => {
                   this.axios({
                        method: 'post',
                        headers: {
                            'AUTHORIZATION': "bearer "+this.$store.state.jwt
                        },
                        url: url,
                        params: params,
                        data: payload
                    }).then(response => {
                        //view.$helpers.success('Erfolg', 'Statistiken wurden erfolgreich geladen');
                        resolve(response.data);
                        
                    }).catch(function (error) {
                        
                        reject(error)
                    })
                });
            }
            

        },
        loadStatsForYearPerEmployee(spotIds = null) {
            let view = this;
            view.loading = true;
            const requests = [];
            for(let i = 0; i < 12; i++){
                let from = view.$helpers.getMomentFromValuesTZ(this.rosterFromTo.year, i, 1);
                let to = from.clone().endOf('month').startOf('day');
                requests.push(() => view.loadDailyStatisticsAndSumPerEmployee(spotIds, from, to));
            }
            const makeRequests = (reqs, retryCount = 2) => Promise.allSettled(reqs.map(req => req()))
            .then(results => {
                //console.log(results);
                let needsRetry = false;
                const promises = results.map((result, i) => {
                if (result.status === "rejected") {
                    if (!needsRetry)
                        needsRetry = true;
                        return reqs[i];
                    }
                    return () => Promise.resolve(result);
                });
                if (needsRetry) {
                    if (retryCount > 0) {
                        return makeRequests(promises, retryCount - 1);
                    } else {
                        return Promise.reject(promises);
                    }
                }
                return promises;
            });
            return new Promise((resolve, reject) => {
                makeRequests(requests).then(reqs => {
                    Promise.allSettled(reqs.map(req => req()))
                    .then(results => {
                        
                        let data = [];
                        results.filter(result => result.status === "fulfilled" && result.value.status === "fulfilled")
                        .forEach(res => {
                            data.push(...res.value.value);
                        })
                        
                        view.loading = false;
                        resolve(data);
                    });
                }).catch(error => {
                    console.log(error)
                    view.loading = false;
                    view.$helpers.error(view.$t('global.notifications.error'), view.$t('global.notifications.dataLoadingError'));
                     reject(error)
                });
            });
            
        },
        loadDailyStatisticsByDatePerEmployee: function(spotIds = null, from, to){
            if(spotIds == null){
                spotIds = Object.values(this.spotMap).map(s => s.id).filter(id => this.filterDropdownOptions.filter(o => o.id == id && o.toggled).length > 0);
            }
            
            let unassigned = this.filterDropdownOptions.filter(o => o.id == -2 && o.toggled).length > 0
            if((spotIds.length == 0 && !unassigned) || this.mainType == null){
                return new Promise((resolve, reject) => {
                    resolve([]);
                });
            } else {
                let view = this;
                let url = '/api/sec/statistics/peremployee/daily';
                let params = {
                    storeId: this.storeId,
                }
                

                let payload = {
                    from: from.format(),
                    to: to.format(),
                    typeId: this.mainType.id,
                    spotIds: spotIds,
                    unassigned: unassigned,
                };

                return new Promise((resolve, reject) => {
                   this.axios({
                        method: 'post',
                        headers: {
                            'AUTHORIZATION': "bearer "+this.$store.state.jwt
                        },
                        url: url,
                        params: params,
                        data: payload
                    }).then(response => {
                        //view.$helpers.success('Erfolg', 'Statistiken wurden erfolgreich geladen');
                        
                        resolve(response.data);
                        
                    }).catch(function (error) {
                        
                        reject(error)
                    })
                });
            }
            

        },
        loadDailyStatisticsAndSumPerEmployee: function(spotIds = null, from, to){
            return new Promise((resolve, reject) => {
                this.loadDailyStatisticsByDatePerEmployee(spotIds, from, to)
                .then(data => {
                    let sum = {};
                    data.forEach(entry => {
                        if(!sum[entry.employeeId]){
                            sum[entry.employeeId] = {from: from.format(), employeeName: entry.employeeName, personnelId: entry.personnelId, employeeId: entry.employeeId};
                        }
                        for(const key in entry){
                            if(key != 'from' && key != 'employeeId' && key != 'employeeName' && key != 'personnelId'){
                                if(!sum[entry.employeeId][key]){
                                    sum[entry.employeeId][key] = entry[key];
                                } else {
                                    sum[entry.employeeId][key] += entry[key];
                                }
                            }
                        }
                    })
                    let entries = [];
                    Object.keys(sum).forEach(k => {
                        entries.push(sum[k]);
                    })
                    entries.sort((a, b) => a.employeeName.localeCompare(b.employeeName));
                    resolve(entries)
                        
                }).catch(function (error) {
                        
                    reject(error)
                })
            });
            
        },
        
        saveStatisticsSetting: function(crewLaborConfig){
            let view = this;
            let url = '/api/sec/statisticssetting';
            let params = {
                storeId: this.storeId,
            }
                
            return new Promise((resolve, reject) => {
                view.axios({
                    method: 'post',
                    headers: {
                        'AUTHORIZATION': "bearer "+this.$store.state.jwt
                    },
                    url: url,
                    params: params,
                    data: crewLaborConfig
                }).then(response => {
                    resolve();  
                }).catch(function (error) { 
                    reject(error)
                })
            });
        },

        OpenMenuDetails($event, state){
          let view = this;

          this.$helpers.OpenPopup({
            type: 'burgermenu',
            componentState: state,
            listStyle: true,
            noScroll: true,
            pointerDirection: 0,
            elRelative: $event.currentTarget,
            pointerOffset: -15,
          });
        },
        exportCSV(){
            let date = this.$helpers.getMomentTZ();
            let view = this;
            let csvPre = "data:text/csv;charset=utf-8,";
            let csv = "";
            let headers = [];
            const config = this.crewLaborConfig ? this.crewLaborConfig : this.defaultCrewLaborConfig;
            if(this.showPlanned){
                headers =  [this.$t('store.settings.date'), this.$t('roster.view.keyFigure') + this.$t('indicator.vlh.targetBubbleCaps'),
                            this.$t('workBalance.payroll.productiveWorkTime') + this.$t('indicator.vlh.targetBubbleCaps'), this.$t('workBalance.payroll.productiveWorkTime') + " " + this.$t('workBalance.extraPay.costs') + this.$t('indicator.vlh.targetBubbleCaps'),
                            this.$t('workBalance.payroll.unproductiveWorkTime') + this.$t('indicator.vlh.targetBubbleCaps'), this.$t('indicator.eval.unproductiveWorkTimeCosts') + this.$t('indicator.vlh.targetBubbleCaps'),
                            this.$t('indicator.eval.contractWorkTime'), this.$t('indicator.eval.contractWorkTimeCost'),
                            this.$t('roster.view.productivity') + this.$t('indicator.vlh.targetBubbleCaps'),
                            this.$t('indicator.eval.nightWorkShiftsAmount') + this.$t('indicator.vlh.targetBubbleCaps'), this.$t('indicator.eval.nightWorkFixedCosts') + this.$t('indicator.vlh.targetBubbleCaps'),
                            this.$t('workBalance.payroll.nightWork') + this.$t('indicator.vlh.targetBubbleCaps'), this.$t('indicator.eval.nightWorkCosts') + this.$t('indicator.vlh.targetBubbleCaps'),
                            this.$t('workBalance.payroll.overTimeShifts') + this.$t('indicator.vlh.targetBubbleCaps'), this.$t('indicator.eval.overtimeFlat') + this.$t('indicator.vlh.targetBubbleCaps'),
                            this.$t('workBalance.payroll.overTime') + this.$t('indicator.vlh.targetBubbleCaps'), this.$t('indicator.eval.overtimeCosts') + this.$t('indicator.vlh.targetBubbleCaps'),
                            this.$t('workBalance.payroll.holidayWorkTime') + this.$t('indicator.vlh.targetBubbleCaps'), this.$t('indicator.eval.holidayCosts') + this.$t('indicator.vlh.targetBubbleCaps'),
                            this.$t('indicator.eval.vacationWorkTime'), this.$t('indicator.eval.vacationWorkTimeCosts'),
                            this.$t('indicator.eval.sickLeaveWorkTime'), this.$t('indicator.eval.sickLeaveWorkTimeCosts'),
                            this.$t('indicator.eval.holidayCompensationWorkTime'), this.$t('indicator.eval.holidayCompensationCosts'),
                            this.$t('indicator.eval.otherAbsencesWorkTime'), this.$t('indicator.eval.otherAbsencesWorkTimeCosts'),
                            this.$t('indicator.eval.nursingLeaveWorkTime'), this.$t('indicator.eval.nursingLeaveWorkTimeCosts'),
                            this.$t('indicator.eval.traineeWorkTime'), this.$t('indicator.eval.traineeWorkTimeCosts'),
                            this.$t('indicator.eval.payContinuationWorkTime'), this.$t('indicator.eval.payContinuationCosts'),
                            this.$t('indicator.main.fixCosts'),
                            this.$t('indicator.crew.crewLabor') + this.$t('indicator.vlh.targetBubbleCaps'), this.$t('indicator.eval.crewLaborShort') + "%" + this.$t('indicator.vlh.targetBubbleCaps')
                          ];
                
            } else {
                headers =  [this.$t('store.settings.date'), this.$t('roster.view.keyFigure') + this.$t('roster.comp.actualBubble'),
                            this.$t('workBalance.payroll.productiveWorkTime') + this.$t('roster.comp.actualBubble'), this.$t('workBalance.payroll.productiveWorkTime') + " " + this.$t('workBalance.extraPay.costs') + this.$t('roster.comp.actualBubble'),
                            this.$t('workBalance.payroll.unproductiveWorkTime') + this.$t('roster.comp.actualBubble'), this.$t('indicator.eval.unproductiveWorkTimeCosts') + this.$t('roster.comp.actualBubble'),
                            this.$t('indicator.eval.contractWorkTime'), this.$t('indicator.eval.contractWorkTimeCost'),
                            this.$t('roster.view.productivity') + this.$t('roster.comp.actualBubble'),
                            this.$t('indicator.eval.nightWorkShiftsAmount') + this.$t('roster.comp.actualBubble'), this.$t('indicator.eval.nightWorkFixedCosts') + this.$t('roster.comp.actualBubble'),
                            this.$t('workBalance.payroll.nightWork') + this.$t('roster.comp.actualBubble'), this.$t('indicator.eval.nightWorkCosts') + this.$t('roster.comp.actualBubble'),
                            this.$t('indicator.eval.overtimeShiftsAmount') + this.$t('roster.comp.actualBubble'), this.$t('indicator.eval.overtimeFlat') + this.$t('roster.comp.actualBubble'),
                            this.$t('workBalance.payroll.overTime') + this.$t('roster.comp.actualBubble'), this.$t('indicator.eval.overtimeCosts') + this.$t('roster.comp.actualBubble'),
                            this.$t('workBalance.payroll.holidayWorkTime') + this.$t('roster.comp.actualBubble'), this.$t('indicator.eval.holidayCosts') + this.$t('roster.comp.actualBubble'),
                            this.$t('indicator.eval.vacationWorkTime'), this.$t('indicator.eval.vacationWorkTimeCosts'),
                            this.$t('indicator.eval.sickLeaveWorkTime'), this.$t('indicator.eval.sickLeaveWorkTimeCosts'),
                            this.$t('indicator.eval.holidayCompensationWorkTime'), this.$t('indicator.eval.holidayCompensationCosts'),
                            this.$t('indicator.eval.otherAbsencesWorkTime'), this.$t('indicator.eval.otherAbsencesWorkTimeCosts'),
                            this.$t('indicator.eval.nursingLeaveWorkTime'), this.$t('indicator.eval.nursingLeaveWorkTimeCosts'),
                            this.$t('indicator.eval.traineeWorkTime'), this.$t('indicator.eval.traineeWorkTimeCosts'),
                            this.$t('indicator.eval.payContinuationWorkTime'), this.$t('indicator.eval.payContinuationCosts'),
                            this.$t('indicator.main.fixCosts'),
                            this.$t('indicator.crew.crewLabor') + this.$t('roster.comp.actualBubble'), this.$t('indicator.eval.crewLaborShort') + "%" + this.$t('roster.comp.actualBubble')
                          ];
                
            }
           
            
                
            let filename = this.$t('indicator.main.evaluation') + '_' + this.storeSettings.name + '_' + date.format("DD_MM_YYYY_HH_mm") +  '.csv';
                
            csv += headers.join(";");
            csv += "\n";
            let values = this.hourMode ? Object.values(this.statisticsHourMap) : Object.values(this.statisticsDayMap)
            values.forEach(i => {
                let cur = [];
                if(this.showPlanned){
                    let productiveTime = 0;
                    let productiveValue = 0;
                    let unproductiveTime = 0;
                    let unproductiveValue = 0;

                    if(!config.openWorkValue){
                        productiveTime = i.productivePlannedWorkTime;
                        productiveValue = i.productivePlannedWorkValue;
                        unproductiveTime = i.plannedWorkTime - i.productivePlannedWorkTime;
                        unproductiveValue = i.plannedWorkValue - i.productivePlannedWorkValue;
                    } else if(config.openWorkValue) {
                        productiveTime = i.productivePlannedOpenWorkTime;
                        productiveValue = i.productivePlannedOpenWorkValue;
                        unproductiveTime = i.plannedOpenWorkTime - i.productivePlannedOpenWorkTime;
                        unproductiveValue = i.plannedOpenWorkValue - i.productivePlannedOpenWorkValue;
                    } 
                    cur = [
                            this.$helpers.getMomentFromStringTZ(i.from).format("DD.MM.YYYY HH:mm"),
                            (""+i.plannedIndicatorValue.toFixed(2)).replace(".", ","),
                            (""+(productiveTime/3600).toFixed(2)).replace(".", ","),
                            (""+(productiveValue/100).toFixed(2)).replace(".", ","),
                            (""+(unproductiveTime/3600).toFixed(2)).replace(".", ","),
                            (""+(unproductiveValue/100).toFixed(2)).replace(".", ","),
                            (""+(i.contractWorkTime/3600).toFixed(2)).replace(".", ","),
                            (""+(i.contractWorkValue/100).toFixed(2)).replace(".", ","),
                            (""+(i.plannedWorkTime > 0 ? (i.plannedIndicatorValue/(i.plannedWorkTime/3600)).toFixed(2) : "-")).replace(".", ","),
                            (""+(i.plannedNightWorkShiftCount).toFixed(2)).replace(".", ","),
                            (""+(i.plannedNightWorkShiftFlatValue/100).toFixed(2)).replace(".", ","),
                            (""+(i.plannedNightWorkTime/3600).toFixed(2)).replace(".", ","),
                            (""+(i.plannedNightWorkValue/100).toFixed(2)).replace(".", ","),
                            (""+(i.plannedOvertimeShiftCount).toFixed(2)).replace(".", ","),
                            (""+(i.plannedOvertimeShiftFlatValue/100).toFixed(2)).replace(".", ","),
                            (""+(i.plannedOvertime/3600).toFixed(2)).replace(".", ","),
                            (""+(i.plannedOvertimeValue/100).toFixed(2)).replace(".", ","),
                            (""+(i.plannedHolidayWorkTime/3600).toFixed(2)).replace(".", ","),
                            (""+(i.plannedHolidayWorkValue/100).toFixed(2)).replace(".", ","),
                            (""+(i.vacationWorkTime/3600).toFixed(2)).replace(".", ","),
                            (""+(i.vacationWorkValue/100).toFixed(2)).replace(".", ","),
                            (""+(i.sickWorkTime/3600).toFixed(2)).replace(".", ","),
                            (""+(i.sickWorkValue/100).toFixed(2)).replace(".", ","),
                            (""+(i.holidayAdjustWorkTime/3600).toFixed(2)).replace(".", ","),
                            (""+(i.holidayAdjustWorkValue/100).toFixed(2)).replace(".", ","),
                            (""+(i.miscWorkTime/3600).toFixed(2)).replace(".", ","),
                            (""+(i.miscWorkValue/100).toFixed(2)).replace(".", ","),
                            (""+(i.nursingVacationWorkTime/3600).toFixed(2)).replace(".", ","),
                            (""+(i.nursingVacationWorkValue/100).toFixed(2)).replace(".", ","),
                            (""+(i.eduWorkTime/3600).toFixed(2)).replace(".", ","),
                            (""+(i.eduWorkValue/100).toFixed(2)).replace(".", ","),
                            (""+(i.wageContinuationWorkTime/3600).toFixed(2)).replace(".", ","),
                            (""+(i.wageContinuationWorkValue/100).toFixed(2)).replace(".", ","),
                            (""+(i.fixedCostValue/100).toFixed(2)).replace(".", ","),
                            (""+(view.$helpers.calculateCLCrewLaborSum(i, config, this.showPlanned)/100).toFixed(2)).replace(".", ","),
                            i.plannedIndicatorValue > 0 ? (((view.$helpers.calculateCLCrewLaborSum(i, config, true)/100/i.plannedIndicatorValue)*100).toFixed(2).replace(".", ",")+' %') : '-'
                        ]; 
                    
                } else {
                    let productiveTime = 0;
                    let productiveValue = 0;
                    let unproductiveTime = 0;
                    let unproductiveValue = 0;

                    if(!config.openWorkValue ){
                        productiveTime = i.productiveActualWorkTime;
                        productiveValue = i.productiveActualWorkValue;
                        unproductiveTime = i.actualWorkTime - i.productiveActualWorkTime;
                        unproductiveValue = i.actualWorkValue - i.productiveActualWorkValue;
                    } else {
                        productiveTime = i.productiveActualOpenWorkTime;
                        productiveValue = i.productiveActualOpenWorkValue;
                        unproductiveTime = i.actualOpenWorkTime - i.productiveActualOpenWorkTime;
                        unproductiveValue = i.actualOpenWorkValue - i.productiveActualOpenWorkValue;
                    } 
                    cur = [
                            this.$helpers.getMomentFromStringTZ(i.from).format("DD.MM.YYYY HH:mm"),
                            (""+i.actualIndicatorValue.toFixed(2)).replace(".", ","),
                            (""+(productiveTime/3600).toFixed(2)).replace(".", ","),
                            (""+(productiveValue/100).toFixed(2)).replace(".", ","),
                            (""+(unproductiveTime/3600).toFixed(2)).replace(".", ","),
                            (""+(unproductiveValue/100).toFixed(2)).replace(".", ","),
                            (""+(i.contractWorkTime/3600).toFixed(2)).replace(".", ","),
                            (""+(i.contractWorkValue/100).toFixed(2)).replace(".", ","),
                            (""+(i.actualWorkTime > 0 ? (i.actualIndicatorValue/(i.actualWorkTime/3600)).toFixed(2) : "-")).replace(".", ","),
                            (""+(i.actualNightWorkShiftCount).toFixed(2)).replace(".", ","),
                            (""+(i.actualNightWorkShiftFlatValue/100).toFixed(2)).replace(".", ","),
                            (""+(i.actualNightWorkTime/3600).toFixed(2)).replace(".", ","),
                            (""+(i.actualNightWorkValue/100).toFixed(2)).replace(".", ","),
                            (""+(i.actualOvertimeShiftCount).toFixed(2)).replace(".", ","),
                            (""+(i.actualOvertimeShiftFlatValue/100).toFixed(2)).replace(".", ","),
                            (""+(i.actualOvertime/3600).toFixed(2)).replace(".", ","),
                            (""+(i.actualOvertimeValue/100).toFixed(2)).replace(".", ","),
                            (""+(i.actualHolidayWorkTime/3600).toFixed(2)).replace(".", ","),
                            (""+(i.actualHolidayWorkValue/100).toFixed(2)).replace(".", ","),
                            (""+(i.vacationWorkTime/3600).toFixed(2)).replace(".", ","),
                            (""+(i.vacationWorkValue/100).toFixed(2)).replace(".", ","),
                            (""+(i.sickWorkTime/3600).toFixed(2)).replace(".", ","),
                            (""+(i.sickWorkValue/100).toFixed(2)).replace(".", ","),
                            (""+(i.holidayAdjustWorkTime/3600).toFixed(2)).replace(".", ","),
                            (""+(i.holidayAdjustWorkValue/100).toFixed(2)).replace(".", ","),
                            (""+(i.miscWorkTime/3600).toFixed(2)).replace(".", ","),
                            (""+(i.miscWorkValue/100).toFixed(2)).replace(".", ","),
                            (""+(i.nursingVacationWorkTime/3600).toFixed(2)).replace(".", ","),
                            (""+(i.nursingVacationWorkValue/100).toFixed(2)).replace(".", ","),
                            (""+(i.eduWorkTime/3600).toFixed(2)).replace(".", ","),
                            (""+(i.eduWorkValue/100).toFixed(2)).replace(".", ","),
                            (""+(i.wageContinuationWorkTime/3600).toFixed(2)).replace(".", ","),
                            (""+(i.wageContinuationWorkValue/100).toFixed(2)).replace(".", ","),
                            (""+(i.fixedCostValue/100).toFixed(2)).replace(".", ","),
                            (""+(view.$helpers.calculateCLCrewLaborSum(i, config, this.showPlanned)/100).toFixed(2)).replace(".", ","),
                            i.actualIndicatorValue > 0 ? (((view.$helpers.calculateCLCrewLaborSum(i, config, false)/100/i.actualIndicatorValue)*100).toFixed(2).replace(".", ",")+' %') : '-'
                        ];
                    
                }
                 
                
                csv += cur.join(";");
                csv += "\n";
            })

            let encodedUri = encodeURI(csvPre) + "\uFEFF" +  encodeURIComponent(csv);
 
            var link = document.createElement("a");
            link.setAttribute("href", encodedUri);
            link.setAttribute("download", filename);
            document.body.appendChild(link); // Required for FF

            link.click();
        },
        // PDF
        PdfHourlyReportPopup() {
          let view = this;
          let actual = !this.showPlanned;

          this.OpenPdfSettingsPopup({currentTarget: null}, true, false, false, false, false, (pdfSettings) => {
            view.loading = true;
            view.loadHourStatisticsFully(pdfSettings.spotIds, pdfSettings.dayFrom, pdfSettings.dayTo.clone().add(1, 'days'), [])
            .then(values => {
                view.loading = false;
                view.generatePdfReport(pdfSettings, values, actual, 3);
            }).catch(error => {
                console.log(error)
                view.loading = false;
                view.$helpers.error(view.$t('global.notifications.error'), view.$t('global.notifications.dataLoadingError'));
            })
          });
        },
        PdfDailyReportPopup() {
          let view = this;
          let actual = !this.showPlanned;

          this.OpenPdfSettingsPopup({currentTarget: null}, false, true, false, false, false, (pdfSettings) => {
            view.loadDailyStatisticsByDate(pdfSettings.spotIds, pdfSettings.dayFrom, pdfSettings.dayTo.clone())
            .then(values => {
                view.loading = false;
                view.generatePdfReport(pdfSettings, values, actual);
            }).catch(error => {
                console.log(error)
                view.loading = false;
                view.$helpers.error(view.$t('global.notifications.error'), view.$t('global.notifications.dataLoadingError'));
            })
            
          });
        },
        PdfWeekReportPopup() {
          let view = this;
          let actual = !this.showPlanned;

          this.OpenPdfSettingsPopup({currentTarget: null}, false, false, true, false, false, (pdfSettings) => {
            view.loading = true;
            view.loadDailyStatisticsByDate(pdfSettings.spotIds, pdfSettings.week.from, pdfSettings.week.to.clone().add(-1,'days'))
            .then(values => {
                view.loading = false;
                view.generatePdfReport(pdfSettings, values, actual, 2);
            }).catch(error => {
                console.log(error)
                view.loading = false;
                view.$helpers.error(view.$t('global.notifications.error'), view.$t('global.notifications.dataLoadingError'));
            })
          });
        },
        PdfYearReportPopup() {
          let view = this;
          let actual = !this.showPlanned;

          this.OpenPdfSettingsPopup({currentTarget: null}, false, false, false, true, false, (pdfSettings) => {
            view.loadStatsForYear(pdfSettings.spotIds, pdfSettings.yearFrom, pdfSettings.yearTo)
            .then(values => {
                view.generatePdfReport(pdfSettings, values, actual, 1);
            })
          });
        },
        PdfHourlyReportPerEmployeePopup() {
          let view = this;
          let actual = !this.showPlanned;

          this.OpenPdfSettingsPopup({currentTarget: null}, true, false, false, false, true, (pdfSettings) => {
            view.loading = true;
            view.loadHourStatisticsFullyPerEmployee(pdfSettings.spotIds, pdfSettings.dayFrom, pdfSettings.dayTo.clone().add(1, 'days'), [])
            .then(values => {
                view.loading = false;
                let filteredValues = values;
                if(!pdfSettings.allEmployees){
                    filteredValues = values.filter(v => pdfSettings.employees.includes(v.employeeId));
                }
                view.generatePdfReport(pdfSettings, filteredValues, actual, 3);
            }).catch(error => {
                console.log(error)
                view.loading = false;
                view.$helpers.error(view.$t('global.notifications.error'), view.$t('global.notifications.dataLoadingError'));
            })
          });
        },
        PdfDailyReportPerEmployeePopup() {
          let view = this;
          let actual = !this.showPlanned;

          this.OpenPdfSettingsPopup({currentTarget: null}, false, true, false, false, true, (pdfSettings) => {
            view.loading = true;
            view.loadDailyStatisticsByDatePerEmployee(pdfSettings.spotIds, pdfSettings.dayFrom, pdfSettings.dayTo)
            .then(values => {
                view.loading = false;
                let filteredValues = values;
                if(!pdfSettings.allEmployees){
                    filteredValues = values.filter(v => pdfSettings.employees.includes(v.employeeId));
                }
                view.generatePdfReport(pdfSettings, filteredValues, actual);
            }).catch(error => {
                console.log(error)
                view.loading = false;
                view.$helpers.error(view.$t('global.notifications.error'), view.$t('global.notifications.dataLoadingError'));
            })
          });
        },
        PdfWeekReportPerEmployeePopup() {
          let view = this;
          let actual = !this.showPlanned;

          this.OpenPdfSettingsPopup({currentTarget: null}, false, false, true, false, true, (pdfSettings) => {
            view.loading = true;
            view.loadDailyStatisticsByDatePerEmployee(pdfSettings.spotIds, pdfSettings.week.from, pdfSettings.week.to.clone().add(-1,'days'))
            .then(values => {
                view.loading = false;
                let filteredValues = values;
                if(!pdfSettings.allEmployees){
                    filteredValues = values.filter(v => pdfSettings.employees.includes(v.employeeId));
                }
                view.generatePdfReport(pdfSettings, filteredValues, actual, 2);
            }).catch(error => {
                console.log(error)
                view.loading = false;
                view.$helpers.error(view.$t('global.notifications.error'), view.$t('global.notifications.dataLoadingError'));
            })
          });
        },
        PdfYearReportPerEmployeePopup() {
          let view = this;
          let actual = !this.showPlanned;

          this.OpenPdfSettingsPopup({currentTarget: null}, false, false, false, true, true, (pdfSettings) => {
            view.loading = true;
            view.loadStatsForYearPerEmployee(pdfSettings.spotIds)
            .then(values => {
                view.loading = false;
                let filteredValues = values;
                if(!pdfSettings.allEmployees){
                    filteredValues = values.filter(v => pdfSettings.employees.includes(v.employeeId));
                }
                view.generatePdfReport(pdfSettings, filteredValues, actual, 1);
            })
          });
        },
        OpenPdfSettingsPopup($event, hourly = false, daily = false, weekly = false, yearly = false,peremployee = false, createCallback) {
          const config = this.crewLaborConfig ? this.crewLaborConfig : this.defaultCrewLaborConfig;
          
          let spotItems = Object.values(this.spotMap).map(spot => {return {label: spot.name, value: spot.id, selected: spot.employeeLevel == 1}});

          let dataEntries = [
                {label: this.$t('store.settings.date'), key: 'date', hidden: true, disabled: true, type: 'bool', value: true},
                {label: this.$tc('store.structure.spot', 2), key: 'spotIds', hidden: false, type: 'dropdownsearch', value: null, dropdownSearchState:{
                            toggled: false,
                            displayedItems: [],
                            input: '',
                            items: spotItems,
                            selectMultiple: true,
                            selectedItems: spotItems.filter(item => item.selected),
                            styleLight: true,
                }},
                {label: this.$t('pages.employeeCoreData.personnelNumber') + " ", key: 'personnelId', hidden: peremployee ? false : true, disabled: false, type: 'bool', value: peremployee ? true : false},
                {label: "Mitarbeiter Name" + " ", key: 'employeeName', hidden: peremployee ? false : true, disabled: true, type: 'bool', value: peremployee ? true : false}
            ];
          if(this.showPlanned){
            dataEntries = dataEntries.concat([
                {label: this.$t('indicator.crew.crewLabor') + this.$t('indicator.vlh.targetBubbleCaps'), key: 'plannedCrewLaborSum', hidden: peremployee ? true : false, disabled: false, type: 'bool', value: false},
                {label: this.$t('indicator.crew.crewLabor') + " %", key: 'plannedCrewLaborPercentage', hidden: peremployee ? true : false, disabled: false, type: 'bool', value: false},
                {label: this.$t('roster.view.keyFigure') + this.$t('indicator.vlh.targetBubbleCaps'), key: 'plannedIndicatorValue', hidden: peremployee ? true : false, disabled: false, type: 'bool', value: false},
                
                {label: this.$t('shift.template.workTime') + this.$t('indicator.vlh.targetBubbleCaps'), key: 'plannedWorkTime', hidden: false, disabled: false, type: 'bool', value: true},
                {label: this.$t('indicator.eval.workTimeCosts') + this.$t('indicator.vlh.targetBubbleCaps'), key: 'plannedWorkValue', hidden: false, disabled: false, type: 'bool', value: true},

                {label: this.$t('workBalance.payroll.productiveWorkTime') + this.$t('indicator.vlh.targetBubbleCaps'), key: 'productivePlannedWorkTime', hidden: !config.workValue, disabled: false, type: 'bool', value: false},
                {label: this.$t('workBalance.payroll.productiveWorkTime') + " " + this.$t('workBalance.extraPay.costs') + this.$t('indicator.vlh.targetBubbleCaps'), key: 'productivePlannedWorkValue', hidden: !config.workValue, disabled: false, type: 'bool', value: false},

                {label: this.$t('indicator.eval.openProductiveWorkTime') + this.$t('indicator.vlh.targetBubbleCaps'), key: 'productivePlannedOpenWorkTime', hidden: !config.openWorkValue, disabled: false, type: 'bool', value: false},
                {label: this.$t('indicator.eval.openProductiveWorkTime') + " " + this.$t('workBalance.extraPay.costs') + this.$t('indicator.vlh.targetBubbleCaps'), key: 'productivePlannedOpenWorkValue', hidden: !config.openWorkValue, disabled: false, type: 'bool', value: false},
                
               
                {label: this.$t('indicator.eval.contractWorkTime'), key: 'contractWorkTime', hidden: false, disabled: false, type: 'bool', value: false},
                {label: this.$t('indicator.eval.contractWorkTimeCost'), key: 'contractWorkValue', hidden: false, disabled: false, type: 'bool', value: false},
                {label: this.$t('roster.view.productivity') + this.$t('indicator.vlh.targetBubbleCaps'), key: 'plannedProductivity', hidden: peremployee ? true : false, disabled: false, type: 'bool', value: false},
                {label: this.$t('indicator.eval.nightWorkShiftsAmount') + this.$t('indicator.vlh.targetBubbleCaps'), key: 'plannedNightWorkShiftCount', hidden: false, disabled: false, type: 'bool', value: false},
                {label: this.$t('indicator.eval.nightWorkFixedCosts') + this.$t('indicator.vlh.targetBubbleCaps'), key: 'plannedNightWorkShiftFlatValue', hidden: false, disabled: false, type: 'bool', value: false},
                {label: this.$t('workBalance.payroll.nightWork') + this.$t('indicator.vlh.targetBubbleCaps'), key: 'plannedNightWorkTime', hidden: false, disabled: false, type: 'bool', value: false},
                {label: this.$t('indicator.eval.nightWorkCosts') + this.$t('indicator.vlh.targetBubbleCaps'), key: 'plannedNightWorkValue', hidden: false, disabled: false, type: 'bool', value: false},
                {label: this.$t('workBalance.payroll.overTimeShifts') + this.$t('indicator.vlh.targetBubbleCaps'), key: 'plannedOvertimeShiftCount', hidden: false, disabled: false, type: 'bool', value: false},
                {label: this.$t('indicator.eval.overtimeFlat') + this.$t('indicator.vlh.targetBubbleCaps'), key: 'plannedOvertimeShiftFlatValue', hidden: false, disabled: false, type: 'bool', value: false},
                {label: this.$t('workBalance.payroll.overTime') + this.$t('indicator.vlh.targetBubbleCaps'), key: 'plannedOvertime', hidden: false, disabled: false, type: 'bool', value: false},
                {label: this.$t('indicator.eval.overtimeCosts') + this.$t('indicator.vlh.targetBubbleCaps'), key: 'plannedOvertimeValue', hidden: false, disabled: false, type: 'bool', value: false},
                {label: this.$t('workBalance.payroll.holidayWorkTime') + this.$t('indicator.vlh.targetBubbleCaps'), key: 'plannedHolidayWorkTime', hidden: false, disabled: false, type: 'bool', value: false},
                {label: this.$t('indicator.eval.holidayCosts') + this.$t('indicator.vlh.targetBubbleCaps'), key: 'plannedHolidayWorkValue', hidden: false, disabled: false, type: 'bool', value: false},
                
                {label: this.$t('workBalance.payroll.unproductiveWorkTime') + this.$t('indicator.vlh.targetBubbleCaps'), key: 'plannedUnproductiveWorkTime', hidden: false, disabled: false, type: 'bool', value: false},
                {label: this.$t('workBalance.payroll.unproductiveQuota'), key: 'unproductiveWorkPercentage', hidden: false, disabled: false, type: 'bool', value: false},
            ]);
          } else {
            dataEntries = dataEntries.concat([
                {label: this.$t('indicator.crew.crewLabor') + this.$t('roster.comp.actualBubble'), key: 'actualCrewLaborSum', hidden: peremployee ? true : false, disabled: false, type: 'bool', value: false},
                {label: this.$t('indicator.crew.crewLabor') + "%" + this.$t('roster.comp.actualBubble'), key: 'actualCrewLaborPercentage', hidden: peremployee ? true : false, disabled: false, type: 'bool', value: false},
                {label: this.$t('roster.view.keyFigure') + this.$t('roster.comp.actualBubble'), key: 'actualIndicatorValue', hidden: peremployee ? true : false, disabled: false, type: 'bool', value: false},
                {label: this.$t('shift.template.workTime') + this.$t('roster.comp.actualBubble'), key: 'actualWorkTime', hidden: false, disabled: false, type: 'bool', value: true},
                {label: this.$t('indicator.eval.workTimeCosts') + this.$t('roster.comp.actualBubble'), key: 'actualWorkValue', hidden: false, disabled: false, type: 'bool', value: true},
                
                {label: this.$t('workBalance.payroll.productiveWorkTime') + this.$t('roster.comp.actualBubble'), key: 'productiveActualWorkTime', hidden: !config.workValue, disabled: false, type: 'bool', value: false},
                {label: this.$t('workBalance.payroll.productiveWorkTime') + " " + this.$t('workBalance.extraPay.costs') + this.$t('roster.comp.actualBubble'), key: 'productiveActualWorkValue', hidden: !config.workValue, disabled: false, type: 'bool', value: false},
                
                {label: this.$t('indicator.eval.openProductiveWorkTime') + this.$t('roster.comp.actualBubble'), key: 'productiveActualOpenWorkTime', hidden: !config.openWorkValue, disabled: false, type: 'bool', value: false},
                {label: this.$t('indicator.eval.openProductiveWorkTime') + " " + this.$t('workBalance.extraPay.costs') + this.$t('roster.comp.actualBubble'), key: 'productiveActualOpenWorkValue', hidden: !config.openWorkValue, disabled: false, type: 'bool', value: false},
                
                
                {label: this.$t('indicator.eval.contractWorkTime'), key: 'contractWorkTime', hidden: false, disabled: false, type: 'bool', value: false},
                {label: this.$t('indicator.eval.contractWorkTimeCost'), key: 'contractWorkValue', hidden: false, disabled: false, type: 'bool', value: false},
                {label: this.$t('roster.view.productivity') + this.$t('roster.comp.actualBubble'), key: 'actualProductivity', hidden: peremployee ? true : false, disabled: false, type: 'bool', value: false},
                {label: this.$t('indicator.eval.nightWorkShiftsAmount') + this.$t('roster.comp.actualBubble'), key: 'actualNightWorkShiftCount', hidden: false, disabled: false, type: 'bool', value: false},
                {label: this.$t('indicator.eval.nightWorkFixedCosts') + this.$t('roster.comp.actualBubble'), key: 'actualNightWorkShiftFlatValue', hidden: false, disabled: false, type: 'bool', value: false},
                {label: this.$t('workBalance.payroll.nightWork') + this.$t('roster.comp.actualBubble'), key: 'actualNightWorkTime', hidden: false, disabled: false, type: 'bool', value: false},
                {label: this.$t('indicator.eval.nightWorkCosts') + this.$t('roster.comp.actualBubble'), key: 'actualNightWorkValue', hidden: false, disabled: false, type: 'bool', value: false},
                {label: this.$t('indicator.eval.overtimeShiftsAmount') + this.$t('roster.comp.actualBubble'), key: 'actualOvertimeShiftCount', hidden: false, disabled: false, type: 'bool', value: false},
                {label: this.$t('indicator.eval.overtimeFlat') + this.$t('roster.comp.actualBubble'), key: 'actualOvertimeShiftFlatValue', hidden: false, disabled: false, type: 'bool', value: false},
                {label: this.$t('workBalance.payroll.overTime') + this.$t('roster.comp.actualBubble'), key: 'actualOvertime', hidden: false, disabled: false, type: 'bool', value: false},
                {label: this.$t('indicator.eval.overtimeCosts') + this.$t('roster.comp.actualBubble'), key: 'actualOvertimeValue', hidden: false, disabled: false, type: 'bool', value: false},
                {label: this.$t('workBalance.payroll.holidayWorkTime') + this.$t('roster.comp.actualBubble'), key: 'actualHolidayWorkTime', hidden: false, disabled: false, type: 'bool', value: false},
                {label: this.$t('indicator.eval.holidayCosts') + this.$t('roster.comp.actualBubble'), key: 'actualHolidayWorkValue', hidden: false, disabled: false, type: 'bool', value: false},
                
                {label: this.$t('workBalance.payroll.unproductiveWorkTime') + this.$t('roster.comp.actualBubble'), key: 'actualUnproductiveWorkTime', hidden: false, disabled: false, type: 'bool', value: false},
                {label: this.$t('workBalance.payroll.unproductiveQuota'), key: 'unproductiveWorkPercentage', hidden: false, disabled: false, type: 'bool', value: false},
            ]);
          }

          dataEntries = dataEntries.concat([
                {label: this.$t('indicator.eval.vacationWorkTime'), key: 'vacationWorkTime', hidden: false, disabled: false, type: 'bool', value: false},
                {label: this.$t('indicator.eval.vacationWorkTimeCosts'), key: 'vacationWorkValue', hidden: false, disabled: false, type: 'bool', value: false},
                {label: this.$t('workBalance.payroll.vacationQuota'), key: 'vacationWorkPercentage', hidden: false, disabled: false, type: 'bool', value: false},
                
                {label: this.$t('indicator.eval.sickLeaveWorkTime'), key: 'sickWorkTime', hidden: false, disabled: false, type: 'bool', value: false},
                {label: this.$t('indicator.eval.sickLeaveWorkTimeCosts'), key: 'sickWorkValue', hidden: false, disabled: false, type: 'bool', value: false},
                {label: this.$t('workBalance.payroll.sickDaysQuota'), key: 'sickWorkPercentage', hidden: false, disabled: false, type: 'bool', value: false},
                
                {label: this.$t('indicator.eval.holidayCompensationWorkTime'), key: 'holidayAdjustWorkTime', hidden: false, disabled: false, type: 'bool', value: false},
                {label: this.$t('indicator.eval.holidayCompensationWorkTimeCosts'), key: 'holidayAdjustWorkValue', hidden: false, disabled: false, type: 'bool', value: false},
                {label: this.$t('indicator.eval.holidayCompensationQuota'), key: 'holidayAdjustWorkPercentage', hidden: false, disabled: false, type: 'bool', value: false},
                
                {label: this.$t('indicator.eval.otherAbsencesWorkTime'), key: 'miscWorkTime', hidden: false, disabled: false, type: 'bool', value: false},
                {label: this.$t('indicator.eval.otherAbsencesWorkTimeCosts'), key: 'miscWorkValue', hidden: false, disabled: false, type: 'bool', value: false},
                {label: this.$t('indicator.eval.otherAbsencesQuota'), key: 'miscWorkPercentage', hidden: false, disabled: false, type: 'bool', value: false},
                
                {label: this.$t('indicator.eval.nursingLeaveWorkTime'), key: 'nursingVacationWorkTime', hidden: false, disabled: false, type: 'bool', value: false},
                {label: this.$t('indicator.eval.nursingLeaveWorkTimeCosts'), key: 'nursingVacationWorkValue', hidden: false, disabled: false, type: 'bool', value: false},
                {label: this.$t('workBalance.payroll.nursingLeaveQuota'), key: 'nursingVacationWorkPercentage', hidden: false, disabled: false, type: 'bool', value: false},
                
                {label: this.$t('indicator.eval.traineeWorkTime'), key: 'eduWorkTime', hidden: false, disabled: false, type: 'bool', value: false},
                {label: this.$t('indicator.eval.traineeWorkTimeCosts'), key: 'eduWorkValue', hidden: false, disabled: false, type: 'bool', value: false},
                {label: this.$t('workBalance.payroll.traineeQuota'), key: 'eduWorkPercentage', hidden: false, disabled: false, type: 'bool', value: false},
                
                {label: this.$t('indicator.eval.payContinuationWorkTime'), key: 'wageContinuationWorkTime', hidden: false, disabled: false, type: 'bool', value: false},
                {label: this.$t('indicator.eval.payContinuationCosts'), key: 'wageContinuationWorkValue', hidden: false, disabled: false, type: 'bool', value: false},
                {label: this.$t('workBalance.payroll.sickPayQuota'), key: 'wageContinuationWorkPercentage', hidden: false, disabled: false, type: 'bool', value: false},

                {label: this.$t('indicator.main.fixCosts'), key: 'fixedCostValue', hidden: peremployee ? true : false, disabled: false, type: 'bool', value: false}
            ]);
          
          
          if(weekly){
            let weekItems = [];
            let from = this.$helpers.getMomentFromStringTZ(this.rosterFromTo.from);
            let to = this.$helpers.getMomentFromStringTZ(this.rosterFromTo.to);
            while(from < to){
                let tempFrom = from.clone();
                let tempTo = from.clone().add(7, 'days');
                weekItems.push({label: "KW "+tempFrom.isoWeek()+" "+tempFrom.format('DD.MM.YYYY')+" - "+tempTo.format('DD.MM.YYYY'), value: {from: tempFrom, to: tempTo}});
                
                from = from.add(7, 'days');
            }
            dataEntries.unshift({
                    label: this.$t('roster.comp.week'), key: 'week', hidden: false, type: 'dropdownsearch', value:  null, selectMultiple: false, flexGroup: false,
                    dropdownSearchState:{
                        toggled: false,
                        displayedItems: [],
                        input: '',
                        items: weekItems,
                        selectMultiple: false,
                        selectFirst: true,
                        onceSelected: function ($event, item, searchbar){
                        },
                        styleLight: true,
                        placeholder: this.$t('indicator.eval.selectWeek'),
                    }
                })

          } else if(hourly || daily) {
            let dayItems = [];
            let from = this.$helpers.getMomentFromValuesTZ(this.rosterFromTo.year, this.rosterFromTo.month, 1);
            let to = from.clone().endOf('month').startOf('day');
            while(from < to){
                let tempFrom = from.clone();
                
                dayItems.push({label: tempFrom.format('DD.MM.YYYY'), value: tempFrom});
                
                from = from.add(1, 'days');
            }
            dayItems.push({label: to.format('DD.MM.YYYY'), value: to});
            dataEntries.unshift({
                    label: this.$t('global.general.toDay'), key: 'dayTo', hidden: false, type: 'dropdownsearch', value:  null, selectMultiple: false, flexGroup: false,
                    dropdownSearchState:{
                        toggled: false,
                        displayedItems: [],
                        input: '',
                        items: dayItems,
                        selectMultiple: false,
                        selectLast: true,
                        onceSelected: function ($event, item, searchbar){
                        },
                        styleLight: true,
                        placeholder: this.$t('indicator.eval.selectDay'),
                    }
                })
            dataEntries.unshift({
                    label: this.$t('global.general.fromDay'), key: 'dayFrom', hidden: false, type: 'dropdownsearch', value:  null, selectMultiple: false, flexGroup: false,
                    dropdownSearchState:{
                        toggled: false,
                        displayedItems: [],
                        input: '',
                        items: dayItems,
                        selectMultiple: false,
                        selectFirst: true,
                        onceSelected: function ($event, item, searchbar){
                        },
                        styleLight: true,
                        placeholder: this.$t('indicator.eval.selectDay'),
                    }
                })
          } else if(!peremployee && yearly){
            let yearItems = [];
            let from = this.$helpers.getMomentFromStringTZ(this.storeSettings.usageStartDate).startOf('year');
            let to = this.$helpers.getMomentTZ().startOf('year');
            while(from < to){
                let tempFrom = from.clone();
                
                yearItems.push({label: tempFrom.format('YYYY'), value: tempFrom});
                
                from = from.add(1, 'years');
            }
            yearItems.push({label: to.format('YYYY'), value: to});
            dataEntries.unshift({
                    label: this.$t('indicator.eval.toYear'), key: 'yearTo', hidden: false, type: 'dropdownsearch', value:  null, selectMultiple: false, flexGroup: false,
                    dropdownSearchState:{
                        toggled: false,
                        displayedItems: [],
                        input: '',
                        items: yearItems,
                        selectMultiple: false,
                        selectLast: true,
                        onceSelected: function ($event, item, searchbar){
                        },
                        styleLight: true,
                        placeholder: this.$t('indicator.eval.selectYear'),
                    }
                })
            dataEntries.unshift({
                    label: this.$t('indicator.eval.fromYear'), key: 'yearFrom', hidden: false, type: 'dropdownsearch', value:  null, selectMultiple: false, flexGroup: false,
                    dropdownSearchState:{
                        toggled: false,
                        displayedItems: [],
                        input: '',
                        items: yearItems,
                        selectMultiple: false,
                        selectLast: true,
                        onceSelected: function ($event, item, searchbar){
                        },
                        styleLight: true,
                        placeholder: this.$t('indicator.eval.selectYear'),
                    }
                })
          }
          if(peremployee){
            let employeesMapped = Object.values(this.employeeMap)
                                  .map(e => {return {label: e.lastName+" "+e.firstName, value: e.id, selected: false}})
                                  .sort((a, b) => a.label.localeCompare(b.label));

            dataEntries.unshift({label: this.$t('global.ui.selectEmployee'), key: 'employees', hidden: true, type: 'dropdownsearch', value: null, selectMultiple: true, flexGroup: false,
                dropdownSearchState:{
                    toggled: false,
                    displayedItems: [],
                    input: '',
                    items: employeesMapped,
                    selectMultiple: true,
                    selectedItems: employeesMapped.filter(item => item.selected),
                    selectedItem: {},
                    onceSelected: function ($event, item, searchbar){

                    },
                styleLight: true,
                placeholder: this.$t('global.ui.selectEmployee'),
                },
            });
            dataEntries.unshift({label: this.$t('global.ui.allEmployees'), key: 'allEmployees', hidden: false, disabled: false, type: 'bool', value: true,
                computed: (datafill, lastVal, entryBeforeUpdate) => {
                    let empl = datafill.entries.find(i => i.key == 'employees');

                    if(entryBeforeUpdate.value == true){

                        employeesMapped.forEach(bal => bal.selected = false);
                        empl.dropdownSearchState = {
                            toggled: false,
                            displayedItems: [],
                            input: '',
                            items: employeesMapped,
                            selectMultiple: true,
                            selectedItems: employeesMapped.filter(item => item.selected),
                            selectedItem: {},
                            onceSelected: function ($event, item, searchbar){

                            },
                        styleLight: true,
                        placeholder: this.$t('global.ui.selectEmployee'),
                        }
                        empl.hidden = true;


                    } else {
                        empl.hidden = false;
                    }

                    return entryBeforeUpdate;
                }
            })
          }
          dataEntries.unshift({label: this.$t('indicator.eval.ignoreLinesWithoutWorkTime'), key: 'ignoreNullRows', hidden: false, type: 'bool', value: false})
          dataEntries.unshift({label: "CSV", key: 'csv', hidden: false, type: 'bool', value: false})
          
          
          
          let target = $event.currentTarget;

          this.$helpers.OpenPopup({
            elRelative: target,
            type: 'datafill',
            componentState: {
              entries: dataEntries,
              description: this.$t('indicator.eval.evalPdfHelp'),
              errorCheck: [
                    (entries) => {
                        if(entries['yearFrom'] != null && entries['yearTo'] != null && entries['yearFrom'].isAfter(entries['yearTo'])){
                            return {key: 'yearFrom', type: 'error', label: this.$t('indicator.eval.toYear'), text: this.$t('indicator.eval.yearToBeforeFrom')}
                        } else {
                            return null
                        }
                    },
                    (entries) => {
                        if(entries['dayFrom'] != null && entries['dayTo'] != null && entries['dayFrom'].isAfter(entries['dayTo'])){
                            return {key: 'dayFrom', type: 'error', label: this.$t('global.general.toDay'), text: this.$t('indicator.eval.dayToBeforeFrom')}
                        } else {
                            return null
                        }
                    },
                ],
              selectCallback: createCallback
            },
            header: this.$t('indicator.eval.reportConfig'),
            expanded: true,
            width: "800px",
            centered: true
          });
        },
        
        hideModal(ref) {
          this.$refs[ref].hide()
        },
        showModal(ref) {
          this.$refs[ref].show()
        },

        addReportSum(sums, key, value){
          if(sums[key] == undefined){
            sums[key] = value;
          } else {
            sums[key] += value;
          }
        },
        OpenMinuteOffsetPopup(){
            let view = this;

                let dataEntries = [];

                

                dataEntries.push({label: this.$t('indicator.main.hourOffset'), key: 'minuteOffset', type: 'slider', hidden: false, value: this.minuteOffset,
                    slider: {hideMin: true, hideMax: true, min: 0, max: 23*60, value: this.minuteOffset, step: 60,
                        DisplayLabel: (val) => { return val/60+"h" }, inputControl: true, sliderInput: (x) => {return x * 60},
                        labelToInt: (x) => {return Number(x.slice(0, -1)) * 60}, shorterDisplayLabel: (x) => {return x / 60}},
                })
                
                view.$helpers.OpenPopup({
                    type: 'datafill',
                    componentState: {
                        entries: dataEntries,
                        
                        selectCallback: function (data) {
                           view.minuteOffset = data.minuteOffset;
                           view.refreshStatistics();
                           
                        }
                    },
                    header: this.$t('indicator.main.hourOffset'),
                    width: "700px",
                    expanded: true,
                    centered: true
                });
        },
        OpenCrewLaborReportPopup(){
            let view = this;

                let dataEntries = [];

                let from = this.dateSelectionStart.clone().startOf('month');
                let to = from.clone().add(1, 'month');

                
                
                let temp = from.clone();
                let dates = [];
                

                while(temp < to){
                    dates.push(temp.clone());
                    temp.add(1, 'days');
                }
                let dateItems = dates.map(d => {
                    return {
                        label: d.format("DD.MM.YYYY"),
                        value: d,
                        selected: false
                    }
                });

                let dateToItems = dates.map(d => {
                    return {
                        label: d.format("DD.MM.YYYY"),
                        value: d.clone(),
                        selected: false
                    }
                });

                dataEntries.push({label: this.$t('roster.view.wholeMonth'), key: 'fullMonth', type: 'bool', hidden: false, value: true})
                dataEntries.push({label: this.$t('indicator.eval.upToCurrentHour'), key: 'untilLastHour', type: 'bool', hidden: view.$helpers.CheckDatafillKeysForHidden('fullMonth'), value: true})
                dataEntries.push({label: this.$t('global.general.fromDay'), key: 'date', type: 'dropdownsearch', hidden: view.$helpers.CheckDatafillKeysForHiddenInverted('fullMonth'),
                    dropdownSearchState: {
                        selectMultiple: false, styleLight: true,
                        placeholder: this.$t('roster.view.pleaseSelectDay'),
                        items: dateItems,
                        selectedItem: dateItems.find(i => i.selected),
                        selectedItems: dateItems.filter(i => i.selected),
                        selectFirst: true,
                    }
                });

                dataEntries.push({label: this.$t('global.general.toDay'), key: 'dateTo', type: 'dropdownsearch', hidden: view.$helpers.CheckDatafillKeysForHiddenInverted('fullMonth'),
                    dropdownSearchState: {
                        selectMultiple: false, styleLight: true,
                        placeholder: this.$t('roster.view.pleaseSelectDay'),
                        items: dateToItems,
                        selectedItem: dateToItems.find(i => i.selected),
                        selectedItems: dateToItems.filter(i => i.selected),
                        selectFirst: true,
                    }
                });
                dataEntries.push({label: this.$t('indicator.eval.onlySum'), key: 'summaryOnly', type: 'bool', hidden: false, value: false})
                

                let employeeLevelItems = [{label: this.$t('workBalance.payroll.crew'), value: 1, selected: true}, {label: 'Management', value: 2, selected: false}];
                dataEntries.push({label: this.$tc('store.structure.employeeLevel'), key: 'employeeLevel', type: 'dropdownsearch', hidden: false,
                    dropdownSearchState: {
                        selectMultiple: false, styleLight: true,
                        placeholder: '',
                        items: employeeLevelItems,
                        selectedItem: employeeLevelItems.find(i => i.selected),
                        selectedItems: employeeLevelItems.filter(i => i.selected),
                        selectFirst: true,
                    }
                });
                let plannedActualItems = [{label: this.$t('workBalance.summary.actual'), value: 1, selected: true}, {label: this.$t('workBalance.summary.target'), value: 2, selected: false}, {label: 'Soll + Ist', value: 3, selected: false}];
                dataEntries.push({label: this.$t('store.settings.data'), key: 'dataType', type: 'dropdownsearch', hidden: false,
                    dropdownSearchState: {
                        selectMultiple: false, styleLight: true,
                        placeholder: '',
                        items: plannedActualItems,
                        selectedItem: plannedActualItems.find(i => i.selected),
                        selectedItems: plannedActualItems.filter(i => i.selected),
                        selectFirst: true,
                    }
                });
                
                dataEntries.push({label: this.$t('indicator.main.hourOffset'), key: 'minuteOffset', type: 'slider', hidden: false, value: this.minuteOffset,
                    slider: {hideMin: true, hideMax: true, min: 0, max: 23*60, value: this.minuteOffset, step: 60, DisplayLabel: (val) => {

                        return val/60+"h";
                    }},
                })

                view.$helpers.OpenPopup({
                    type: 'datafill',
                    componentState: {
                        entries: dataEntries,
                        errorCheck: [
                           
                            (entries) => {
                                if(entries['date'] != null && entries['dateTo'] != null && entries['date'].isAfter(entries['dateTo'])){
                                    return {key: 'dateTo', type: 'error', label: this.$t('global.general.toDay'), text: this.$t('indicator.eval.dayToBeforeFrom')}
                                } else {
                                    return null
                                }
                            },
                        ],
                        selectCallback: function (data) {
                            let spotIds = Object.values(view.spotMap).filter(s => s.employeeLevel == data.employeeLevel).map(s => s.id);
                            
                            let unassigned = data.employeeLevel == 1;
                            let from = view.$helpers.getMomentFromValuesTZ(view.rosterFromTo.year, view.rosterFromTo.month, 1);
                            let to = from.clone().endOf('month').startOf('day');
                            let typeId = view.mainType.id;
                            let f;
                            let currentLastHour = null;
                            if(data.untilLastHour){
                                let ch = view.$helpers.getMomentTZ().startOf('hour');
                                if(ch > from && ch < to){
                                    currentLastHour = ch;
                                }
                            }
                            if(data.minuteOffset > 0 || currentLastHour != null){
                                let lTo = to.clone()
                                
                                if(!data.fullMonth){
                                    from = data.date;
                                    lTo = data.dateTo.clone().add(1, 'days'); 
                                } else {
                                    if(currentLastHour != null){
                                        if(currentLastHour > from && currentLastHour < lTo){
                                            lTo = currentLastHour.clone().startOf('day');
                                        }
                                    }
                                    lTo = lTo.add(1, 'days');
                                }
                                view.loading = true;
                                f = view.loadDailyStatisticsAsHourlyInterval(data.minuteOffset, from.clone(), lTo, spotIds, unassigned, typeId, [data.employeeLevel], currentLastHour)
                            } else {
                                f = view.$helpers.loadDailyStatistics(from, to, spotIds, unassigned, typeId, [data.employeeLevel]);
                            }

                            f
                            .then((rData) => {
                                console.log(rData)
                                view.loading = false;
                                view.generateCrewLaborReport(rData, data.employeeLevel, data.dataType, data.fullMonth, data.date, data.dateTo, data.summaryOnly, data.minuteOffset)
                                
                            }).catch(error => {
                                
                                console.log(error)
                                view.$helpers.error(view.$t('global.notifications.error'), view.$t('roster.view.createReportError'));
                            })
                           
                        }
                    },
                    header: 'Crew Labor Report',
                    width: "700px",
                    expanded: true,
                    centered: true
                });
        },
        generateCrewLaborReport(values, employeeLevel = 1, dataType, fullMonth = true, selectedDate = null, dateTo = null, summaryOnly = false, minuteOffset = 0){
            const config = this.crewLaborConfig ? this.crewLaborConfig : this.defaultCrewLaborConfig;
            let view = this;
            let date = this.$helpers.getMomentTZ();
            let filename = this.$t('indicator.eval.clReport') + "_"+this.storeSettings.name + '_' + date.format("DD_MM_YYYY_HH_mm")+'.pdf';

            let dataTypeLabel = dataType == 1 ? this.$t('workBalance.summary.actual') : dataType == 2 ? this.$t('workBalance.summary.target') : this.$t('roster.comp.targetActual');

            let headers = ["", this.$t('indicator.eval.field'), this.$tc('global.ui.hours'), this.$t('indicator.main.amount'), this.$t('indicator.eval.crewLaborShort') + "%"];
            let repDoc = this.$helpers.tableReportDoc(
                headers,
                this.$t('indicator.eval.clReport') + ' ' + this.dateSelectionStart.format("MMMM YYYY")+ (employeeLevel == 1 ? ' - Crew ' : ' - Management ')+'('+dataTypeLabel+')',
                this.storeSettings.name,
                this.storeSettings.description,
                this.userFullname,
                9);
            let doc = repDoc.doc;
            let contentOffsetY = repDoc.contentOffsetY;
            doc.setFontSize(12);

            
            let indSum = 0;
            let prodWorkTimeSum = 0;
            let unprodWorkTimeSum = 0;
            let workSum = 0;
            let unprodWorkSum = 0;

            let holidayTimeSum = 0;
            let holidaySum = 0;

            let holidayAdjustTimeSum = 0;
            let holidayAdjustSum = 0;

            let vacationTimeSum = 0;
            let vacationSum = 0;

            let nurseVacTimeSum = 0;
            let nursecVacSum = 0;

            let sickTimeSum = 0;
            let sickSum = 0;

            let wageContTimeSum = 0;
            let wageContSum = 0;

            let eduTimeSum = 0;
            let eduSum = 0;

            let miscTimeSum = 0;
            let miscSum = 0;

            let nightTimeSum = 0;
            let nightSum = 0;
            let nightFlatSum = 0;

            let overtimeSum = 0;
            let overSum = 0;
            let overFlatSum = 0;

            let workTimeSum = 0;
            let workTimeTotalSum = 0;
            let workValueSum = 0;

            let fixedCostValueSum = 0;
            let currentDate = this.$helpers.getMomentTZ().startOf('day');

            values.filter(i => fullMonth || (this.$helpers.getMomentFromStringTZ(i.from) >= selectedDate && this.$helpers.getMomentFromStringTZ(i.from) <= dateTo)).forEach(i => {
                let d = this.$helpers.getMomentFromStringTZ(i.from).format("DD.MM.YYYY");
                if(minuteOffset > 0){
                    d = this.$helpers.getMomentFromStringTZ(i.from).add(minuteOffset, 'minutes').format("DD.MM.YYYY HH:mm")+" - "+this.$helpers.getMomentFromStringTZ(i.from).add(1, 'days').add(minuteOffset, 'minutes').format("DD.MM.YYYY HH:mm")
                }
                
                let body = [];
                let workTime = 0;
                let workTimeTotal = 0;
                let workValue = 0;

                let actual = true;
                if(dataType == 2){
                    actual = false;
                } else if(dataType == 3){
                    actual = this.$helpers.getMomentFromStringTZ(i.from) < currentDate;
                    d+= actual ? this.$t('roster.comp.actualBubble') : this.$t('indicator.vlh.targetBubbleCaps');
                }
                
                
                
                body.push([d, '', '', '', '']);
                let productiveWorkTime = this.$helpers.calculateCLWorkTimeSum(i, config, !actual);
                let productiveWorkValue = this.$helpers.calculateCLProductiveWorkValueSum(i, config, !actual);

                let indicatorValue = actual ? i.actualIndicatorValue : i.plannedIndicatorValue;
                let workClPer = indicatorValue > 0 ? (productiveWorkValue/100.0) / indicatorValue * 100 : 0;
                body.push([this.$t('indicator.eval.workHours'),'', '', '', '']);
                body.push(["", this.$t('shift.template.workTime'), (productiveWorkTime/3600.0).toFixed(2), (productiveWorkValue/100.0).toFixed(2), workClPer.toFixed(2)+"%"]);
                
                prodWorkTimeSum += productiveWorkTime;
                workSum += productiveWorkValue;
                indSum += indicatorValue;

                workTime += productiveWorkTime;
                workTimeTotal += productiveWorkTime;
                workValue += productiveWorkValue;

                let unproductiveWorkTime = this.$helpers.calculateCLOnlyUnproductiveWorkTimeSum(i, config, !actual);
                let unproductiveWorkValue = this.$helpers.calculateCLOnlyUnproductiveWorkValueSum(i, config, !actual);
                workClPer = indicatorValue > 0 ? (unproductiveWorkValue/100.0) / indicatorValue * 100 : 0;
                body.push(["", this.$t('workBalance.payroll.unproductiveWorkTime'), (unproductiveWorkTime/3600.0).toFixed(2), (unproductiveWorkValue/100.0).toFixed(2), workClPer.toFixed(2)+"%"]);

                unprodWorkTimeSum += unproductiveWorkTime;
                unprodWorkSum += unproductiveWorkValue;
                
                workTime += unproductiveWorkTime;
                workTimeTotal += unproductiveWorkTime;
                workValue += unproductiveWorkValue;

                

                body.push([this.$tc('global.general.absence', 2), "", '', '', '']);
                if(config.vacationWorkValue){
                    let vacationWorkTime =  i.vacationWorkTime;
                    let vacationWorkValue = i.vacationWorkValue;
                    let vacationClPer = indicatorValue > 0 ? (vacationWorkValue/100.0) / indicatorValue * 100 : 0;
                    body.push(["", this.$t('workBalance.summary.vacation'), (vacationWorkTime/3600.0).toFixed(2), (vacationWorkValue/100.0).toFixed(2), vacationClPer.toFixed(2)+"%"]);
                    
                    vacationTimeSum += vacationWorkTime;
                    vacationSum += vacationWorkValue;

                    workTime += vacationWorkTime;
                    workTimeTotal += vacationWorkTime;
                    workValue += vacationWorkValue;
                }

                if(config.sickWorkValue){
                    let sickWorkTime = i.sickWorkTime;
                    let sickWorkValue = i.sickWorkValue;
                    let sickClPer = indicatorValue > 0 ? (sickWorkValue/100.0) / indicatorValue * 100 : 0;
                    body.push(["", this.$t('workBalance.summary.sickLeave'), (sickWorkTime/3600.0).toFixed(2), (sickWorkValue/100.0).toFixed(2), sickClPer.toFixed(2)+"%"]);
                    
                    sickTimeSum += sickWorkTime;
                    sickSum += sickWorkValue;

                    workTime += sickWorkTime;
                    workTimeTotal += sickWorkTime;
                    workValue += sickWorkValue;
                }

                if(config.holidayAdjustWorkValue){
                    let holidayAdjustWorkTime = i.holidayAdjustWorkTime;
                    let holidayAdjustWorkValue = i.holidayAdjustWorkValue;
                    let holidayAdjustClPer = indicatorValue > 0 ? (holidayAdjustWorkValue/100.0) / indicatorValue * 100 : 0;
                    body.push(["", this.$t('workBalance.payroll.holidayCompensation'), (holidayAdjustWorkTime/3600.0).toFixed(2), (holidayAdjustWorkValue/100.0).toFixed(2), holidayAdjustClPer.toFixed(2)+"%"]);
                    
                    holidayAdjustTimeSum += holidayAdjustWorkTime;
                    holidayAdjustSum += holidayAdjustWorkValue;

                    workTime += holidayAdjustWorkTime;
                    workTimeTotal += holidayAdjustWorkTime;
                    workValue += holidayAdjustWorkValue;
                }

                if(config.nursingVacationWorkValue){
                    let nursingVacationWorkTime = i.nursingVacationWorkTime;
                    let nursingVacationWorkValue = i.nursingVacationWorkValue;
                    let nursingVacationClPer = indicatorValue > 0 ? (nursingVacationWorkValue/100.0) / indicatorValue * 100 : 0;
                    body.push(["", this.$t('workBalance.summary.nursingLeave'), (nursingVacationWorkTime/3600.0).toFixed(2), (nursingVacationWorkValue/100.0).toFixed(2), nursingVacationClPer.toFixed(2)+"%"]);
                    
                    nurseVacTimeSum += nursingVacationWorkTime;
                    nursecVacSum += nursingVacationWorkValue;

                    workTime += nursingVacationWorkTime;
                    workTimeTotal += nursingVacationWorkTime;
                    workValue += nursingVacationWorkValue;
                }

                if(config.eduWorkValue){
                    let eduWorkTime = i.eduWorkTime;
                    let eduWorkValue = i.eduWorkValue;
                    let eduClPer = indicatorValue > 0 ? (eduWorkValue/100.0) / indicatorValue * 100 : 0;
                    body.push(["", this.$t('workBalance.summary.trainee'), (eduWorkTime/3600.0).toFixed(2), (eduWorkValue/100.0).toFixed(2), eduClPer.toFixed(2)+"%"]);
                    
                    eduTimeSum += eduWorkTime;
                    eduSum += eduWorkValue;

                    workTime += eduWorkTime;
                    workTimeTotal += eduWorkTime;
                    workValue += eduWorkValue;
                }

                if(config.wageContinuationWorkValue){
                    let wageContinuationWorkTime = i.wageContinuationWorkTime;
                    let wageContinuationWorkValue = i.wageContinuationWorkValue;
                    let wageContinuationClPer = indicatorValue > 0 ? (wageContinuationWorkValue/100.0) / indicatorValue * 100 : 0;
                    body.push(["", this.$t('workBalance.summary.sickPay'), (wageContinuationWorkTime/3600.0).toFixed(2), (wageContinuationWorkValue/100.0).toFixed(2), wageContinuationClPer.toFixed(2)+"%"]);
                    
                    wageContTimeSum += wageContinuationWorkTime;
                    wageContSum += wageContinuationWorkValue;

                    workTime += wageContinuationWorkTime;
                    workTimeTotal += wageContinuationWorkTime;
                    workValue += wageContinuationWorkValue;
                }

                if(config.miscWorkValue){
                    let miscWorkTime = i.miscWorkTime;
                    let miscWorkValue = i.miscWorkValue;
                    let miscClPer = indicatorValue > 0 ? (miscWorkValue/100.0) / indicatorValue * 100 : 0;
                    body.push(["", this.$t('workBalance.summary.otherAbsences'), (miscWorkTime/3600.0).toFixed(2), (miscWorkValue/100.0).toFixed(2), miscClPer.toFixed(2)+"%"]);
                    
                    miscTimeSum += miscWorkTime;
                    miscSum += miscWorkValue;

                    workTime += miscWorkTime;
                    workTimeTotal += miscWorkTime;
                    workValue += miscWorkValue;
                }

                body.push([this.$t('indicator.crew.extraPay'), "", '', '', '']);
                if(config.holidayWorkValue){
                    let holidayWorkTime = actual ? i.actualHolidayWorkTime : i.plannedHolidayWorkTime;
                    let holidayWorkValue = actual ? i.actualHolidayWorkValue : i.plannedHolidayWorkValue;
                    let holidayClPer = indicatorValue > 0 ? (holidayWorkValue/100.0) / indicatorValue * 100 : 0;
                    body.push(["", this.$t('workBalance.summary.holidayWork'), (holidayWorkTime/3600.0).toFixed(2), (holidayWorkValue/100.0).toFixed(2), holidayClPer.toFixed(2)+"%"]);
                    
                    holidayTimeSum += holidayWorkTime;
                    holidaySum += holidayWorkValue;

                    workTimeTotal += holidayWorkTime;
                    workValue += holidayWorkValue;
                }

                if(config.nightWorkValue){
                    let nightWorkTime =  actual ? i.actualNightWorkTime : i.plannedNightWorkTime;
                    let nightWorkValue =  actual ? i.actualNightWorkValue : i.plannedNightWorkValue;
                    let nightClPer = indicatorValue > 0 ? (nightWorkValue/100.0) / indicatorValue * 100 : 0;
                    body.push(["", this.$t('workBalance.payroll.nightWorkTime'), (nightWorkTime/3600.0).toFixed(2), (nightWorkValue/100.0).toFixed(2), nightClPer.toFixed(2)+"%"]);
                   
                   nightTimeSum += nightWorkTime;
                   nightSum += nightWorkValue;

                    workTimeTotal += nightWorkTime;
                    workValue += nightWorkValue;
                }

                if(config.nightWorkShiftFlatValue){
                    let nightWorkShiftFlatValue =  actual ? i.actualNightWorkShiftFlatValue : i.plannedNightWorkShiftFlatValue;
                    body.push(["", this.$t('indicator.eval.nightWorkFlat'), '', (nightWorkShiftFlatValue/100.0).toFixed(2), '']);
                    nightFlatSum += nightWorkShiftFlatValue;

                    workValue += nightWorkShiftFlatValue;
                }

                if(config.overtimeValue){
                    let overtime =  actual ? i.actualOvertime : i.plannedOvertime;
                    let overtimeValue =  actual ? i.actualOvertimeValue : i.plannedOvertimeValue;
                    let overtimeClPer = indicatorValue > 0 ? (overtimeValue/100.0) / indicatorValue * 100 : 0;
                    body.push(["", this.$t('workBalance.payroll.overTime'), (overtime/3600.0).toFixed(2), (overtimeValue/100.0).toFixed(2), overtimeClPer.toFixed(2)+"%"]);
                    
                    overtimeSum += overtime;
                    overSum += overtimeValue;

                    workTimeTotal += overtime;
                    workValue += overtimeValue;
                }

                if(config.overtimeShiftFlatValue){
                    let overtimeShiftFlatValue =  actual ? i.actualOvertimeShiftFlatValue : i.plannedOvertimeShiftFlatValue;
                    body.push(["", this.$t('indicator.eval.overtimeFlat'), '', (overtimeShiftFlatValue/100.0).toFixed(2), '']);
                    overFlatSum += overtimeShiftFlatValue;

                    workValue += overtimeShiftFlatValue;
                    
                }

                if(i.fixedCostValue){
                    body.push([this.$t('roster.main.other'), "", '', '', ''])
                    let fixedCostValue =  i.fixedCostValue;
                    let fixedCostClPer = indicatorValue > 0 ? (fixedCostValue/100.0) / indicatorValue * 100 : 0;
                    body.push(["", this.$t('indicator.main.fixCosts'), '', (fixedCostValue/100.0).toFixed(2), fixedCostClPer.toFixed(2)+"%"]);
                    fixedCostValueSum += fixedCostValue;

                    workValue += fixedCostValue;
                }
                let workValueClPer = indicatorValue > 0 ? (workValue/100.0) / indicatorValue * 100 : 0;
                body.push([this.$t('global.ui.sum'), "", '', '', '']);
                //body.push(["", "Arbeitszeit ohne Zuschläge", (workTime/3600.0).toFixed(2), '', '']);
                body.push(["", this.$t('shift.template.total'), (workTime/3600.0).toFixed(2), (workValue/100.0).toFixed(2), workValueClPer.toFixed(2)+"%"]);

                workTimeSum += workTime;
                workTimeTotalSum += workTimeTotal;
                workValueSum += workValue;
                if(!summaryOnly ||  (selectedDate.format() == dateTo.format() && !fullMonth)){
                    let newPage = doc.lastAutoTable.finalY ? true : false
                    let finalY = doc.lastAutoTable.finalY ? doc.lastAutoTable.finalY : repDoc.contentOffsetY
                    let pageSize = doc.internal.pageSize
                    let pageHeight = pageSize.height ? pageSize.height : pageSize.getHeight()
                    
                    let offset = finalY + (pageHeight - (finalY % pageHeight)) 

                    doc.autoTable({
                        startY: newPage ? offset : repDoc.contentOffsetY,
                        head: [headers],
                        body: body,
                        headStyles: {
                        fillColor: [109,141,33],
                        fontSize: 12,
                        },
                        bodyStyles: {
                        fontSize: 12
                        },
                        columnStyles: {
                        },
                        horizontalPageBreak: headers.length > 15,
                        horizontalPageBreakRepeat: 0,
                    });
                }
                



            });
            if(fullMonth || selectedDate.format() != dateTo.format()){
                //total sum
                let body = [];
                let label;
                if(fullMonth){
                    label = this.dateSelectionStart.format("MMMM YYYY");

                   
                } else {
                    label = selectedDate.format("DD.MM.YYYY") +' - '+dateTo.format("DD.MM.YYYY")
                   
                }
                if(minuteOffset > 0){
                    label += "\n (+"+minuteOffset/60+"h Verschiebung)";
                }
                if(dataType == 3){
                    label+= this.$t('indicator.eval.targetActualBubble');
                }
                body.push([label, '', '', '', '']);
                
                body.push([this.$t('indicator.eval.workHours'),'', '', '', '']);
                let workClPer = indSum > 0 ? (workSum/100.0) / indSum * 100 : 0;
                body.push(["", this.$t('shift.template.workTime'), (prodWorkTimeSum/3600.0).toFixed(2), (workSum/100.0).toFixed(2), workClPer.toFixed(2)+"%"]);
                workClPer = indSum > 0 ? (unprodWorkSum/100.0) / indSum * 100 : 0;
                body.push(["", this.$t('workBalance.payroll.unproductiveWorkTime'), (unprodWorkTimeSum/3600.0).toFixed(2), (unprodWorkSum/100.0).toFixed(2), workClPer.toFixed(2)+"%"]);

                body.push([this.$tc('global.general.absence', 2), "", '', '', '']);
                if(config.vacationWorkValue){
                    let vacationClPer = indSum > 0 ? (vacationSum/100.0) / indSum * 100 : 0;
                    body.push(["", this.$t('workBalance.summary.vacation'), (vacationTimeSum/3600.0).toFixed(2), (vacationSum/100.0).toFixed(2), vacationClPer.toFixed(2)+"%"]);
                        
                }

                if(config.sickWorkValue){
                    let sickClPer = indSum > 0 ? (sickSum/100.0) / indSum * 100 : 0;
                    body.push(["", this.$t('workBalance.summary.sickLeave'), (sickTimeSum/3600.0).toFixed(2), (sickSum/100.0).toFixed(2), sickClPer.toFixed(2)+"%"]);
                }

                if(config.holidayAdjustWorkValue){
                    let holidayAdjustClPer = indSum > 0 ? (holidayAdjustSum/100.0) / indSum * 100 : 0;
                    body.push(["", this.$t('workBalance.payroll.holidayCompensation'), (holidayAdjustTimeSum/3600.0).toFixed(2), (holidayAdjustSum/100.0).toFixed(2), holidayAdjustClPer.toFixed(2)+"%"]);
                }

                if(config.nursingVacationWorkValue){
                    let nursingVacationClPer = indSum > 0 ? (nursecVacSum/100.0) / indSum * 100 : 0;
                    body.push(["", this.$t('workBalance.summary.nursingLeave'), (nurseVacTimeSum/3600.0).toFixed(2), (nursecVacSum/100.0).toFixed(2), nursingVacationClPer.toFixed(2)+"%"]);
                }

                if(config.eduWorkValue){
                    let eduClPer = indSum > 0 ? (eduSum/100.0) / indSum * 100 : 0;
                    body.push(["", this.$t('workBalance.summary.trainee'), (eduTimeSum/3600.0).toFixed(2), (eduSum/100.0).toFixed(2), eduClPer.toFixed(2)+"%"]);
                }

                if(config.wageContinuationWorkValue){
                    let wageContClPer = indSum > 0 ? (wageContSum/100.0) / indSum * 100 : 0;
                    body.push(["", this.$t('workBalance.summary.sickPay'), (wageContTimeSum/3600.0).toFixed(2), (wageContSum/100.0).toFixed(2), wageContClPer.toFixed(2)+"%"]);
                }

                if(config.miscWorkValue){
                    let miscClPer = indSum > 0 ? (miscSum/100.0) / indSum * 100 : 0;
                    body.push(["", this.$t('workBalance.summary.otherAbsences'), (miscTimeSum/3600.0).toFixed(2), (miscSum/100.0).toFixed(2), miscClPer.toFixed(2)+"%"]);
                }

                body.push([this.$t('indicator.crew.extraPay'), "", '', '', '']);
                if(config.holidayWorkValue){
                    let holidayClPer = indSum > 0 ? (holidaySum/100.0) / indSum * 100 : 0;
                    body.push(["", this.$t('workBalance.summary.holidayWork'), (holidayTimeSum/3600.0).toFixed(2), (holidaySum/100.0).toFixed(2), holidayClPer.toFixed(2)+"%"]);
                }

                if(config.nightWorkValue){
                    let nightClPer = indSum > 0 ? (nightSum/100.0) / indSum * 100 : 0;
                    body.push(["", this.$t('workBalance.payroll.nightWorkTime'), (nightTimeSum/3600.0).toFixed(2), (nightSum/100.0).toFixed(2), nightClPer.toFixed(2)+"%"]);
                }

                if(config.nightWorkShiftFlatValue){
                    body.push(["", this.$t('indicator.eval.nightWorkTimeFlat'), '', (nightFlatSum/100.0).toFixed(2), '']);
                }

                if(config.overtimeValue){
                    let overtimeClPer = indSum > 0 ? (overSum/100.0) / indSum * 100 : 0;
                    body.push(["", this.$t('workBalance.payroll.overTime'), (overtimeSum/3600.0).toFixed(2), (overSum/100.0).toFixed(2), overtimeClPer.toFixed(2)+"%"]);
                }

                if(config.overtimeShiftFlatValue){
                    body.push(["", this.$t('indicator.eval.overtimeFlat'), '', (overFlatSum/100.0).toFixed(2), '']);
                }
                if(fixedCostValueSum > 0){
                    body.push([this.$t('roster.main.other'), "", '', '', '']);
                    let fixedCostValueClPer = indSum > 0 ? (fixedCostValueSum/100.0) / indSum * 100 : 0;
                    body.push(["", this.$t('indicator.main.fixCosts'), '', (fixedCostValueSum/100.0).toFixed(2), fixedCostValueClPer.toFixed(2)+"%"]);
                }
                let workValueClPer = indSum > 0 ? (workValueSum/100.0) / indSum * 100 : 0;
                body.push([this.$t('global.ui.sum'), "", '', '', '']);
                //body.push(["", "Arbeitszeit ohne Zuschläge", (workTimeSum/3600.0).toFixed(2), '', '']);
                body.push(["", this.$t('shift.template.total'), (workTimeSum/3600.0).toFixed(2), (workValueSum/100.0).toFixed(2), workValueClPer.toFixed(2)+"%"]);

                let newPage = doc.lastAutoTable.finalY ? true : false
                let finalY = doc.lastAutoTable.finalY ? doc.lastAutoTable.finalY : repDoc.contentOffsetY
                
                let pageSize = doc.internal.pageSize
                let pageHeight = pageSize.height ? pageSize.height : pageSize.getHeight()
                    
                let offset = finalY + (pageHeight - (finalY % pageHeight)) 

                doc.autoTable({
                        startY: newPage ? offset : repDoc.contentOffsetY,
                        head: [headers],
                        body: body,
                        headStyles: {
                        fillColor: [109,141,33],
                        fontSize: 12,
                        },
                        bodyStyles: {
                        fontSize: 12
                        },
                        columnStyles: {
                        },
                        horizontalPageBreak: headers.length > 15,
                        horizontalPageBreakRepeat: 0,
                });
            }
            

            view.$helpers.previewPdf(doc, filename);
                

        },
        
        generatePdfReport(pdfSettings, values, actual = true, reportType = 0, save = true){
          
          const config = this.crewLaborConfig ? this.crewLaborConfig : this.defaultCrewLaborConfig;
          let view = this;
          let date = this.$helpers.getMomentTZ();

          let headers = [];
          if (pdfSettings.date) headers.push(this.$t('store.settings.date'));
          if (pdfSettings.personnelId) headers.push(this.$t('pages.employeeCoreData.personnelNumber'));
          if (pdfSettings.employeeName) headers.push(this.$t('pages.employeeData.name'));
          if (pdfSettings.plannedIndicatorValue) headers.push(this.$t('roster.view.keyFigure') + this.$t('indicator.vlh.targetBubbleCaps'));
          if (pdfSettings.actualIndicatorValue) headers.push(this.$t('roster.view.keyFigure') + this.$t('roster.comp.actualBubble'));
          
          if (pdfSettings.plannedWorkTime) headers.push(this.$t('shift.template.workTime') + this.$t('indicator.vlh.targetBubbleCaps'));
          if (pdfSettings.actualWorkTime) headers.push(this.$t('shift.template.workTime') + this.$t('roster.comp.actualBubble'));
          if (pdfSettings.plannedWorkValue) headers.push(this.$t('indicator.eval.workTimeCosts') + this.$t('indicator.vlh.targetBubbleCaps'));
          if (pdfSettings.actualWorkValue) headers.push(this.$t('indicator.eval.workTimeCosts') + this.$t('roster.comp.actualBubble'));

          if (pdfSettings.productivePlannedWorkTime) headers.push(this.$t('indicator.eval.productive') + "\r\n" + this.$t('shift.template.workTime') + this.$t('indicator.vlh.targetBubbleCaps'));
          if (pdfSettings.productiveActualWorkTime) headers.push(this.$t('indicator.eval.productive') + "\r\n" + this.$t('shift.template.workTime') + this.$t('roster.comp.actualBubble'));
          if (pdfSettings.productivePlannedWorkValue) headers.push(this.$t('indicator.eval.productive') + "\r\n" + this.$t('indicator.eval.workTimeCosts') + this.$t('indicator.vlh.targetBubbleCaps'));
          if (pdfSettings.productiveActualWorkValue) headers.push(this.$t('indicator.eval.productive') + "\r\n" + this.$t('indicator.eval.workTimeCosts') + this.$t('roster.comp.actualBubble'));

          if (pdfSettings.productivePlannedOpenWorkTime) headers.push(this.$t('workBalance.payroll.productiveWorkTime') + "\r\n" + this.$t('store.openingHours.title') + this.$t('indicator.vlh.targetBubbleCaps'));
          if (pdfSettings.productiveActualOpenWorkTime) headers.push(this.$t('workBalance.payroll.productiveWorkTime') + "\r\n" + this.$t('store.openingHours.title') + this.$t('roster.comp.actualBubble'));
          if (pdfSettings.productivePlannedOpenWorkValue) headers.push(this.$t('indicator.eval.workTimeCosts') + "\r\n" + this.$t('store.openingHours.title') + this.$t('indicator.vlh.targetBubbleCaps'));
          if (pdfSettings.productiveActualOpenWorkValue) headers.push(this.$t('indicator.eval.workTimeCosts') + "\r\n" + this.$t('store.openingHours.title') + this.$t('roster.comp.actualBubble'));

          if (pdfSettings.productivePlannedIndicatorWorkTime) headers.push(this.$t('indicator.eval.keyFigureProductive') + "\r\n" + this.$t('shift.template.workTime') + this.$t('indicator.vlh.targetBubbleCaps'));
          if (pdfSettings.productiveActualIndicatorWorkTime) headers.push(this.$t('indicator.eval.keyFigureProductive') + "\r\n" + this.$t('shift.template.workTime') + this.$t('roster.comp.actualBubble'));
          if (pdfSettings.productivePlannedIndicatorWorkValue) headers.push(this.$t('indicator.eval.keyFigureProductive') + "\r\n" + this.$t('indicator.eval.workTimeCosts') + this.$t('indicator.vlh.targetBubbleCaps'));
          if (pdfSettings.productiveActualIndicatorWorkValue) headers.push(this.$t('indicator.eval.keyFigureProductive') + "\r\n" + this.$t('indicator.eval.workTimeCosts') + this.$t('roster.comp.actualBubble'));

          if (pdfSettings.contractWorkTime) headers.push(this.$t('indicator.eval.contractS') + "\r\n" + this.$t('shift.template.workTime'));
          if (pdfSettings.contractWorkValue) headers.push(this.$t('indicator.eval.contractS') + "\r\n" + this.$t('indicator.eval.workTimeCosts'));
          if (pdfSettings.plannedProductivity) headers.push(this.$t('roster.view.productivity') + "\r\n" + this.$t('indicator.vlh.targetBubbleCaps'));
          if (pdfSettings.actualProductivity) headers.push(this.$t('roster.view.productivity') + "\r\n" + this.$t('roster.comp.actualBubble'));
          if (pdfSettings.plannedNightWorkShiftCount) headers.push(this.$t('indicator.eval.nightWorkShifts') + "\r\n" + this.$t('shift.template.amount') + this.$t('indicator.vlh.targetBubbleCaps'));
          if (pdfSettings.actualNightWorkShiftCount) headers.push(this.$t('indicator.eval.nightWorkShifts') + "\r\n" + this.$t('shift.template.amount') + this.$t('roster.comp.actualBubble'));
          if (pdfSettings.plannedNightWorkShiftFlatValue) headers.push(this.$t('indicator.eval.nightWorkTimeFlat') + "\r\n" + this.$t('workBalance.extraPay.costs') + this.$t('indicator.vlh.targetBubbleCaps'));
          if (pdfSettings.actualNightWorkShiftFlatValue) headers.push(this.$t('indicator.eval.nightWorkTimeFlat') + "\r\n" + this.$t('workBalance.extraPay.costs') + this.$t('roster.comp.actualBubble'));
          if (pdfSettings.plannedNightWorkTime) headers.push(this.$t('workBalance.payroll.nightWork') + "\r\n" + this.$t('indicator.vlh.targetBubbleCaps'));
          if (pdfSettings.actualNightWorkTime) headers.push(this.$t('workBalance.payroll.nightWork') + "\r\n" + this.$t('roster.comp.actualBubble'));
          if (pdfSettings.plannedNightWorkValue) headers.push(this.$t('workBalance.payroll.nightWork') + "\r\n" + this.$t('workBalance.extraPay.costs') + this.$t('indicator.vlh.targetBubbleCaps'));
          if (pdfSettings.actualNightWorkValue) headers.push(this.$t('workBalance.payroll.nightWork') + "\r\n" + this.$t('workBalance.extraPay.costs') + this.$t('roster.comp.actualBubble'));
          if (pdfSettings.plannedOvertimeShiftCount) headers.push(this.$t('indicator.eval.overtimeShifts') + "\r\n" + this.$t('shift.template.amount') + this.$t('indicator.vlh.targetBubbleCaps'));
          if (pdfSettings.actualOvertimeShiftCount) headers.push(this.$t('indicator.eval.overtimeShifts') + "\r\n" + this.$t('shift.template.amount') + this.$t('roster.comp.actualBubble'));
          if (pdfSettings.plannedOvertimeShiftFlatValue) headers.push(this.$t('workBalance.payroll.overTime') + "\r\n" + this.$t('workBalance.bonus.lumpSum') + this.$t('indicator.vlh.targetBubbleCaps'));
          if (pdfSettings.actualOvertimeShiftFlatValue) headers.push(this.$t('workBalance.payroll.overTime') + "\r\n" + this.$t('workBalance.bonus.lumpSum') + this.$t('roster.comp.actualBubble'));
          if (pdfSettings.plannedOvertime) headers.push(this.$t('workBalance.payroll.overTime') + "\r\n" + this.$t('indicator.vlh.targetBubbleCaps'));
          if (pdfSettings.actualOvertime) headers.push(this.$t('workBalance.payroll.overTime') + "\r\n" + this.$t('roster.comp.actualBubble'));
          if (pdfSettings.plannedOvertimeValue) headers.push(this.$t('workBalance.payroll.overTime') + "\r\n" + this.$t('workBalance.extraPay.costs') + this.$t('indicator.vlh.targetBubbleCaps'));
          if (pdfSettings.actualOvertimeValue) headers.push(this.$t('workBalance.payroll.overTime') + "\r\n" + this.$t('workBalance.extraPay.costs') + this.$t('roster.comp.actualBubble'));
          if (pdfSettings.plannedHolidayWorkTime) headers.push(this.$t('indicator.eval.holidayS') + "\r\n" + this.$t('shift.template.workTime') + this.$t('indicator.vlh.targetBubbleCaps'));
          if (pdfSettings.actualHolidayWorkTime) headers.push(this.$t('indicator.eval.holidayS') + "\r\n" + this.$t('shift.template.workTime') + this.$t('roster.comp.actualBubble'));
          if (pdfSettings.plannedHolidayWorkValue) headers.push(this.$t('workBalance.payroll.holidayWorkTime') + "\r\n" + this.$t('workBalance.extraPay.costs') + this.$t('indicator.vlh.targetBubbleCaps'));
          if (pdfSettings.actualHolidayWorkValue) headers.push(this.$t('workBalance.payroll.holidayWorkTime') + "\r\n" + this.$t('workBalance.extraPay.costs') + this.$t('roster.comp.actualBubble'));

          if (pdfSettings.plannedUnproductiveWorkTime) headers.push(this.$t('roster.view.unproductive') + "\r\n" + this.$t('shift.template.workTime') + this.$t('indicator.vlh.targetBubbleCaps'));
          if (pdfSettings.actualUnproductiveWorkTime) headers.push(this.$t('roster.view.unproductive') + "\r\n" + this.$t('shift.template.workTime') + this.$t('roster.comp.actualBubble'));
          if (pdfSettings.unproductiveWorkPercentage) headers.push(this.$t('roster.view.unproductive') + "\r\n" + this.$t('indicator.eval.quota'));

          if (pdfSettings.vacationWorkTime) headers.push(this.$t('workBalance.summary.vacation') + "\r\n" + this.$t('shift.template.workTime'));
          if (pdfSettings.vacationWorkValue) headers.push(this.$t('workBalance.summary.vacation') + "\r\n" + this.$t('indicator.eval.workTimeCosts'));
          if (pdfSettings.vacationWorkPercentage) headers.push(this.$t('workBalance.summary.vacation') + "\r\n" + this.$t('indicator.eval.workTimeQuota'));

          if (pdfSettings.sickWorkTime) headers.push(this.$t('workBalance.summary.sickLeave') + "\r\n" + this.$t('shift.template.workTime'));
          if (pdfSettings.sickWorkValue) headers.push(this.$t('workBalance.summary.sickLeave') + "\r\n" + this.$t('indicator.eval.workTimeCosts'));
          if (pdfSettings.sickWorkPercentage) headers.push(this.$t('workBalance.summary.sickLeave') + "\r\n" + this.$t('indicator.eval.workTimeQuota'));

          if (pdfSettings.holidayAdjustWorkTime) headers.push(this.$t('workBalance.payroll.holidayCompensation') + "\r\n" + this.$t('shift.template.workTime'));
          if (pdfSettings.holidayAdjustWorkValue) headers.push(this.$t('workBalance.payroll.holidayCompensation') + "\r\n" + this.$t('workBalance.extraPay.costs'));
          if (pdfSettings.holidayAdjustWorkPercentage) headers.push(this.$t('workBalance.payroll.holidayCompensation') + "\r\n" + this.$t('indicator.eval.quota'));

          if (pdfSettings.miscWorkTime) headers.push(this.$t('workBalance.summary.otherAbsences') + "\r\n" + this.$t('shift.template.workTime'));
          if (pdfSettings.miscWorkValue) headers.push(this.$t('workBalance.summary.otherAbsences') + "\r\n" + this.$t('indicator.eval.workTimeCosts'));
          if (pdfSettings.miscWorkPercentage) headers.push(this.$t('workBalance.summary.otherAbsences') + "\r\n" + this.$t('indicator.eval.workTimeQuota'));

          if (pdfSettings.nursingVacationWorkTime) headers.push(this.$t('workBalance.summary.nursingLeave') + "\r\n" + this.$t('shift.template.workTime'));
          if (pdfSettings.nursingVacationWorkValue) headers.push(this.$t('workBalance.summary.nursingLeave') + "\r\n" + this.$t('indicator.eval.workTimeCosts'));
          if (pdfSettings.nursingVacationWorkPercentage) headers.push(this.$t('workBalance.summary.nursingLeave') + "\r\n" + this.$t('indicator.eval.workTimeQuota'));

          if (pdfSettings.eduWorkTime) headers.push(this.$t('workBalance.summary.trainee') + "\r\n" + this.$t('shift.template.workTime'));
          if (pdfSettings.eduWorkValue) headers.push(this.$t('workBalance.summary.trainee') + "\r\n" + this.$t('indicator.eval.workTimeCosts'));
          if (pdfSettings.eduWorkPercentage) headers.push(this.$t('workBalance.summary.trainee') + "\r\n" + this.$t('indicator.eval.workTimeQuota'));

          if (pdfSettings.wageContinuationWorkTime) headers.push(this.$t('workBalance.summary.sickPay') + "\r\n" + this.$t('shift.template.workTime'));
          if (pdfSettings.wageContinuationWorkValue) headers.push(this.$t('workBalance.summary.sickPay') + "\r\n" + this.$t('indicator.eval.workTimeCosts'));
          if (pdfSettings.wageContinuationWorkPercentage) headers.push(this.$t('workBalance.summary.sickPay') + "\r\n" + this.$t('indicator.eval.workTimeQuota'));

          if (pdfSettings.fixedCostValue) headers.push(this.$t('indicator.main.fixCosts'));

          if (pdfSettings.actualCrewLaborSum) headers.push(this.$t('indicator.crew.crewLabor') + "\r\n" + this.$t('roster.comp.actualBubble'));
          if (pdfSettings.plannedCrewLaborSum) headers.push(this.$t('indicator.crew.crewLabor') + "\r\n" + this.$t('indicator.vlh.targetBubbleCaps'));
          if (pdfSettings.plannedCrewLaborPercentage) headers.push(this.$t('indicator.eval.crewLaborShort') + "%" + "\r\n" + this.$t('indicator.vlh.targetBubbleCaps'));
          if (pdfSettings.actualCrewLaborPercentage) headers.push(this.$t('indicator.eval.crewLaborShort') + "%" + "\r\n" + this.$t('roster.comp.actualBubble'));
          
          

          let filename = "";
          if(reportType == 1){
            filename+=this.$t('indicator.eval.yearS')
          } else if(reportType == 2){
            filename+=this.$t('indicator.eval.weekS')
          } else if(reportType == 3){
            filename+=this.$tc('global.ui.hours', 2)
          } else {
            filename+=this.$t('indicator.eval.dayS')
          }
          filename+= '_' + this.$t('indicator.main.evaluation') + '_' + this.storeSettings.name + '_' + date.format("DD_MM_YYYY_HH_mm") +  (pdfSettings.csv ? '.csv' :'.pdf');

          
          let body = [];
          let title = '';
          if(reportType == 1){
            if(pdfSettings.employeeName){
                title = this.rosterFromTo.year
            } else {
                title = pdfSettings.yearFrom.format('YYYY')+" - "+pdfSettings.yearTo.format('YYYY')
            }
           
          } else if(reportType == 2){
            title = "KW "+pdfSettings.week.from.isoWeek()+" "+pdfSettings.week.from.format('DD.MM.YYYY')+" - "+pdfSettings.week.to.format('DD.MM.YYYY')
          } else if(reportType == 3){
            title = pdfSettings.dayFrom.format('DD.MM.YYYY')+" - "+pdfSettings.dayTo.format('DD.MM.YYYY')
          } else {
            title = pdfSettings.dayFrom.format('DD.MM.YYYY')+" - "+pdfSettings.dayTo.format('DD.MM.YYYY')
            
          }
          

          let repDoc = this.$helpers.tableReportDoc(
              headers,
              this.$t('indicator.main.evaluation') + ' ' + title,
              this.storeSettings.name,
              this.storeSettings.description,
              this.userFullname,
              9);
          let doc = repDoc.doc;
          let contentOffsetY = repDoc.contentOffsetY;
          doc.setFontSize(12);

          
          let sums = {
            

          }
          let computedFields = ["plannedProductivity", "actualProductivity", "plannedCrewLaborPercentage", "actualCrewLaborPercentage", "from", 
                                "plannedUnproductiveWorkTime", "actualUnproductiveWorkTime",  "totalWorkTime", 
                                "unproductiveWorkPercentage", "vacationWorkPercentage", "sickWorkPercentage", "holidayAdjustWorkPercentage",
                                "miscWorkPercentage", "nursingVacationWorkPercentage", "eduWorkPercentage", "wageContinuationWorkPercentage"];
          values.forEach(i => {

            let unproductiveWorkTime = i.sickWorkTime + i.vacationWorkTime + i.holidayAdjustWorkTime + i.miscWorkTime + i.nursingVacationWorkTime + i.eduWorkTime + i.wageContinuationWorkTime;
            let productiveWorkTime = 0;
            if(actual){
                unproductiveWorkTime += (i.actualWorkTime - i.productiveActualWorkTime);
                productiveWorkTime = i.productiveActualWorkTime;
            } else {
                unproductiveWorkTime += (i.plannedWorkTime - i.productivePlannedWorkTime);
                productiveWorkTime = i.productivePlannedWorkTime;
            }
            let totalWorkTime = unproductiveWorkTime + productiveWorkTime;
            
            
            this.addReportSum(sums, "actualCrewLaborSum", view.$helpers.calculateCLCrewLaborSum(i, config, false));
            this.addReportSum(sums, "actualWorkTimeSum", view.$helpers.calculateCLWorkTimeSum(i, config, false));

            this.addReportSum(sums, "plannedCrewLaborSum", view.$helpers.calculateCLCrewLaborSum(i, config, true));
            this.addReportSum(sums, "plannedWorkTimeSum", view.$helpers.calculateCLWorkTimeSum(i, config, true));

            this.addReportSum(sums, "totalWorkTime", totalWorkTime);
            this.addReportSum(sums, "productiveWorkTime", productiveWorkTime);
            this.addReportSum(sums, "unproductiveWorkTime", unproductiveWorkTime);
            this.addReportSum(sums, "unproductiveWorkPercentage", unproductiveWorkTime);

            this.addReportSum(sums, "vacationWorkPercentage", i.vacationWorkTime);
            this.addReportSum(sums, "sickWorkPercentage", i.sickWorkTime);
            this.addReportSum(sums, "holidayAdjustWorkPercentage", i.holidayAdjustWorkTime);
            this.addReportSum(sums, "miscWorkPercentage", i.miscWorkTime);
            this.addReportSum(sums, "nursingVacationWorkPercentage", i.nursingVacationWorkTime);
            this.addReportSum(sums, "eduWorkPercentage", i.eduWorkTime);
            this.addReportSum(sums, "wageContinuationWorkPercentage", i.wageContinuationWorkTime);
                  
            
            for(let x in i){
                if(!computedFields.includes(x)){
                    let val = i[x] != null ? i[x] : 0;
                    if(sums[x] == null){
                        sums[x] = 0;
                    }
                    sums[x] += val;
                    
                }
            }
            let cur = [];

            if (pdfSettings.date) {
                let fromTz = this.$helpers.getMomentFromStringTZ(i.from);
                if(reportType == 1){
                    cur.push(fromTz.format("MMMM YYYY"));
                } else if(reportType == 2){
                    cur.push(this.translateDayShort(fromTz.format('dd ')) + fromTz.format('DD.MM.YYYY'));
                } else if(reportType == 3){
                    cur.push(fromTz.format("DD.MM.YYYY HH:mm"));
                } else {
                    if (this.hourMode) {
                        cur.push(fromTz.format("HH:mm"));
                    } else {
                        cur.push(fromTz.format("DD.MM.YYYY"));
                    }
                }
              
            }
            

            if (pdfSettings.personnelId) cur.push(i.personnelId);
            if (pdfSettings.employeeName) cur.push(i.employeeName);
            if (pdfSettings.plannedIndicatorValue) cur.push((""+i.plannedIndicatorValue.toFixed(2)).replace(".", ","));
            if (pdfSettings.actualIndicatorValue) cur.push((""+i.actualIndicatorValue.toFixed(2)).replace(".", ","));
           
            if (pdfSettings.plannedWorkTime) cur.push((""+(i.plannedWorkTime/3600).toFixed(2)).replace(".", ","));
            if (pdfSettings.actualWorkTime) cur.push((""+(i.actualWorkTime/3600).toFixed(2)).replace(".", ","));
            if (pdfSettings.plannedWorkValue) cur.push((""+(i.plannedWorkValue/100).toFixed(2)).replace(".", ","));
            if (pdfSettings.actualWorkValue) cur.push((""+(i.actualWorkValue/100).toFixed(2)).replace(".", ","));
            
            if (pdfSettings.productivePlannedWorkTime) cur.push((""+(i.productivePlannedWorkTime/3600).toFixed(2)).replace(".", ","));
            if (pdfSettings.productiveActualWorkTime) cur.push((""+(i.productiveActualWorkTime/3600).toFixed(2)).replace(".", ","));
            if (pdfSettings.productivePlannedWorkValue) cur.push((""+(i.productivePlannedWorkValue/100).toFixed(2)).replace(".", ","));
            if (pdfSettings.productiveActualWorkValue) cur.push((""+(i.productiveActualWorkValue/100).toFixed(2)).replace(".", ","));
            
            if (pdfSettings.productivePlannedOpenWorkTime) cur.push((""+(i.productivePlannedOpenWorkTime/3600).toFixed(2)).replace(".", ","));
            if (pdfSettings.productiveActualOpenWorkTime) cur.push((""+(i.productiveActualOpenWorkTime/3600).toFixed(2)).replace(".", ","));
            if (pdfSettings.productivePlannedOpenWorkValue) cur.push((""+(i.productivePlannedOpenWorkValue/100).toFixed(2)).replace(".", ","));
            if (pdfSettings.productiveActualOpenWorkValue) cur.push((""+(i.productiveActualOpenWorkValue/100).toFixed(2)).replace(".", ","));
            
            if (pdfSettings.productivePlannedIndicatorWorkTime) cur.push((""+(i.productivePlannedIndicatorWorkTime/3600).toFixed(2)).replace(".", ","));
            if (pdfSettings.productiveActualIndicatorWorkTime) cur.push((""+(i.productiveActualIndicatorWorkTime/3600).toFixed(2)).replace(".", ","));
            if (pdfSettings.productivePlannedIndicatorWorkValue) cur.push((""+(i.productivePlannedIndicatorWorkValue/100).toFixed(2)).replace(".", ","));
            if (pdfSettings.productiveActualIndicatorWorkValue) cur.push((""+(i.productiveActualIndicatorWorkValue/100).toFixed(2)).replace(".", ","));
            
            if (pdfSettings.contractWorkTime) cur.push((""+(i.contractWorkTime/3600).toFixed(2)).replace(".", ","));
            if (pdfSettings.contractWorkValue) cur.push((""+(i.contractWorkValue/100).toFixed(2)).replace(".", ","));
            
            if (pdfSettings.plannedProductivity) cur.push((""+(view.$helpers.calculateCLWorkTimeSum(i, config, true) > 0 ? (i.plannedIndicatorValue/(view.$helpers.calculateCLWorkTimeSum(i, config, true)/3600)).toFixed(2) : "-")).replace(".", ","));
            if (pdfSettings.actualProductivity) cur.push((""+(view.$helpers.calculateCLWorkTimeSum(i, config, false) > 0 ? (i.actualIndicatorValue/(view.$helpers.calculateCLWorkTimeSum(i, config, false)/3600)).toFixed(2) : "-")).replace(".", ","));
            if (pdfSettings.plannedNightWorkShiftCount) cur.push((""+(i.plannedNightWorkShiftCount).toFixed(2)).replace(".", ","));
            if (pdfSettings.actualNightWorkShiftCount) cur.push((""+(i.actualNightWorkShiftCount).toFixed(2)).replace(".", ","));
            if (pdfSettings.plannedNightWorkShiftFlatValue) cur.push((""+(i.plannedNightWorkShiftFlatValue/100).toFixed(2)).replace(".", ","));
            if (pdfSettings.actualNightWorkShiftFlatValue) cur.push((""+(i.actualNightWorkShiftFlatValue/100).toFixed(2)).replace(".", ","));
            if (pdfSettings.plannedNightWorkTime) cur.push((""+(i.plannedNightWorkTime/3600).toFixed(2)).replace(".", ","));
            if (pdfSettings.actualNightWorkTime) cur.push((""+(i.actualNightWorkTime/3600).toFixed(2)).replace(".", ","));
            if (pdfSettings.plannedNightWorkValue) cur.push((""+(i.plannedNightWorkValue/100).toFixed(2)).replace(".", ","));
            if (pdfSettings.actualNightWorkValue) cur.push((""+(i.actualNightWorkValue/100).toFixed(2)).replace(".", ","));
            if (pdfSettings.plannedOvertimeShiftCount) cur.push((""+(i.plannedOvertimeShiftCount).toFixed(2)).replace(".", ","));
            if (pdfSettings.actualOvertimeShiftCount) cur.push((""+(i.actualOvertimeShiftCount).toFixed(2)).replace(".", ","));
            if (pdfSettings.plannedOvertimeShiftFlatValue) cur.push((""+(i.plannedOvertimeShiftFlatValue/100).toFixed(2)).replace(".", ","));
            if (pdfSettings.actualOvertimeShiftFlatValue) cur.push((""+(i.actualOvertimeShiftFlatValue/100).toFixed(2)).replace(".", ","));
            if (pdfSettings.plannedOvertime) cur.push((""+(i.plannedOvertime/3600).toFixed(2)).replace(".", ","));
            if (pdfSettings.actualOvertime) cur.push((""+(i.actualOvertime/3600).toFixed(2)).replace(".", ","));
            if (pdfSettings.plannedOvertimeValue) cur.push((""+(i.plannedOvertimeValue/100).toFixed(2)).replace(".", ","));
            if (pdfSettings.actualOvertimeValue) cur.push((""+(i.actualOvertimeValue/100).toFixed(2)).replace(".", ","));
            if (pdfSettings.plannedHolidayWorkTime) cur.push((""+(i.plannedHolidayWorkTime/3600).toFixed(2)).replace(".", ","));
            if (pdfSettings.actualHolidayWorkTime) cur.push((""+(i.actualHolidayWorkTime/3600).toFixed(2)).replace(".", ","));
            if (pdfSettings.plannedHolidayWorkValue) cur.push((""+(i.plannedHolidayWorkValue/100).toFixed(2)).replace(".", ","));
            if (pdfSettings.actualHolidayWorkValue) cur.push((""+(i.actualHolidayWorkValue/100).toFixed(2)).replace(".", ","));

            if(pdfSettings.plannedUnproductiveWorkTime) cur.push((""+(unproductiveWorkTime/3600).toFixed(2)).replace(".", ","));
            if(pdfSettings.actualUnproductiveWorkTime) cur.push((""+(unproductiveWorkTime/3600).toFixed(2)).replace(".", ","));
            if(pdfSettings.unproductiveWorkPercentage) cur.push((totalWorkTime > 0 ? ((unproductiveWorkTime/totalWorkTime)*100).toFixed(2).replace(".", ",")+' %' : "-"));
            
            if (pdfSettings.vacationWorkTime) cur.push((""+(i.vacationWorkTime/3600).toFixed(2)).replace(".", ","));
            if (pdfSettings.vacationWorkValue) cur.push((""+(i.vacationWorkValue/100).toFixed(2)).replace(".", ","));
            if (pdfSettings.vacationWorkPercentage) cur.push((totalWorkTime > 0 ? ((i.vacationWorkTime/totalWorkTime)*100).toFixed(2).replace(".", ",")+' %' : "-"));
            
            if (pdfSettings.sickWorkTime) cur.push((""+(i.sickWorkTime/3600).toFixed(2)).replace(".", ","));
            if (pdfSettings.sickWorkValue) cur.push((""+(i.sickWorkValue/100).toFixed(2)).replace(".", ","));
            if (pdfSettings.sickWorkPercentage) cur.push((totalWorkTime > 0 ? ((i.sickWorkTime/totalWorkTime)*100).toFixed(2).replace(".", ",")+' %' : "-"));

            if (pdfSettings.holidayAdjustWorkTime) cur.push((""+(i.holidayAdjustWorkTime/3600).toFixed(2)).replace(".", ","));
            if (pdfSettings.holidayAdjustWorkValue) cur.push((""+(i.holidayAdjustWorkValue/100).toFixed(2)).replace(".", ","));
            if (pdfSettings.holidayAdjustWorkPercentage) cur.push((totalWorkTime > 0 ? ((i.holidayAdjustWorkTime/totalWorkTime)*100).toFixed(2).replace(".", ",")+' %' : "-"));

            if (pdfSettings.miscWorkTime) cur.push((""+(i.miscWorkTime/3600).toFixed(2)).replace(".", ","));
            if (pdfSettings.miscWorkValue) cur.push((""+(i.miscWorkValue/100).toFixed(2)).replace(".", ","));
            if (pdfSettings.miscWorkPercentage) cur.push((totalWorkTime > 0 ? ((i.miscWorkTime/totalWorkTime)*100).toFixed(2).replace(".", ",")+' %' : "-"));

            if (pdfSettings.nursingVacationWorkTime) cur.push((""+(i.nursingVacationWorkTime/3600).toFixed(2)).replace(".", ","));
            if (pdfSettings.nursingVacationWorkValue) cur.push((""+(i.nursingVacationWorkValue/100).toFixed(2)).replace(".", ","));
            if (pdfSettings.nursingVacationWorkPercentage) cur.push((totalWorkTime > 0 ? ((i.nursingVacationWorkTime/totalWorkTime)*100).toFixed(2).replace(".", ",")+' %' : "-"));

            if (pdfSettings.eduWorkTime) cur.push((""+(i.eduWorkTime/3600).toFixed(2)).replace(".", ","));
            if (pdfSettings.eduWorkValue) cur.push((""+(i.eduWorkValue/100).toFixed(2)).replace(".", ","));
            if (pdfSettings.eduWorkPercentage) cur.push((totalWorkTime > 0 ? ((i.eduWorkTime/totalWorkTime)*100).toFixed(2).replace(".", ",")+' %' : "-"));

            if (pdfSettings.wageContinuationWorkTime) cur.push((""+(i.wageContinuationWorkTime/3600).toFixed(2)).replace(".", ","));
            if (pdfSettings.wageContinuationWorkValue) cur.push((""+(i.wageContinuationWorkValue/100).toFixed(2)).replace(".", ","));
            if (pdfSettings.wageContinuationWorkPercentage) cur.push((totalWorkTime > 0 ? ((i.wageContinuationWorkTime/totalWorkTime)*100).toFixed(2).replace(".", ",")+' %' : "-"));

            if (pdfSettings.fixedCostValue) cur.push((""+(i.fixedCostValue/100).toFixed(2)).replace(".", ","));

            if (pdfSettings.actualCrewLaborSum) cur.push((""+(view.$helpers.calculateCLCrewLaborSum(i, config, false)/100).toFixed(2)).replace(".", ","));
            if (pdfSettings.plannedCrewLaborSum) cur.push((""+(view.$helpers.calculateCLCrewLaborSum(i, config, true)/100).toFixed(2)).replace(".", ","));
            if (pdfSettings.plannedCrewLaborPercentage) {
                if(i.plannedIndicatorValue > 0){
                    cur.push(((view.$helpers.calculateCLCrewLaborSum(i, config, true)/100/i.plannedIndicatorValue)*100).toFixed(2).replace(".", ",")+' %')
                } else {
                    cur.push("-")
                }
                
            }
            if (pdfSettings.actualCrewLaborPercentage) {
                if(i.actualIndicatorValue > 0){
                    cur.push(((view.$helpers.calculateCLCrewLaborSum(i, config, false)/100/i.actualIndicatorValue)*100).toFixed(2).replace(".", ",")+' %')
                } else {
                    cur.push("-")
                }
                
            }
            if((pdfSettings.ignoreNullRows && totalWorkTime != 0) || !pdfSettings.ignoreNullRows){
                body.push(cur);
            }
            
          });

          //SUMS
          if(body.length > 0 && !pdfSettings.csv){
            let cur = [];

            if (pdfSettings.date) {
              
                cur.push(this.$t('global.ui.sum'));
              
            }
            if(pdfSettings.employeeName){
                cur.push('-')
            }
            if(pdfSettings.personnelId){
                cur.push('-')
            }
            if (pdfSettings.plannedIndicatorValue) cur.push((""+sums.plannedIndicatorValue.toFixed(2)).replace(".", ","));
            if (pdfSettings.actualIndicatorValue) cur.push((""+sums.actualIndicatorValue.toFixed(2)).replace(".", ","));
            
            if (pdfSettings.plannedWorkTime) cur.push((""+(sums.plannedWorkTime/3600).toFixed(2)).replace(".", ","));
            if (pdfSettings.actualWorkTime) cur.push((""+(sums.actualWorkTime/3600).toFixed(2)).replace(".", ","));
            if (pdfSettings.plannedWorkValue) cur.push((""+(sums.plannedWorkValue/100).toFixed(2)).replace(".", ","));
            if (pdfSettings.actualWorkValue) cur.push((""+(sums.actualWorkValue/100).toFixed(2)).replace(".", ","));


            if (pdfSettings.productivePlannedWorkTime) cur.push((""+(sums.productivePlannedWorkTime/3600).toFixed(2)).replace(".", ","));
            if (pdfSettings.productiveActualWorkTime) cur.push((""+(sums.productiveActualWorkTime/3600).toFixed(2)).replace(".", ","));
            if (pdfSettings.productivePlannedWorkValue) cur.push((""+(sums.productivePlannedWorkValue/100).toFixed(2)).replace(".", ","));
            if (pdfSettings.productiveActualWorkValue) cur.push((""+(sums.productiveActualWorkValue/100).toFixed(2)).replace(".", ","));

            if (pdfSettings.productivePlannedOpenWorkTime) cur.push((""+(sums.productivePlannedOpenWorkTime/3600).toFixed(2)).replace(".", ","));
            if (pdfSettings.productiveActualOpenWorkTime) cur.push((""+(sums.productiveActualOpenWorkTime/3600).toFixed(2)).replace(".", ","));
            if (pdfSettings.productivePlannedOpenWorkValue) cur.push((""+(sums.productivePlannedOpenWorkValue/100).toFixed(2)).replace(".", ","));
            if (pdfSettings.productiveActualOpenWorkValue) cur.push((""+(sums.productiveActualOpenWorkValue/100).toFixed(2)).replace(".", ","));

            if (pdfSettings.productivePlannedIndicatorWorkTime) cur.push((""+(sums.productivePlannedIndicatorWorkTime/3600).toFixed(2)).replace(".", ","));
            if (pdfSettings.productiveActualIndicatorWorkTime) cur.push((""+(sums.productiveActualIndicatorWorkTime/3600).toFixed(2)).replace(".", ","));
            if (pdfSettings.productivePlannedIndicatorWorkValue) cur.push((""+(sums.productivePlannedIndicatorWorkValue/100).toFixed(2)).replace(".", ","));
            if (pdfSettings.productiveActualIndicatorWorkValue) cur.push((""+(sums.productiveActualIndicatorWorkValue/100).toFixed(2)).replace(".", ","));

            if (pdfSettings.contractWorkTime) cur.push((""+(sums.contractWorkTime/3600).toFixed(2)).replace(".", ","));
            if (pdfSettings.contractWorkValue) cur.push((""+(sums.contractWorkValue/100).toFixed(2)).replace(".", ","));
            if (pdfSettings.plannedProductivity) cur.push((""+(sums.plannedWorkTimeSum > 0 ? (sums.plannedIndicatorValue/(sums.plannedWorkTimeSum/3600)).toFixed(2) : "-")).replace(".", ","));
            if (pdfSettings.actualProductivity) cur.push((""+(sums.actualWorkTimeSum > 0 ? (sums.actualIndicatorValue/(sums.actualWorkTimeSum/3600)).toFixed(2) : "-")).replace(".", ","));
            if (pdfSettings.plannedNightWorkShiftCount) cur.push((""+(sums.plannedNightWorkShiftCount).toFixed(2)).replace(".", ","));
            if (pdfSettings.actualNightWorkShiftCount) cur.push((""+(sums.actualNightWorkShiftCount).toFixed(2)).replace(".", ","));
            if (pdfSettings.plannedNightWorkShiftFlatValue) cur.push((""+(sums.plannedNightWorkShiftFlatValue/100).toFixed(2)).replace(".", ","));
            if (pdfSettings.actualNightWorkShiftFlatValue) cur.push((""+(sums.actualNightWorkShiftFlatValue/100).toFixed(2)).replace(".", ","));
            if (pdfSettings.plannedNightWorkTime) cur.push((""+(sums.plannedNightWorkTime/3600).toFixed(2)).replace(".", ","));
            if (pdfSettings.actualNightWorkTime) cur.push((""+(sums.actualNightWorkTime/3600).toFixed(2)).replace(".", ","));
            if (pdfSettings.plannedNightWorkValue) cur.push((""+(sums.plannedNightWorkValue/100).toFixed(2)).replace(".", ","));
            if (pdfSettings.actualNightWorkValue) cur.push((""+(sums.actualNightWorkValue/100).toFixed(2)).replace(".", ","));
            if (pdfSettings.plannedOvertimeShiftCount) cur.push((""+(sums.plannedOvertimeShiftCount).toFixed(2)).replace(".", ","));
            if (pdfSettings.actualOvertimeShiftCount) cur.push((""+(sums.actualOvertimeShiftCount).toFixed(2)).replace(".", ","));
            if (pdfSettings.plannedOvertimeShiftFlatValue) cur.push((""+(sums.plannedOvertimeShiftFlatValue/100).toFixed(2)).replace(".", ","));
            if (pdfSettings.actualOvertimeShiftFlatValue) cur.push((""+(sums.actualOvertimeShiftFlatValue/100).toFixed(2)).replace(".", ","));
            if (pdfSettings.plannedOvertime) cur.push((""+(sums.plannedOvertime/3600).toFixed(2)).replace(".", ","));
            if (pdfSettings.actualOvertime) cur.push((""+(sums.actualOvertime/3600).toFixed(2)).replace(".", ","));
            if (pdfSettings.plannedOvertimeValue) cur.push((""+(sums.plannedOvertimeValue/100).toFixed(2)).replace(".", ","));
            if (pdfSettings.actualOvertimeValue) cur.push((""+(sums.actualOvertimeValue/100).toFixed(2)).replace(".", ","));
            if (pdfSettings.plannedHolidayWorkTime) cur.push((""+(sums.plannedHolidayWorkTime/3600).toFixed(2)).replace(".", ","));
            if (pdfSettings.actualHolidayWorkTime) cur.push((""+(sums.actualHolidayWorkTime/3600).toFixed(2)).replace(".", ","));
            if (pdfSettings.plannedHolidayWorkValue) cur.push((""+(sums.plannedHolidayWorkValue/100).toFixed(2)).replace(".", ","));
            if (pdfSettings.actualHolidayWorkValue) cur.push((""+(sums.actualHolidayWorkValue/100).toFixed(2)).replace(".", ","));

            if(pdfSettings.plannedUnproductiveWorkTime) cur.push((""+(sums.unproductiveWorkTime/3600).toFixed(2)).replace(".", ","));
            if(pdfSettings.actualUnproductiveWorkTime) cur.push((""+(sums.unproductiveWorkTime/3600).toFixed(2)).replace(".", ","));
            if(pdfSettings.unproductiveWorkPercentage) cur.push((sums.totalWorkTime > 0 ? ((sums.unproductiveWorkTime/sums.totalWorkTime)*100).toFixed(2).replace(".", ",")+' %' : "-"));
            
            if (pdfSettings.vacationWorkTime) cur.push((""+(sums.vacationWorkTime/3600).toFixed(2)).replace(".", ","));
            if (pdfSettings.vacationWorkValue) cur.push((""+(sums.vacationWorkValue/100).toFixed(2)).replace(".", ","));
            if (pdfSettings.vacationWorkPercentage) cur.push((sums.totalWorkTime > 0 ? ((sums.vacationWorkTime/sums.totalWorkTime)*100).toFixed(2).replace(".", ",")+' %' : "-"));

            if (pdfSettings.sickWorkTime) cur.push((""+(sums.sickWorkTime/3600).toFixed(2)).replace(".", ","));
            if (pdfSettings.sickWorkValue) cur.push((""+(sums.sickWorkValue/100).toFixed(2)).replace(".", ","));
            if (pdfSettings.sickWorkPercentage) cur.push((sums.totalWorkTime > 0 ? ((sums.sickWorkTime/sums.totalWorkTime)*100).toFixed(2).replace(".", ",")+' %' : "-"));

            if (pdfSettings.holidayAdjustWorkTime) cur.push((""+(sums.holidayAdjustWorkTime/3600).toFixed(2)).replace(".", ","));
            if (pdfSettings.holidayAdjustWorkValue) cur.push((""+(sums.holidayAdjustWorkValue/100).toFixed(2)).replace(".", ","));
            if (pdfSettings.holidayAdjustWorkPercentage) cur.push((sums.totalWorkTime > 0 ? ((sums.holidayAdjustWorkTime/sums.totalWorkTime)*100).toFixed(2).replace(".", ",")+' %' : "-"));

            if (pdfSettings.miscWorkTime) cur.push((""+(sums.miscWorkTime/3600).toFixed(2)).replace(".", ","));
            if (pdfSettings.miscWorkValue) cur.push((""+(sums.miscWorkValue/100).toFixed(2)).replace(".", ","));
            if (pdfSettings.miscWorkPercentage) cur.push((sums.totalWorkTime > 0 ? ((sums.miscWorkTime/sums.totalWorkTime)*100).toFixed(2).replace(".", ",")+' %' : "-"));

            if (pdfSettings.nursingVacationWorkTime) cur.push((""+(sums.nursingVacationWorkTime/3600).toFixed(2)).replace(".", ","));
            if (pdfSettings.nursingVacationWorkValue) cur.push((""+(sums.nursingVacationWorkValue/100).toFixed(2)).replace(".", ","));
            if (pdfSettings.nursingVacationWorkPercentage) cur.push((sums.totalWorkTime > 0 ? ((sums.nursingVacationWorkTime/sums.totalWorkTime)*100).toFixed(2).replace(".", ",")+' %' : "-"));

            if (pdfSettings.eduWorkTime) cur.push((""+(sums.eduWorkTime/3600).toFixed(2)).replace(".", ","));
            if (pdfSettings.eduWorkValue) cur.push((""+(sums.eduWorkValue/100).toFixed(2)).replace(".", ","));
            if (pdfSettings.eduWorkPercentage) cur.push((sums.totalWorkTime > 0 ? ((sums.eduWorkTime/sums.totalWorkTime)*100).toFixed(2).replace(".", ",")+' %' : "-"));

            if (pdfSettings.wageContinuationWorkTime) cur.push((""+(sums.wageContinuationWorkTime/3600).toFixed(2)).replace(".", ","));
            if (pdfSettings.wageContinuationWorkValue) cur.push((""+(sums.wageContinuationWorkValue/100).toFixed(2)).replace(".", ","));
            if (pdfSettings.wageContinuationWorkPercentage) cur.push((sums.totalWorkTime > 0 ? ((sums.wageContinuationWorkTime/sums.totalWorkTime)*100).toFixed(2).replace(".", ",")+' %' : "-"));
            
            if (pdfSettings.fixedCostValue) cur.push((""+(sums.fixedCostValue/100).toFixed(2)).replace(".", ","));

            if (pdfSettings.actualCrewLaborSum) cur.push((""+(sums.actualCrewLaborSum/100).toFixed(2)).replace(".", ","));
            if (pdfSettings.plannedCrewLaborSum) cur.push((""+(sums.plannedCrewLaborSum/100).toFixed(2)).replace(".", ","));

            if (pdfSettings.plannedCrewLaborPercentage) {
                if(sums.plannedIndicatorValue > 0){
                    cur.push(((sums.plannedCrewLaborSum/100/sums.plannedIndicatorValue)*100).toFixed(2).replace(".", ",")+' %')
                } else {
                    cur.push("-")
                }
                
            }
            if (pdfSettings.actualCrewLaborPercentage) {
                if(sums.actualIndicatorValue > 0){
                    cur.push(((sums.actualCrewLaborSum/100/sums.actualIndicatorValue)*100).toFixed(2).replace(".", ",")+' %')
                } else {
                    cur.push("-")
                }
                
            }

            body.push(cur);
            
            

          }



          doc.setProperties({
            title: this.$t('indicator.eval.reportEvaluation')
          });

          doc.autoTable({
            startY: contentOffsetY,
            head: [headers],
            body: body,
            headStyles: {
              fillColor: [109,141,33],
              fontSize: 7,
            },
            bodyStyles: {
              fontSize: 7
            },
            columnStyles: {
            },
            horizontalPageBreak: headers.length > 15,
            horizontalPageBreakRepeat: 0,
          });

          if(body.length > 0 && !pdfSettings.csv) {
            let finalY = doc.lastAutoTable.finalY || 10
            let pageSize = doc.internal.pageSize
            let pageHeight = pageSize.height ? pageSize.height : pageSize.getHeight()
            
            let offset = finalY + (pageHeight - (finalY % pageHeight)) 

            let headerTitle = '';
            if(reportType == 1){
                this.rosterFromTo.year
                headerTitle = this.$t('indicator.eval.reportEvaluation') + ", "+this.rosterFromTo.year+"\n"+this.storeSettings.description;
            } else if(reportType == 2){
                headerTitle = this.$t('indicator.eval.reportEvaluation') + ", KW "+pdfSettings.week.from.isoWeek()+" "+this.rosterFromTo.year+"\n"+this.storeSettings.description;
                
            } else {
                headerTitle = this.$t('indicator.eval.reportEvaluation') + ", "+this.dateSelectionStart.format('MMM YYYY')+"\n"+this.storeSettings.description;
            }
            let headers = [headerTitle, this.$t('global.ui.sum')];
            let body = [];
            if (pdfSettings.plannedIndicatorValue){
                let cur = [this.$t('roster.view.keyFigure') + this.$t('indicator.vlh.targetBubbleCaps')];
                cur.push((""+sums.plannedIndicatorValue.toFixed(2)).replace(".", ","));
                body.push(cur);
            } 
            if (pdfSettings.actualIndicatorValue){
                let cur = [this.$t('roster.view.keyFigure') + this.$t('roster.comp.actualBubble')];
                cur.push((""+sums.actualIndicatorValue.toFixed(2)).replace(".", ","));
                body.push(cur);
            } 
            if (pdfSettings.plannedWorkTime){
                let cur = [this.$t('shift.template.workTime') + this.$t('indicator.vlh.targetBubbleCaps')];
                cur.push((""+(sums.plannedWorkTime/3600).toFixed(2)).replace(".", ","));
                body.push(cur);
            } 
            if (pdfSettings.actualWorkTime){
                let cur = [this.$t('shift.template.workTime') + this.$t('roster.comp.actualBubble')];
                cur.push((""+(sums.actualWorkTime/3600).toFixed(2)).replace(".", ","));
                body.push(cur);
            } 
            if (pdfSettings.plannedWorkValue){
                let cur = [this.$t('indicator.eval.workTimeCosts') + this.$t('indicator.vlh.targetBubbleCaps')];
                cur.push((""+(sums.plannedWorkValue/100).toFixed(2)).replace(".", ","));
                body.push(cur);
            } 
            if (pdfSettings.actualWorkValue){
                let cur = [this.$t('indicator.eval.workTimeCosts') + this.$t('roster.comp.actualBubble')];
                cur.push((""+(sums.actualWorkValue/100).toFixed(2)).replace(".", ","));
                body.push(cur);
            } 
            if (pdfSettings.productivePlannedWorkTime){
                let cur = [this.$t('workBalance.payroll.productiveWorkTime') + this.$t('indicator.vlh.targetBubbleCaps')];
                cur.push((""+(sums.productivePlannedWorkTime/3600).toFixed(2)).replace(".", ","));
                body.push(cur);
            } 
            if (pdfSettings.productiveActualWorkTime){
                let cur = [this.$t('workBalance.payroll.productiveWorkTime') + this.$t('roster.comp.actualBubble')];
                cur.push((""+(sums.productiveActualWorkTime/3600).toFixed(2)).replace(".", ","));
                body.push(cur);
            } 
            if (pdfSettings.productivePlannedWorkValue){
                let cur = [this.$t('indicator.eval.productiveWorkTimeCosts') + this.$t('indicator.vlh.targetBubbleCaps')];
                cur.push((""+(sums.productivePlannedWorkValue/100).toFixed(2)).replace(".", ","));
                body.push(cur);
            } 
            if (pdfSettings.productiveActualWorkValue){
                let cur = [this.$t('indicator.eval.productiveWorkTimeCosts') + this.$t('roster.comp.actualBubble')];
                cur.push((""+(sums.productiveActualWorkValue/100).toFixed(2)).replace(".", ","));
                body.push(cur);
            }
            if (pdfSettings.productivePlannedOpenWorkTime){
                let cur = [this.$t('indicator.eval.openProductiveWorkTime') + this.$t('indicator.vlh.targetBubbleCaps')];
                cur.push((""+(sums.productivePlannedOpenWorkTime/3600).toFixed(2)).replace(".", ","));
                body.push(cur);
            } 
            if (pdfSettings.productiveActualOpenWorkTime){
                let cur = [this.$t('indicator.eval.openProductiveWorkTime') + this.$t('roster.comp.actualBubble')];
                cur.push((""+(sums.productiveActualOpenWorkTime/3600).toFixed(2)).replace(".", ","));
                body.push(cur);
            }   
            if (pdfSettings.productivePlannedOpenWorkValue){
                let cur = [this.$t('indicator.eval.openProductiveWorkTimeCost') + this.$t('indicator.vlh.targetBubbleCaps')];
                cur.push((""+(sums.productivePlannedOpenWorkValue/100).toFixed(2)).replace(".", ","));
                body.push(cur);
            } 
            if (pdfSettings.productiveActualOpenWorkValue){
                let cur = [this.$t('indicator.eval.openProductiveWorkTimeCost') + this.$t('roster.comp.actualBubble')];
                cur.push((""+(sums.productiveActualOpenWorkValue/100).toFixed(2)).replace(".", ","));
                body.push(cur); 
            } 
            if (pdfSettings.productivePlannedIndicatorWorkTime){
                let cur = [this.$t('indicator.eval.keyFigureProductiveWorkTime') + this.$t('indicator.vlh.targetBubbleCaps')];
                cur.push((""+(sums.productivePlannedIndicatorWorkTime/3600).toFixed(2)).replace(".", ","));
                body.push(cur);
            } 
            if (pdfSettings.productiveActualIndicatorWorkTime) {
                let cur = [this.$t('indicator.eval.keyFigureProductiveWorkTime') + this.$t('roster.comp.actualBubble')];
                cur.push((""+(sums.productiveActualIndicatorWorkTime/3600).toFixed(2)).replace(".", ","));
                body.push(cur);
            } 
            if (pdfSettings.productivePlannedIndicatorWorkValue){
                let cur = [this.$t('indicator.eval.keyFigureProductiveWorkTimeCost') + this.$t('indicator.vlh.targetBubbleCaps')];
                cur.push((""+(sums.productivePlannedIndicatorWorkValue/100).toFixed(2)).replace(".", ","));
                body.push(cur);
            } 
            if (pdfSettings.productiveActualIndicatorWorkValue){
                let cur = [this.$t('indicator.eval.keyFigureProductiveWorkTimeCost') + this.$t('roster.comp.actualBubble')];
                cur.push((""+(sums.productiveActualIndicatorWorkValue/100).toFixed(2)).replace(".", ","));
                body.push(cur);
            } 
            if (pdfSettings.contractWorkTime){
                let cur = [this.$t('indicator.eval.contractWorkTime')];
                cur.push((""+(sums.contractWorkTime/3600).toFixed(2)).replace(".", ","));
                body.push(cur);
            } 
            if (pdfSettings.contractWorkValue){
                let cur = [this.$t('indicator.eval.contractWorkTimeCost') + this.$t('indicator.eval.contractWorkTimeCostBubble')];
                cur.push((""+(sums.contractWorkValue/100).toFixed(2)).replace(".", ","));
                body.push(cur);
            } 
            if (pdfSettings.plannedProductivity){
                let cur = [this.$t('roster.view.productivity') + this.$t('indicator.vlh.targetBubbleCaps')];
                cur.push((""+(sums.plannedWorkTimeSum > 0 ? (sums.plannedIndicatorValue/(sums.plannedWorkTimeSum/3600)).toFixed(2) : "-")).replace(".", ","));
                body.push(cur);
            } 
            if (pdfSettings.actualProductivity){
                let cur = [this.$t('roster.view.productivity') + this.$t('roster.comp.actualBubble')];
                cur.push((""+(sums.actualWorkTimeSum > 0 ? (sums.actualIndicatorValue/(sums.actualWorkTimeSum/3600)).toFixed(2) : "-")).replace(".", ","));
                body.push(cur);
            } 
            if (pdfSettings.plannedNightWorkShiftCount){
                let cur = [this.$t('indicator.eval.nightWorkShiftsAmount') + this.$t('indicator.vlh.targetBubbleCaps')];
                cur.push((""+(sums.plannedNightWorkShiftCount).toFixed(2)).replace(".", ","));
                body.push(cur);
            } 
            if (pdfSettings.actualNightWorkShiftCount){
                let cur = [this.$t('indicator.eval.nightWorkShiftsAmount') + this.$t('roster.comp.actualBubble')];
                cur.push((""+(sums.actualNightWorkShiftCount).toFixed(2)).replace(".", ","));
                body.push(cur);
            } 
            if (pdfSettings.plannedNightWorkShiftFlatValue){
                let cur = [this.$t('indicator.eval.nightWorkFixedCosts') + this.$t('indicator.vlh.targetBubbleCaps')];
                cur.push((""+(sums.plannedNightWorkShiftFlatValue/100).toFixed(2)).replace(".", ","));
                body.push(cur);
            } 
            if (pdfSettings.actualNightWorkShiftFlatValue){
                let cur = [this.$t('indicator.eval.nightWorkFixedCosts') + this.$t('roster.comp.actualBubble')];
                cur.push((""+(sums.actualNightWorkShiftFlatValue/100).toFixed(2)).replace(".", ","));
                body.push(cur);
            } 
            if (pdfSettings.plannedNightWorkTime){
                let cur = [this.$t('workBalance.payroll.nightWork') + this.$t('indicator.vlh.targetBubbleCaps')];
                cur.push((""+(sums.plannedNightWorkTime/3600).toFixed(2)).replace(".", ","));
                body.push(cur);
            } 
            if (pdfSettings.actualNightWorkTime){
                let cur = [this.$t('workBalance.payroll.nightWork') + this.$t('roster.comp.actualBubble')];
                cur.push((""+(sums.actualNightWorkTime/3600).toFixed(2)).replace(".", ","));
                body.push(cur);
            } 
            if (pdfSettings.plannedNightWorkValue){
                let cur = [this.$t('indicator.eval.nightWorkCosts') + this.$t('indicator.vlh.targetBubbleCaps')];
                cur.push((""+(sums.plannedNightWorkValue/100).toFixed(2)).replace(".", ","));
                body.push(cur);

            } 
            if (pdfSettings.actualNightWorkValue) {
                let cur = [this.$t('indicator.eval.nightWorkCosts') + this.$t('roster.comp.actualBubble')];
                cur.push((""+(sums.actualNightWorkValue/100).toFixed(2)).replace(".", ","));
                body.push(cur);
            }
            if (pdfSettings.plannedOvertimeShiftCount){
                let cur = [this.$t('workBalance.payroll.overTimeShifts') + this.$t('indicator.vlh.targetBubbleCaps')];
                cur.push((""+(sums.plannedOvertimeShiftCount).toFixed(2)).replace(".", ","));
                body.push(cur);
            } 
            if (pdfSettings.actualOvertimeShiftCount){
                let cur = [this.$t('indicator.eval.overtimeShiftsAmount') + this.$t('roster.comp.actualBubble')];
                cur.push((""+(sums.actualOvertimeShiftCount).toFixed(2)).replace(".", ","));
                body.push(cur);
            } 
            if (pdfSettings.plannedOvertimeShiftFlatValue){
                let cur = [this.$t('indicator.eval.overtimeFlat') + this.$t('indicator.vlh.targetBubbleCaps')];
                cur.push((""+(sums.plannedOvertimeShiftFlatValue/100).toFixed(2)).replace(".", ","));
                body.push(cur);
            } 
            if (pdfSettings.actualOvertimeShiftFlatValue){
                let cur = [this.$t('indicator.eval.overtimeFlat') + this.$t('roster.comp.actualBubble')];
                cur.push((""+(sums.actualOvertimeShiftFlatValue/100).toFixed(2)).replace(".", ","));
                body.push(cur);
            } 
            if (pdfSettings.plannedOvertime){
                let cur = [this.$t('workBalance.payroll.overTime') + this.$t('indicator.vlh.targetBubbleCaps')];
                cur.push((""+(sums.plannedOvertime/3600).toFixed(2)).replace(".", ","));
                body.push(cur);
            } 
            if (pdfSettings.actualOvertime){
                let cur = [this.$t('workBalance.payroll.overTime') + this.$t('roster.comp.actualBubble')];
                cur.push((""+(sums.actualOvertime/3600).toFixed(2)).replace(".", ","));
                body.push(cur);
            } 
            if (pdfSettings.plannedOvertimeValue){
                let cur = [this.$t('indicator.eval.overtimeCosts') + this.$t('indicator.vlh.targetBubbleCaps')];
                cur.push((""+(sums.plannedOvertimeValue/100).toFixed(2)).replace(".", ","));
                body.push(cur);
            } 
            if (pdfSettings.actualOvertimeValue){
                let cur = [this.$t('indicator.eval.overtimeCosts') + this.$t('roster.comp.actualBubble')];
                cur.push((""+(sums.actualOvertimeValue/100).toFixed(2)).replace(".", ","));
                body.push(cur);
            } 
            if (pdfSettings.plannedHolidayWorkTime){
                let cur = [this.$t('workBalance.payroll.holidayWorkTime') + this.$t('indicator.vlh.targetBubbleCaps')];
                cur.push((""+(sums.plannedHolidayWorkTime/3600).toFixed(2)).replace(".", ","));
                body.push(cur);
            } 
            if (pdfSettings.actualHolidayWorkTime){
                let cur = [this.$t('workBalance.payroll.holidayWorkTime') + this.$t('roster.comp.actualBubble')];
                cur.push((""+(sums.actualHolidayWorkTime/3600).toFixed(2)).replace(".", ","));
                body.push(cur);
            } 
            if (pdfSettings.plannedHolidayWorkValue){
                let cur = [this.$t('indicator.eval.holidayCosts') + this.$t('indicator.vlh.targetBubbleCaps')];
                cur.push((""+(sums.plannedHolidayWorkValue/100).toFixed(2)).replace(".", ","));
                body.push(cur);
            } 
            if (pdfSettings.actualHolidayWorkValue){
                let cur = [this.$t('indicator.eval.holidayCosts') + this.$t('roster.comp.actualBubble')];
                cur.push((""+(sums.actualHolidayWorkValue/100).toFixed(2)).replace(".", ","));
                body.push(cur);
            }
            if (pdfSettings.plannedUnproductiveWorkTime){
                let cur = [this.$t('workBalance.payroll.unproductiveWorkTime') + this.$t('indicator.vlh.targetBubbleCaps')];
                cur.push((""+(sums.unproductiveWorkTime/3600).toFixed(2)).replace(".", ","));
                body.push(cur);
            }
            if (pdfSettings.actualUnproductiveWorkTime){
                let cur = [this.$t('workBalance.payroll.unproductiveWorkTime') + this.$t('roster.comp.actualBubble')];
                cur.push((""+(sums.unproductiveWorkTime/3600).toFixed(2)).replace(".", ","));
                body.push(cur);
            }
            if (pdfSettings.unproductiveWorkPercentage){
                let cur = [this.$t('workBalance.payroll.unproductiveQuota')];
                cur.push((sums.totalWorkTime > 0 ? ((sums.unproductiveWorkTime/sums.totalWorkTime)*100).toFixed(2).replace(".", ",")+' %' : "-"));
                body.push(cur);
            } 
            if (pdfSettings.vacationWorkTime){
                let cur = [this.$t('indicator.eval.vacationWorkTime')];
                cur.push((""+(sums.vacationWorkTime/3600).toFixed(2)).replace(".", ","));
                body.push(cur);
            } 
            if (pdfSettings.vacationWorkValue){
                let cur = [this.$t('indicator.eval.vacationWorkTimeCosts')];
                cur.push((""+(sums.vacationWorkValue/100).toFixed(2)).replace(".", ","));
                body.push(cur);
            }
            if (pdfSettings.vacationWorkPercentage){
                let cur = ["Urlaub Arbeitszeit Quote"];
                cur.push((sums.totalWorkTime > 0 ? ((sums.vacationWorkTime/sums.totalWorkTime)*100).toFixed(2).replace(".", ",")+' %' : "-"));
                body.push(cur);
            } 
            if (pdfSettings.sickWorkTime){
                let cur = [this.$t('indicator.eval.sickLeaveWorkTime')];
                cur.push((""+(sums.sickWorkTime/3600).toFixed(2)).replace(".", ","));
                body.push(cur);
            } 
            if (pdfSettings.sickWorkValue){
                let cur = [this.$t('indicator.eval.sickLeaveWorkTimeCosts')];
                cur.push((""+(sums.sickWorkValue/100).toFixed(2)).replace(".", ","));
                body.push(cur);
            }
            if (pdfSettings.sickWorkPercentage){
                let cur = [this.$t('indicator.eval.sickLeaveWorkTimeQuota')];
                cur.push((sums.totalWorkTime > 0 ? ((sums.sickWorkTime/sums.totalWorkTime)*100).toFixed(2).replace(".", ",")+' %' : "-"));
                body.push(cur);
            } 
            if (pdfSettings.holidayAdjustWorkTime){
                let cur = [this.$t('indicator.eval.holidayCompensationWorkTime')];
                cur.push((""+(sums.holidayAdjustWorkTime/3600).toFixed(2)).replace(".", ","));
                body.push(cur);
            } 
            if (pdfSettings.holidayAdjustWorkValue){
                let cur = [this.$t('indicator.eval.holidayCompensationCosts')];
                cur.push((""+(sums.holidayAdjustWorkValue/100).toFixed(2)).replace(".", ","));
                body.push(cur);
            }
            if (pdfSettings.holidayAdjustWorkPercentage){
                let cur = [this.$t('indicator.eval.holidayCompensationQuota')];
                cur.push((sums.totalWorkTime > 0 ? ((sums.holidayAdjustWorkTime/sums.totalWorkTime)*100).toFixed(2).replace(".", ",")+' %' : "-"));
                body.push(cur);
            } 
            if (pdfSettings.miscWorkTime){
                let cur = [this.$t('indicator.eval.otherAbsencesWorkTime')];
                cur.push((""+(sums.miscWorkTime/3600).toFixed(2)).replace(".", ","));
                body.push(cur);
            } 
            if (pdfSettings.miscWorkValue){
                let cur = [this.$t('indicator.eval.otherAbsencesWorkTimeCosts')];
                cur.push((""+(sums.miscWorkValue/100).toFixed(2)).replace(".", ","));
                body.push(cur);
            }
            if (pdfSettings.miscWorkPercentage){
                let cur = [this.$t('indicator.eval.otherAbsencesQuota')];
                cur.push((sums.totalWorkTime > 0 ? ((sums.miscWorkTime/sums.totalWorkTime)*100).toFixed(2).replace(".", ",")+' %' : "-"));
                body.push(cur);
            } 
            if (pdfSettings.nursingVacationWorkTime){
                let cur = [this.$t('indicator.eval.nursingLeaveWorkTime')];
                cur.push((""+(sums.nursingVacationWorkTime/3600).toFixed(2)).replace(".", ","));
                body.push(cur);
            } 
            if (pdfSettings.nursingVacationWorkValue){
                let cur = [this.$t('indicator.eval.nursingLeaveWorkTimeCosts')];
                cur.push((""+(sums.nursingVacationWorkValue/100).toFixed(2)).replace(".", ","));
                body.push(cur);
            }
            if (pdfSettings.nursingVacationWorkPercentage){
                let cur = [this.$t('workBalance.payroll.nursingLeaveQuota')];
                cur.push((sums.totalWorkTime > 0 ? ((sums.nursingVacationWorkTime/sums.totalWorkTime)*100).toFixed(2).replace(".", ",")+' %' : "-"));
                body.push(cur);
            } 
            if (pdfSettings.eduWorkTime){
                let cur = [this.$t('indicator.eval.traineeWorkTime')];
                cur.push((""+(sums.eduWorkTime/3600).toFixed(2)).replace(".", ","));
                body.push(cur);
            } 
            if (pdfSettings.eduWorkValue){
                let cur = [this.$t('indicator.eval.traineeWorkTimeCosts')];
                cur.push((""+(sums.eduWorkValue/100).toFixed(2)).replace(".", ","));
                body.push(cur);
            }
            if (pdfSettings.eduWorkPercentage){
                let cur = [this.$t('workBalance.payroll.traineeQuota')];
                cur.push((sums.totalWorkTime > 0 ? ((sums.eduWorkTime/sums.totalWorkTime)*100).toFixed(2).replace(".", ",")+' %' : "-"));
                body.push(cur);
            } 
            if (pdfSettings.wageContinuationWorkTime){
                let cur = [this.$t('indicator.eval.payContinuationWorkTime')];
                cur.push((""+(sums.wageContinuationWorkTime/3600).toFixed(2)).replace(".", ","));
                body.push(cur);
            } 
            if (pdfSettings.wageContinuationWorkValue){
                let cur = [this.$t('indicator.eval.payContinuationCosts')];
                cur.push((""+(sums.wageContinuationWorkValue/100).toFixed(2)).replace(".", ","));
                body.push(cur);
            }
            if (pdfSettings.wageContinuationWorkPercentage){
                let cur = [this.$t('workBalance.payroll.sickPayQuota')];
                cur.push((sums.totalWorkTime > 0 ? ((sums.wageContinuationWorkTime/sums.totalWorkTime)*100).toFixed(2).replace(".", ",")+' %' : "-"));
                body.push(cur);
            } 
            if (pdfSettings.actualCrewLaborSum){
                let cur = [this.$t('indicator.crew.crewLabor') + this.$t('roster.comp.actualBubble')];
                cur.push((""+(sums.actualCrewLaborSum/100).toFixed(2)).replace(".", ","));
                body.push(cur);
            } 
            if (pdfSettings.plannedCrewLaborSum){
                let cur = [this.$t('indicator.crew.crewLabor') + this.$t('indicator.vlh.targetBubbleCaps')];
                cur.push((""+(sums.plannedCrewLaborSum/100).toFixed(2)).replace(".", ","));
                body.push(cur);
            } 
            if (pdfSettings.plannedCrewLaborPercentage) {
                let cur = [this.$t('indicator.eval.crewLaborShort') + "%" + this.$t('indicator.vlh.targetBubbleCaps')];
                if(sums.plannedIndicatorValue > 0){
                    cur.push(((sums.plannedCrewLaborSum/100/sums.plannedIndicatorValue)*100).toFixed(2).replace(".", ",")+' %')
                } else {
                    cur.push("-")
                }
                body.push(cur);
            }
            if (pdfSettings.actualCrewLaborPercentage) {
                let cur = [this.$t('indicator.eval.crewLaborShort') + "%" + this.$t('roster.comp.actualBubble')];
                if(sums.actualIndicatorValue > 0){
                    cur.push(((sums.actualCrewLaborSum/100/sums.actualIndicatorValue)*100).toFixed(2).replace(".", ",")+' %')
                } else {
                    cur.push("-")
                }
                body.push(cur);
            }
            doc.autoTable({
                startY:  offset + 20,
                head: [headers],
                body: body,
                headStyles: {
                fillColor: [109,141,33],
                fontSize: 7,
                },
                bodyStyles: {
                fontSize: 7
                },
                columnStyles: {
                },
                horizontalPageBreak: headers.length > 15,
                horizontalPageBreakRepeat: 0,
            });
          }
            if(pdfSettings.csv){
                let csvPre = "data:text/csv;charset=utf-8,";
                let csv = "";
                headers = headers.map(cur => {
                    return cur.replace("\r\n", " ");
                })
                csv += headers.join(";");
                csv += "\n";
                body.forEach(cur => {
                    csv += cur.join(";");
                    csv += "\n";
                })

                let encodedUri = encodeURI(csvPre) + "\uFEFF" +  encodeURIComponent(csv);
                
                var link = document.createElement("a");
                link.setAttribute("href", encodedUri);
                link.setAttribute("download", filename);
                document.body.appendChild(link); // Required for FF

                link.click();
                
            } else {
                view.$helpers.previewPdf(doc, filename);
            }
           
        }

    }

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .tablecontainer{
        padding-left: 30px;
        padding-right: 30px;
    }
 
    .has-header > .has-header > .scrollbar-container{
        height: calc(100% - var(--header-height) - var(--tab-menu-height)) !important;
        top: var(--header-height);
    }
    .header.top{
        margin: 10px 0;
    }
    .data-table{
        top: 10px;
        position: relative;
    }

    .header.date{
        display: inline-flex;
        justify-items: center;
        align-items: center;
        position: absolute;
        left: 20px;
    }

    .header.date .label{
        color: var(--contrast-4);
        font-family: DistrictProLight;
        font-weight: 200;
        margin-top: -3px;
    }

    .header.date .label.bold{
        font-family: DistrictProBold;
        font-weight: 800;
        margin-right: 5px;
        margin-top: -3px;
    }

    .header.date .fa-calendar{
        margin: 0 10px;
        font-size: 20px;
        margin-top: -3px;
    }
    .header.date .fa-angle-left{
        margin: 0 10px;
        font-size: 25px;
        color: var(--contrast-4);
    }
    .indicator-view{
        padding: 30px;
        padding-bottom: 50px;
    }
</style>
